import {AvailableCourses} from "./AvailableCourses";

export const kedCourseStructure = [
    {
        title: "Wprowadzenie",
        episodes: [
            {
                title: "Witaj na kursie!",
                vimeoUrl: 'https://vimeo.com/1048286825',
                description: "Witaj na Kursie Efektywnego Działania!<br/><br/>" +
                    "Nagrałem ten krótki film, aby pogratulować Ci podjęcia doskonałej decyzji i osobiście " +
                    "przywitać Cię w programie. <br/>" +
                    "W tygodniu zerowym przejdziemy sobie przez sprawy organizacyjne i pokażę Ci, jak wynieść 100% z " +
                    "kursu. <br/><br/> " +
                    "Bardzo się cieszę, że tutaj jesteś i życzę Ci powodzenia w stawaniu się najlepszą wersją siebie!" +
                    "<br/> <i>-Mikołaj, Twój główny instruktor</i>"
            },
            {
                title: "Jak wygląda kurs?",
                description: "Kurs składa się z 9 tygodni. <br/> Zaczynamy od budowania świadomości, przez podstawy efektywnego działania i efektywną naukę, aż po wejście na wyższy poziom i stanie się najlepszą wersją siebie.<br/><br/>" +
                    "Pełny opis poszczególnych tygodni znajduje się <a class='text-success text-decoration-underline' href='/produkt/kurs-efektywnego-dzialania'>tutaj</a>. <br/><br/>" +
                    "Każdy kolejny tydzień zostanie odblokowany automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z poprzedniego tygodnia. <br/><br/>" +
                    "Kluczowe jest, aby wykonywać ćwiczenia oraz wprowadzać w życie zmiany. W przeciwnym razie stracisz tylko swój czas.<br/><br/>" +
                    "Informacje o pozostałym czasie do odblokowania kolejnego tygodnia znajdziesz na stronie głównej Kursu, pod kolejnym tygodniem: (Przykład) <img class='img-fluid' src='https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/auto-unlock-next-week.png' alt='odblokowanie kolejnego tygodnia'/><br/><br/>" +
                    "Jeżeli nie widzisz tej informacji, musisz najpierw rozpocząć oglądanie najnowszego tygodnia Kursu." +
                    "<br/><br/><i>\"Nic się nie zmieni, o ile Ty się nie zmienisz.\"",
            },
            {
                title: "Gdzie szukać pomocy?",
                description: "<ol>" +
                    "<li>Co tydzień odbywają się konsultacje online. Na spotkaniu odpowiadamy na pytania uczniów i pomagamy im w zrozumieniu i wdrożeniu w życie rzeczy z kursu. Więcej informacji znajdziesz po kliknięciu w link w sekcji \"Materiały\". </li>" +
                    "<br/>" +
                    "<li>Dołącz na naszego Discorda, gdzie poznasz nowe, ambitne osoby oraz uzyskasz szybką pomoc. Więcej informacji w sekcji \"Materiały\".</li>" +
                    "</ol> ",
                resources: [
                    {
                        title: "Cotygodniowe spotkania",
                        link: "/produkt/spolecznosc/spotkania"
                    },
                    {
                        title: "Discord",
                        link: "/produkt/spolecznosc"
                    }
                ]
            },
            {
                title: "Jak wynieść 100% z kursu?",
                description: "Aby wynieść z Kursu jak najwięcej, warto stosować się następujących zasad:<br/> " +
                    "<ol>" +
                    "<li class='mb-1 mt-3'>Regularnie pojawiaj się na spotkaniach online.</li>" +
                    "<li class='mb-1'>Dołącz na naszego Discorda, nawiązuj nowe znajomości i uzyskuj szybką pomoc.</li>" +
                    "<li class='mb-1'>Zawsze zachowaj otwarty umysł.</li>" +
                    "<li class='mb-1'>Po każdej lekcji zapisz swoimi słowami, czego się z niej nauczyłeś/aś i jakie zmiany zamierzasz wprowadzić w swoim życiu.</li>" +
                    "<li class='mb-1'>Nie spiesz się. Lepiej poświęcić więcej czasu na praktykę niż tylko oglądać filmy. Nie ma czegoś takiego jak za dużo praktyki :)</li>" +
                    "<li class='mb-1'>Wykonuj ćwiczenia, o których jest mowa w filmach, nawet jeżeli wydaje Ci się, że nie jest Ci to potrzebne. Zobaczysz, że podziękujesz sobie.</li>" +
                    "<li class='mb-1'>Zaplanuj czas, w którym poświęcisz swoją uwagę tylko i wyłącznie na Kurs. Średnio będziesz potrzebować ~2-3h tygodniowo, aby obejrzeć wszystkie filmy i wprowadzić w życie zmiany. </li>" +
                    "</ol><br/>" +
                    "<b class='fs-9'>Powodzenia!</b>",
                resources: [
                    {
                        title: "Cotygodniowe spotkania",
                        link: "/produkt/spolecznosc/spotkania"
                    },
                    {
                        title: "Discord",
                        link: "/produkt/spolecznosc"
                    }
                ]
            },
            {
                title: "Dodatkowe narzędzia",
                description: "Dostęp do wszystkich materiałów, o których była mowa przy dołączaniu do kursu, otrzymasz we właściwym tygodniu. <br/> " +
                    "<ul>" +
                    "<li class='mb-1 mt-3'>Dokument \"BEST Self\" - Tydzień 1</li>" +
                    "<li class='mb-1'>Dokument \"Roczny Plan Dominacji\" - Tydzień 2</li>" +
                    "<li class='mb-1'>Autorskie Techniki Oddechowe - Tydzień 2</li>" +
                    "</ul>" +
                    "Temat Sztucznej Inteligencji będzie szczegółowo omawiany w Tygodniu 7, jednak dostęp do Chatu masz już teraz. Więcej w sekcji \"Materiały\". <br/><br/>",
                resources: [
                    {
                        title: "Chat Produkacji",
                        link: "/produkt/chat"
                    },
                ]
            }
        ]
    },
    {
        title: "Budowa świadomości",
        episodes: [
            {
                title: 'Przedstawienie tygodnia',
                vimeoUrl: 'https://vimeo.com/1048286859',
                description: "W tej lekcji dowiesz się, jak wygląda pierwszy tydzień oraz czego się w nim spodziewać."
            },
            {
                title: 'Po co mi świadomość?',
                vimeoUrl: 'https://vimeo.com/1048286897',
                description: "W tej lekcji poznasz podstawy pracy ze świadomością. Zrozumiesz, czym jest, dlaczego jest istotna oraz jak wykorzystywać ją do swoich celów.<br/>" +
                    "Na świadomości będziemy bazować w całym kursie, dlatego tak kluczowe jest jej zrozumienie. <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Dlaczego świadomość jest istotna.</li>" +
                    "<li>Przykład niskiej świadomości.</li>" +
                    "<li>Jak działają najlepsi.</li>" +
                    "</ul>",
            },
            {
                title: 'Idealna wersja siebie',
                vimeoUrl: 'https://vimeo.com/1048286949',
                description: "W tej lekcji przejdziemy przez ćwiczenie polegające na stworzeniu idealnej wersji siebie. Zaczniemy od analizy sytuacji obecnej, a następnie stworzymy personę, którą chcesz się stać i do której dążysz. Na podstawie tego ćwiczenia, będziesz mógł/mogła jasno określić dalsze działania konieczne do stawania się najlepszą wersją siebie",
                attachFiles: true,
                resources: [
                    {
                        link: 'https://docs.google.com/document/d/1muaPqx4UlmK9taEOqH4Qxw8pWY-Eo317eyNV_bo-sL8/edit?usp=sharing',
                        title: 'Idealna wersja siebie (Wersja podstawowa)'
                    },
                    {
                        link: 'https://docs.google.com/document/d/1H_ogNwmD6PN27LEvW-4_itdbP339IJJ2iQI8afWsooQ/edit?usp=sharing',
                        title: 'Idealna wersja siebie (Wersja rozszerzona)'
                    }
                ]
            },
            {
                title: 'Rola naszego nastawienia',
                vimeoUrl: 'https://vimeo.com/1048286994',
                description: "W tej lekcji zrozumiesz dokładnie rolę nastawienia i dowiesz się, w jaki sposób Twój mindset kształtuje Twoje życie. <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Dlaczego nasze nastawienie jest istotne.</li>" +
                    "<li>Różnice pomiędzy \"Fixed mindset\" i \"Growth mindset\".</li>" +
                    "<li>Jak pracować z nastawieniem.</li>" +
                    "</ul>",
            },
            {
                title: 'Marginalne zyski',
                vimeoUrl: "https://vimeo.com/1048880467",
                description: "W tej lekcji skupimy się na marginalnych zyskach - małych zmianach, które nałożone na siebie, dają w długoterminowej perspektywie ogromne rezultaty. <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Przykład marginalnych zysków na podstawie historii Brytyjskich kolarzy.</li>" +
                    "<li>Czym są marginalne zyski.</li>" +
                    "<li>Dlaczego marginalne zyski są istotne.</li>" +
                    "<li>W jaki sposób mierzyć marginalne zyski.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Historia Brytyjskich kolarzy (dla zainteresowanych)",
                        link: "https://jamesclear.com/marginal-gains"
                    }
                ]
            },
            {
                title: 'Cykl Kolba',
                description: "W tej lekcji zajmiemy się dokładnym zrozumieniem Cyklu Kolba.<br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Czym jest Cykl Kolba i dlaczego jest on istotny.</li>" +
                    "<li>Jak tworzyć Cykl Kolba.</li>" +
                    "<li>Przykład Cyklu Kolba.</li>" +
                    "</ul>" +
                    "Po przerobieniu tej lekcji, <b>Twoim zadaniem będzie stworzenie przynajmniej dwóch Cyklów Kolba</b>. ",
                vimeoUrl: "https://vimeo.com/1048880606",
                attachFiles: true,
                resources: [
                    {
                        title: 'Cykl Kolba - Cheat Sheet',
                        link: 'https://docs.google.com/document/d/1bsmkEtrmOgDHhBmo5MYiRo0duydQIP9btpFDDtLJ468/edit?usp=sharing'
                    },
                    {
                        title: 'Przykład cyklu Kolba z lekcji',
                        link: 'https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/Przyk%C5%82ad+Cyklu+Kolba+z+filmu.pdf'
                    },
                    {
                        title: 'Przykłady innych cyklów Kolba (blog)',
                        link: 'https://produkacja.pl/blog/2i5Lz6X464cb7STIj8W75WMKfA7'
                    }
                ]
            },
            {
                title: 'Podsumowanie tygodnia',
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Dokument \"BEST Self\" jest przynajmniej w ukończony przynajmniej dla obecnej wersji siebie.</li>" +
                    "<li>Znasz różnice między <i>Fixed</i> i <i>Growth</i> mindset.</li>" +
                    "<li>Zdajesz sobie sprawę, w jaki sposób działać każdego dnia, aby codziennie przybliżać się do najlepszej wersji siebie.</li>" +
                    "<li>Mierzysz marginalne zyski w kontekście swojego celu. </li>" +
                    "<li>Dwa Cykle Kolba zostały w pełni ukończone.</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>",
            },
        ],
    },
    {
        title: "Podstawy Efektywnego Działania",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1051131451",
                description: "W tej lekcji dowiesz się, jak wygląda drugi tydzień oraz czego się w nim spodziewać."
            },
            {
                title: "Pokonaj prokrastynację raz na zawsze!",
                vimeoUrl: "https://vimeo.com/1050476619",
                description: "W tej lekcji zagłębimy się w temat prokrastynacji.<br/><br/>" +
                    "Omówimy sobie czym jest prokrastynacja, a następnie przejdziemy przez przykład z życia, aby dokładniej zobrazować Ci problem i przedstawić rozwiązanie. <br/><br/>" +
                    "Jeżeli borykasz się z odkładaniem rzeczy na później, zastanów się, z czego to wynika i co można zrobić, aby to zmienić. Wykonanie Cyklu Kolba może być bardzo dobrym pomysłem.",
                resources: [
                    {
                        title: "Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/tablice/W2E2+-+Pokonaj+prokrastynacje%CC%A8%C2%A0raz+na+zawsze.png"
                    }
                ]
            },
            {
                title: "Techniki anty-prokrastynacyjne",
                vimeoUrl: "https://vimeo.com/1050476698",
                description: "W tej lekcji omówimy 4 techniki, które skutecznie pomogą Ci w walce z prokrastynacją."
            },
            {
                title: "Zarządzaj czasem jak mistrz",
                vimeoUrl: "https://vimeo.com/1050476746",
                description: "W tym filmie dokładnie omówimy sobie nasz autorski dokument \"Roczny Plan Dominacji\", który od tej pory będzie Twoim dobrym przyjacielem podczas planowania. <br/><br/> Nowość: Ostatnio zintegrowaliśmy Plan Dominacji bezpośrednio z naszą platformą. <a href='/produkt/plan-dominacji' target='_blank' class='text-success text-decoration-underline'>Przetestuj już teraz</a>",
                resources: [
                    {
                        title: "Roczny Plan Dominacji 2026",
                        link: "https://docs.google.com/spreadsheets/d/1PPD1KpJW3GgoyVy_kIdVY1_tHTUziSizPXHUgZ210j4/edit?usp=sharing"
                    },
                    {
                        title: "Plan Dominacji na Produkacji",
                        link: "/produkt/plan-dominacji"
                    }
                ]
            },
            {
                title: "Określanie priorytetów",
                vimeoUrl: "https://vimeo.com/1050476795",
                description: "W tej lekcji zagłębimy się w temat określania priorytetów.<br/><br/>" +
                    "Omówimy sobie dokładnie Matrycę Eisenhowera, na podstawie której określimy zadania w kategoriach WAŻNE / PILNE oraz pokażemy, na co zwrócić uwagę podczas planowania.",
                resources: [
                    {
                        title: "Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/tablice/W2E5+-+Matryca+Eisenhowera.png"
                    }
                ]
            },
            {
                title: "Planowanie nauki",
                vimeoUrl: "https://vimeo.com/1050476846",
                description: "W tej lekcji omówimy właściwe planowanie nauki do sprawdzianów, a także pokażemy przykład skutecznego planowania. <br/><br/> Nowość: Ostatnio dodaliśmy narzędzie do planowania nauki bezpośrednio na naszą platformę. <a href='/produkt/planer-nauki' target='_blank' class='text-success text-decoration-underline'>Przetestuj już teraz</a>",
                resources: [
                    {
                        title: "Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/tablice/W2E6+-+Planowanie+nauki.png"
                    },
                    {
                        title: "Planer nauki na Produkacji",
                        link: "/produkt/planer-nauki"
                    }
                ]
            },
            {
                title: "Świadomość czasu",
                vimeoUrl: 'https://vimeo.com/1051131518',
                description: "W tej lekcji omówimy arkusz 'Świadomość czasu' oraz 'Mapa mocy' - na czym polegają i jak zastosować je w praktyce. Po wykonaniu tych ćwiczeń, odzyskasz kontrolę nad swoim czasem.",
                resources: [
                    {
                        title: "Arkusz 'Świadomość czasu'",
                        link: 'https://docs.google.com/spreadsheets/d/1GnxxyYwwpZ1-56YhCC1Ek7zLoTMs2hw99yjonX6cpsU/edit?usp=sharing'
                    },
                    {
                        title: "Arkusz 'Mapa mocy'",
                        link: "https://docs.google.com/spreadsheets/d/1OVvW0Ntq7kbMgzR9Ci7HoaYJiM4bFaEvsFmNOG4rFcg/edit?usp=sharing"
                    }
                ]
            },
            {
                title: "Radzenie sobie z gorszym nastrojem",
                description: "Raz na jakiś czas może się zdarzyć, że będziesz w gorszym humorze, mniej Ci się będzie chciało i słabo się będziesz czuć. Czasami takie dni się zdarzają.<br/><br/>" +
                    "Jednak jeżeli masz sporo do zrobienia, warto znać sposoby na działanie nawet w gorszej formie. Poniżej znajdziesz parę porad: <br/>" +
                    "<ul>" +
                    "<li class='mb-1 mt-1'>Pamiętaj, że to jest tylko chwilowe i bądź dla siebie empatyczny/a.</li>" +
                    "<li class='mb-1'>Zajmij się rzeczami łatwiejszymi / pilniejszymi, które i tak w końcu trzeba kiedyś zrobić. Dzięki temu, nie będziesz musieć poświęcać na nie czasu w inne dni, kiedy Twoja wydajność będzie na znacznie wyższym poziomie.</li>" +
                    "<li class='mb-1'>Zacznij robić coś tylko przez 5 minut - a następnie ustal, co dalej. Dzięki temu łatwiej się będzie zebrać do działania - przypomnij sobie czwartą technikę z filmu o technikach anty-prokrastynacyjnych.</li>" +
                    "<li class='mb-1'>Poświęć więcej czasu na (aktywny) odpoczynek i porządnie się wyśpij.</li>" +
                    "<li class='mb-1'>Jeżeli zdarza Ci się regularnie mieć gorszy nastrój, wykonaj Cykl Kolba, aby zdać sobie sprawę, skąd on wynika i co może być przyczyną. Możesz również prowadzić dziennik i w nim analizować swoje odczucia/emocje/myśli.<br/> Więcej o prowadzeniu dziennika w przyszłych tygodniach Kursu.</li>" +
                    "</ul>"
            },
            {
                title: "BONUS: Techniki oddechowe na redukcję stresu",
                description: "W sekcji z zasobami znajdziesz dwa nagrania technik oddechowych. <br/><br/>" +
                    "<b>Pierwsze nagranie: Oddech Pudełkowy</b><br/>" +
                    "Wdech 4s<br/>" +
                    "Zatrzymanie 4s<br/>" +
                    "Wydech 4s<br/><br/>" +
                    "Reguluje oddech oraz tętno, redukuje stres, wspiera koncentrację. <br/><br/><hr/><br/>" +
                    "<b>Drugie nagranie: Oddech Naprzemienny</b><br/>" +
                    "Zamknięcie prawej dziurki prawym kciukiem, wdech lewą.<br/>" +
                    "Zatkanie lewej palcem serdecznym wydech prawą.<br/><br/>" +
                    "Redukuje stres, uspokaja układ nerwowy, równoważy działanie półkul, poprawia koncentrację.",
                resources: [
                    {
                        title: "Oddech pudełkowy",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/techniki-oddechowe/Oddech+pude%C5%82kowy.WAV"
                    },
                    {
                        title: "Oddech naprzemienny",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/techniki-oddechowe/Oddech+naprzemienny.WAV"
                    }
                ]
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Dokument \"Plan Dominacji\" został przez Ciebie uzupełniony do Twoich potrzeb. </li>" +
                    "<li>Znasz techniki anty-prokrastynacyjne i stosujesz je na co dzień. </li>" +
                    "<li>Znasz różnice między zadaniami PILNYMI a WAŻNYMI oraz zdajesz sobie sprawę, że należy skupiać się na rzeczach WAŻNYCH. </li>" +
                    "<li>Wiesz, w jaki sposób planować sobie naukę do sprawdzianów oraz na co zwracać uwagę.</li>" +
                    "<li>Jesteś w trakcie lub już wypełniłeś/aś arkusz \"Świadomość czasu\". Kolejnym krokiem jest przeniesienie tamtych aktywności do arkusza \"Mapa mocy\".</li>" +
                    "<li>Potrafisz radzić sobie z gorszym nastrojem.</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później!<br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 3.",
            }
        ]
    },
    {
        title: "Wstęp do Efektywnej Nauki",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1053283973",
                description: "W tej lekcji dowiesz się, jak wygląda trzeci tydzień Kursu oraz czego się w nim spodziewać."
            },
            {
                title: "Postawy Efektywnej Nauki (POP)",
                vimeoUrl: 'https://vimeo.com/1052917379',
                description: "W tym filmie przedstawimy pokrótce, czym jest POP:<br/>" +
                    "<ul>" +
                    "<li><b>P</b>owtórki - Rozstaw czasowy między powtórkami.</li>" +
                    "<li><b>O</b>dzyskiwanie - Wydobywanie tego, czego się nauczyliśmy z pamięci.</li>" +
                    "<li><b>P</b>rzeplatanie - Korzystanie z różnych technik podczas każdej sesji nauki.</li>" +
                    "</ul>" +
                    "" +
                    "Trzy kolejne lekcje będą poświęcone powtórkom, odzyskiwaniu oraz przeplataniu.",
            },
            {
                title: "Powtórki",
                vimeoUrl: 'https://vimeo.com/1052917397',
                description: "W tym filmie przyjrzymy się tematowi powtórek i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym jest <i>krzywa zapominania</i> i jak z nią walczyć.</li>" +
                    "<li>Jak często należy robić powtórki.</li>" +
                    "<li>Na co zwracać uwagę podczas powtórek.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Krzywa zapominania",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/tablice/W3E3+-+Krzywa+zapominania.png"
                    }
                ]
            },
            {
                title: "Odzyskiwanie",
                description: "Odzyskiwanie polega na wydobywaniu informacji z pamięci w celu rozwiązania konkretnego problemu. (np. przypomnienie sobie, jak zastosować konkretny wzór na sprawdzianie)<br/><br/>" +
                    "Nauczenie się na sprawdzian to jedno, a odzyskiwanie informacji to drugie. <br/><br/>" +
                    "Co z tego, że spędzisz 10h przygotowując się na sprawdzian, jak później nie będziesz sobie w stanie niczego przypomnieć? 🤯<br/><br/>" +
                    "Dlatego tak ważne jest ćwiczenie odzyskiwania. Na ten moment musisz zwrócić uwagę na dwie rzeczy: <br/>" +
                    "<ol>" +
                    "<li class='mt-2'><b>Nie patrz na notatki przed i podczas robienia powtórek</b>. Zawsze daj sobie szansę na odzyskanie informacji z pamięci, nawet jak nie jesteś do końca pewny/a, czy te informacje są poprawne. " +
                    "Nawet jak wydaje Ci się, że nic nie pamiętasz, poświęć przynajmniej 5 minut na <b>próbę</b> przypomnienia sobie, czego się nauczyłeś/aś. Jeżeli wciąż niczego sobie nie przypomnisz, nic nie szkodzi. Najważniejsze jest ćwiczenie - a z czasem, jak odpowiednio 'wytrenujemy' nasz mózg, znacznie łatwiej będzie nam sobie to, czego się nauczyliśmy. <br/>" +
                    "Można myśleć o naszej pamięci jak o mięśniach - ćwicząć ją, staje się silniejsza.</li>" +
                    "<li class='mt-4'><b>Śpij przynajmniej 8-8.5h</b>, tym bardziej w noc przed sprawdzianem/egzaminem. Jest to niezbędne, aby mieć właściwą ilość fazu snu REM, w której następuje łączenie ze sobą informacji - co sprawia, że znacznie łatwiej jest nam je później odzyskać.<br/>" +
                    "Więcej o roli snu w Tygodniu 4.</li>" +
                    "</ol>" +
                    "Dodatkowo, sama umiejętność kodowania informacji pozytywnie wpłynie na zdolność odzyskiwania ich z pamięci. W kolejnej lekcji będziemy mówić o różnych technikach, które mogą Ci w tym pomóc - i będziemy do tego wracać w 7 Tygodniu Kursu, gdzie zagłębimy się w bardziej zaawansowane aspekty Efektywnej Nauki.",
            },
            {
                title: "Przeplatanie",
                vimeoUrl: "https://vimeo.com/1052917496",
                description: "W tej lekcji zajmiemy się tematem <i>przeplatania</i>.<br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Na czym polega <i>przeplatanie</i> różnych technik. </li>" +
                    "<li>Jakie techniki można stosować.</li>" +
                    "</ul>" +
                    "Przyjrzymy się również dokładnie takim technikom, jak: " +
                    "<ul>" +
                    "<li>Nauka wyimaginowanej osoby / technika Feynmana</li>" +
                    "<li>Tworzenie własnych pytań testowych</li>" +
                    "<li>Odpowiadanie na pytania testowe</li>" +
                    "<li>Zrzut pamięci, ang. <i>Brain dump</i></li>" +
                    "<li>Mapa myśli (więcej o mapach w 7 tygodniu Kursu)</li>" +
                    "<li>Fiszki (więcej i fiszkach w 5 tygodniu Kursu)</li>" +
                    "<li>Dyskusja / Nauka w grupie</li>" +
                    "<li>Dodawanie / Modyfikowanie zmiennych</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Fiszki na Produkacji",
                        link: "/produkt/fiszki"
                    }
                ]
            },
            {
                title: "Cykl Kolba w praktyce",
                vimeoUrl: "https://vimeo.com/1052917611",
                description: "W tym filmie przyjrzymy się wykorzystaniu Cyklu Kolba w praktyce, w kontekście Efektywnej Nauki. <br/><br/>" +
                    "Omówimy sobie dokładnie dwa przykłady - jeden z techniką Feynmana oraz jeden z tworzeniem pytań.",
                resources: [
                    {
                        title: "Cykl Kolba (Cheat-Sheet)",
                        link: "https://docs.google.com/document/d/1bsmkEtrmOgDHhBmo5MYiRo0duydQIP9btpFDDtLJ468/edit?usp=sharing"
                    },
                    {
                        title: "Przykład - Technika Feynmana",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/cykl-kolba/Cykl+Kolba+-+Technika+Feynmana.pdf"
                    },
                    {
                        title: "Przykład - Tworzenie pytań",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/cykl-kolba/Cykl+Kolba+-+Tworzenie+pytan%CC%81.pdf"
                    }
                ]
            },
            {
                title: "Planowanie SMART",
                vimeoUrl: "https://vimeo.com/1052917686",
                description: "W tym filmie przyjrzymy się tematowi planowania \"SMART\". <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Na czym polega planowanie \"SMART\".</li>" +
                    "<li>Przykłady celów \"SMART\" i celów nie-\"SMART\".</li>" +
                    "<li>Jak skutecznie stawiać cele \"SMART\".</li>",
                resources: [
                    {
                        title: "Cele \"SMART\" - Ściąga",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/cele-smart/Cele+SMART.pdf"
                    },
                    {
                        title: "Pytania pomocnicze do tworzenia celów \"SMART\"",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/cele-smart/Pytania+podczas+stawiania+celo%CC%81w+SMART.pdf"
                    }
                ]
            },
            {
                title: "30-dniowy Plan Działania",
                vimeoUrl: "https://vimeo.com/1052917743",
                description: "W tym omówimy sobie dokładnie, w jaki sposób możemy wykorzystać Plan Dominacji do stworzenia 30-dniowego planu działania, " +
                    "dzięki któremu upewnimy się, że wdrożymy w życie wszystko, o czym była mowa w tym tygodniu Kursu. <br/><br/>" +
                    "Jeżeli potrzebujesz sobie odświeżyć temat Planu Dominacji, był on szczegółowo omawiamy w poprzednim tygodniu Kursu, w filmie \"Zarządzaj czasem jak mistrz\"."
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Wiesz, co składa się na podstawy Efektywnej Nauki (POP).</li>" +
                    "<li>Zdajesz sobie sprawę z istoty powtórek i wiesz, jak często oraz w jaki sposób należy je wykonywać.</li>" +
                    "<li>Potrafisz przeplatać różne rodzaje technik Efektywnej Nauki.</li>" +
                    "<li>Potrafisz wykorzystywać Cykl Kolba do analizowania technik Efektywnej Nauki.</li>" +
                    "<li>Wiesz, na czym polegają cele/plany SMART.</li>" +
                    "<li>Stworzyłeś/aś 30-dniowy działania plan w swoim Planie Dominacji.</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później! <br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 4.",
            }
        ]
    },
    {
        title: "Środowisko",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1069106943",
                description: "W tej lekcji dowiesz się, jak wygląda czwarty tydzień Kursu oraz czego się w nim spodziewać."
            },
            {
                title: "Chronotypy snu",
                vimeoUrl: "https://vimeo.com/1067621057",
                description: "W tym filmie przyjrzymy się tematowi chronotypów snu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym są chronotypy snu.</li>" +
                    "<li>Wyznacznie Twojego chronotypu.</li>" +
                    "<li>Charakteryzowanie każdego z chronotypów.</li>" +
                    "</ul>" +
                    "W sekcji z materiałami znajdziesz link do testu na chronotyp snu oraz do bardziej szczegółowego opisu każdego z nich.",
                resources: [
                    {
                        title: "Test na chronotyp",
                        link: "https://produkacja.pl/chronotypy"
                    },
                    {
                        title: "Chronotyp DELFIN",
                        link: "https://docs.google.com/document/d/1mn_wWiWHqDOwST20XQyaHf7vYk8Xw4LfM1KMdHrTkKM/edit?usp=sharing",
                    },
                    {
                        title: "Chronotyp LEW",
                        link: "https://docs.google.com/document/d/1KO_UpB_KPn3IlIoMaAsNTCqgxUMdMRM4AVk0KBEZvAk/edit?usp=sharing"
                    },
                    {
                        title: "Chronotyp NIEDŹWIEDŹ",
                        link: "https://docs.google.com/document/d/1qSwgBKCW6TzPKLZLa0udIL05b8vFErQNYHGUX4sBB2M/edit?usp=sharing"
                    },
                    {
                        title: "Chronotyp WILK",
                        link: "https://docs.google.com/document/d/1_7l1ElBPG9o4yAz21ImC943YO-9kJ-DOW1XgdiPztmQ/edit?usp=sharing"
                    },
                ]
            },
            {
                title: "Sen - A po co to komu?",
                vimeoUrl: "https://vimeo.com/1067621138",
                description: "W tym filmie przyjrzymy się tematowi snu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Po co nam sen.</li>" +
                    "<li>Badania na temat snu.</li>" +
                    "<li>Wyjaśnienie faz snu - i dlaczego zarywanie nocki przed sprawdzianem to głupota.</li>" +
                    "<li>Błędne koło związane ze snem.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Fazy snu na przestrzeni nocy (materiały z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W4/W4E3+-+Fazy+snu+na+przestrzeni+nocy.png"
                    },
                    {
                        title: "Przykład błędnego koła (materiały z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W4/W4E3+-+B%C5%82e%CC%A8dne+ko%C5%82o.png"
                    }
                ]
            },
            {
                title: "Zostaw ten telefon",
                vimeoUrl: "https://vimeo.com/1067621214",
                description: "W tym filmie przyjrzymy się tematowi telefonu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego spędzanie dużej ilości czasu na telefonie Ci nie sprzyja.</li>" +
                    "<li>Jak zoptymalizować telefon, aby spędzać na nim mniej czasu.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Sposoby na optymalizację telefonu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W4/W4E4+-+Sposoby+na+optymalizacje%CC%A8+telefonu.pdf"
                    }
                ]
            },
            {
                title: "Optymalizacja komputera",
                vimeoUrl: "https://vimeo.com/1067621295",
                description: "W tym filmie omówimy sobie, w jaki sposób zoptymalizować nasz komputer do maksymalnej produktywności.<br/><br/>" +
                    "Przedstawimy ogólne zasady, zaproponujemy plan działania oraz zainstalujemy niezbędne rozszerzenia do przeglądarki.",
                resources: [
                    {
                        title: "Lista rozszerzeń",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W4/W4E5+-+Lista+rozszerzen.pdf"
                    },
                    {
                        title: "HTML New Tab - kod",
                        link: "https://pastebin.com/FQifj62c"
                    }
                ]
            },
            {
                title: "Twoje miejsce pracy",
                vimeoUrl: "https://vimeo.com/1067621337",
                description: "W tym filmie omówimy sobie, w jaki sposób stworzyć produktywne miejsce pracy oraz na co zwrócić uwagę.<br/><br/>" +
                    "Naszym celem jest upewnienie się, że pracujesz w środowisku sprzyjającym skupieniu się oraz rozwojowi.",
                resources: [
                    {
                        title: "Na co zwrócić uwagę (Cheat-sheet)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W4/W4E6+-+Na+co+zwro%CC%81cic%CC%81+uwage%CC%A8.pdf"
                    }
                ]
            },
            {
                title: "Z kim się przystajesz takim się stajesz",
                vimeoUrl: "https://vimeo.com/1067621407",
                description: "W tym filmie przyjrzymy się wpływowi swojego otoczenia i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Jak inni na Ciebie wpływają.</li>" +
                    "<li>Świadome podejście do swoich znajomych.</li>" +
                    "</ul>" +
                    "<i>\"Jesteś sumą 5 osób, z którymi spędzasz najwięcej czasu.\"</i>",
            },
            {
                title: "Koncentracja mistrza",
                description: "Umiejętność dłuższego koncentrowania się na danym zadaniu naturalnie przyjdzie z czasem, po wdrażaniu w życie proponowanych zmian. Tutaj podsumujemy sobie ogólne zasady, które już zostały lub zostaną omówione bardziej szczegółowo w Kursie.<br/><br/>" +
                    "<ol>" +
                    "<li><b>Dokładne rozplanowanie sobie, co będziemy robić (SMART)</b>. Przed zabraniem się do działania, chcesz wiedzieć, co dokładnie jest do zrobienia, tak aby od razu móc przejść do rzeczy. Idealnie, planowanie powinno odbywać się poprzedniego dnia wieczorem. </li><br/>" +
                    "<li><b>Zoptymalizowane miejsce pracy</b>. Środowisko, w którym się uczysz/pracujesz powinno być wolne od rozpraszaczy i sprzyjać rozwojowi oraz skupieniu.</li><br/>" +
                    "<li><b>Regularne wykonywanie Cyklów Kolba / pisanie w dzienniku</b>. Temat dziennika będziemy poruszać w dalszej części Kursu, jednak z Cyklem Kolba jesteś już zaznajomiony/a. Dobrze jest go wykonywać dość systematycznie i analizować swoje doświadczenia związane z utrzymywaniem koncentracji. To pozwoli Ci łatwiej znaleźć miejsca do poprawy i zaobserwować pozytywne zmiany. </li><br/>" +
                    "<li><b>Medytacja / ćwiczenia oddechowe</b>. Regularne praktyki medytacji lub ćwiczeń oddechowych pomogą w utrzymaniu skupienia przez dłuższy czas. Nawet 5 minut każdego dnia może pomóc w znaczącej poprawie koncentracji oraz w zyskaniu większej klarowności umysłu. </li><br/>" +
                    "<li><b>Właściwa ilość i jakość snu</b>. Temat snu już kilkukrotnie poruszaliśmy i wciąż będziemy do niego wracać w kolejnych tygodniach, ponieważ jest on BARDZO istotny w kontekście Efektywnego Działania. Bez właściwej ilości snu nie ma opcji, aby być w stanie pracować w skupieniu przez dłuższy czas. Zacznij priorytetyzować sen i zobaczysz, że większość Twoich problemów naturalnie się rozwiąże.  </li><br/>" +
                    "<li><b>Przerwy, limity</b>. Ucząc się przez 4h bez żadnych przerw, nawet najlepsi będą mieli trudność z utrzymaniem skupienia na najwyższym poziomie. Zaplanuj sobie przerwy od nauki, w czasie od 25 minut do 3 godzin, w zależności od tego, jak się czujesz. U większości uczniów górną granicą będzie 1.5h-2h. Eksperymentuj i patrz, co najlepiej sprawdza się w Twoim przypadku. Pamiętaj również, że lepiej jest rozłożyć pracę/naukę w czasie, niż starać się wszystko zrobić jednego dnia. O ile jednorazowo cały dzień poświecony na naukę może być naprawdę pomocny (więcej w Tygodniu 8), o tyle regularne 'przepracowywanie' się nie prowadzi do niczego dobrego.</li>" +
                    "</ol>"
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Znasz swój chronotyp snu i eksperymentujesz z różnymi porami różnych aktywności (przede wszystkim nauki/pracy).</li>" +
                    "<li>Zdajesz sobie sprawę, dlaczego sen jest istotny, priorytetyzujesz go i wyszedłeś/wyszłaś z błędnego koła (o ile w nim tkwiłeś/aś).</li>" +
                    "<li>Zoptymalizowałeś/aś swój telefon i zaczynasz spędzać na nim mniej czasu.</li>" +
                    "<li>Zoptymalizowałeś/aś swój komputer do maksymalnej produktywności. (Rozszerzenia zostały zainstalowane, powiadomienia wyłączone, nieużywane aplikacje zamknięte...)</li>" +
                    "<li>Stworzyłeś/aś produktywne miejsce pracy, wolne od jakichkolwiek rozpraszaczy, dzięki czemu jesteś w stanie dłużej utrzymać skupienie oraz szybciej zrobić to, co potrzebujesz.</li>" +
                    "<li>Wiesz, w jaki sposób pracować nad koncentracją. </li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później! <br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 5.",
            },
        ]
    },
    {
        title: "Wystrzał",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1069111411",
                description: "W tej lekcji dowiesz się, jak wygląda piąty tydzień Kursu oraz czego się w nim spodziewać."
            },
            {
                title: "O czym należy pamiętać?",
                description: "Wszystko, czego uczyliśmy się w trzecim tygodniu na temat Efektywnej Nauki nas nie opuści. <br/><br/>" +
                    "To znaczy, dalej robimy powtórki, dalej planujemy sobie naukę, dalej ćwiczymy odzyskiwanie i dalej staramy się stosować różne techniki przyswajania wiedzy.<br/><br/>" +
                    "I trzymamy się tego, dopóki nie będziemy proponować alternatyw :) <br/><br/>" +
                    "Powodzenia!"
            },
            {
                title: "Nauka na lekcji",
                vimeoUrl: "https://vimeo.com/1068558207",
                resources: [
                    {
                        title: "3-stopniowy proces (Cheat-sheet)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W5/W5E3+-+Wynoszenie+z+lekcji+100%25+(Cheat-sheet).pdf"
                    }
                ],
                description: "W tym filmie przyjrzymy się tematowi nauki na lekcji i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Na co zwrócić uwagę podczas nauki w szkole.</li>" +
                    "<li>3-stopniowy proces wynoszenia z lekcji 100%.</li>" +
                    "</ul>",
            },
            {
                title: "Techniki egzaminacyjne",
                vimeoUrl: "https://vimeo.com/1068558255",
                resources: [
                    {
                        title: "Pokonaj stres przed testem - 7 Porad (Cheat-sheet)",
                        link: "https://docs.google.com/document/d/1xacXncyKn3alT26SvB8Fah6PYh0pZ6n0TeH-xnrnW5Q/edit?usp=sharing"
                    },
                    {
                        title: "Równe tempo i sprawdzanie odpowiedzi (Notatki z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W5/W5E4+-+Technika+2.png"
                    }
                ],
                description: "W tym filmie przyjrzymy się technikom egzaminacyjnym i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>5-stopniowy proces pisania sprawdzianów/egzaminów na topowe wyniki.</li>" +
                    "<li>W jaki sposób pokonać stres przed testem. (Cheat-sheet w sekcji z materiałami)</li>" +
                    "</ul>",
            },
            {
                title: "Efektywne notatki",
                vimeoUrl: "https://vimeo.com/1068558290",
                description: "W tym filmie przyjrzymy się tematowi efektywnych notatek i omówimy sobie, na co zwracać uwagę podczas notowania.<br/><br/>" +
                    "Podsumujemy sobie to, czego już do tej pory się nauczyliśmy wraz z prostymi przykładami.<br/><br/>" +
                    "Temat notatek będziemy bardziej szczegółowo rozwijać w Tygodniu 7, gdzie zagłębimy się w mapy myśli.<br/><br/>" +
                    "Na ten moment, staraj się pisać MNIEJ tekstu, a dodawać więcej wizualnych elementów, takich jak diagramy, rysunki czy mapy myśli. <br/><br/>"
            },
            {
                title: "Fiszki",
                vimeoUrl: "https://vimeo.com/1069111444",
                description: "W tym filmie przyjrzymy się tematowi fiszek i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym są fiszki i dlaczego są one skuteczne.</li>" +
                    "<li>Kiedy fiszki sprawdzą się najlepiej.</li>" +
                    "<li>Jak skutecznie tworzyć fiszki.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Fiszki na Produkacji",
                        link: "/produkt/fiszki"
                    }
                ]
            },
            {
                title: "Przerwy",
                description: "Wiele osób zastanawia się, czy istnieje 'idealna' długość nauki oraz przerw.<br/><br/>" +
                    "Odpowiedź brzmi <b>nie</b>. Nie ma jednej właściwej odpowiedzi. <br/><br/>" +
                    "Istnieją jednak ogólne zasady, których warto się stosować, aby nauka była maksymalnie produktywna. <br/><br/>" +
                    "1. Robienie przerw między 25min a 3h. U większości uczniów górną granicą będzie 1.5h-2h. Istotne jest to, aby eksperymentować i patrzeć, co najlepiej działa w Twoim przypadku. Możesz wykorzystać do tego Cykl Kolba i przeanalizować, jak czujesz się robiąc przerwę po 30min, a jak po 1.5h? Czy jest jakaś różnica w przypadku nauki do innych przedmiotów? Wyciągaj wnioski i powtarzaj to, co działa w Twoim przypadku.<br/><br/>" +
                    "2. Podczas przerw, postaw na aktywny odpoczynek. Lepiej sprawdzi się wyjście na spacer, pomedytowanie, poczytanie książki czy pójście pobiegać, niż bezmyślne scrollowanie i gapienie się w telefon. Nasz mózg powinien mieć szansę na odpoczynek i regenerację - aby mieć siłę na kolejny blok pracy/nauki. <br/><br/>" +
                    "3. Pamiętaj o limitach. Wielu osobom trudno będzie pracować dłużej niż 3-4h na maksymalnej produktywności. Znacznie lepiej jest rozłożyć naukę w czasie, niż starać się zrobić wszystko w ostatnie 2 dni przed sprawdzianem/egzaminem.",
            },
            {
                title: "Rutyna przed nauką",
                description: "Aby nasz mózg automatycznie wchodził w stan koncentracji, świetnie sprawdzi się wykonywanie zawsze tej samej czynności przed każdą sesją nauki. <br/><br/>" +
                    "Może być to na przykład słuchanie zawsze tej samej piosenki czy robienie sobie zawsze tej samej herbaty. Możliwości jest wiele, jednak dobrze, żeby nie trwało to więcej niż 5 minut. <br/><br/>" +
                    "Dzięki temu, Twój mózg zacznie kojarzyć tę konkretną aktywność z koniecznością skupienia się. Wykształcenie takiej reakcji zajmuje kilka tygodni, jednak po tym czasie zobaczysz, że jeszcze łatwiej będzie Ci wejść w \"stan nauki\".<br/><br/>" +
                    "Ten schemat można również stosować w przypadku sprawdzianów / egzaminów. Czyli za każdym razem przed testem, wykonujemy tę samą czynność. <br/><br/>" +
                    "Eksperymentuj i patrz, jak to działa w Twoim przypadku!"
            },
            {
                title: "Kolejność nauki",
                vimeoUrl: "https://vimeo.com/1069111483",
                description: "W tym filmie przyjrzymy się tematowi fiszek i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym kolejność nauki ma znaczenie.</li>" +
                    "<li>W jakiej kolejności powinniśmy się uczyć.</li>" +
                    "</ul>",
            },
            {
                title: "Łączenie wszystkiego w całość",
                description: "W tym filmie wykorzystamy Plan Dominacji, aby podsumować zagadnienia z Tygodnia 5 i wdrożyć w życie zmiany.",
                vimeoUrl: "https://vimeo.com/1069111503"
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Wiesz, w jaki sposób uczyć się na lekcji i stosujesz to w swoim przypadku.</li>" +
                    "<li>Znasz techniki egzaminacyjne i masz stworzoną swoją <i>\"Checklistę\"</i> przed testami.</li>" +
                    "<li>Wiesz, na co zwracać uwagę podczas robienia notatek i starasz się robić je w nieliniowy sposób.</li>" +
                    "<li>Potrafisz robić efektywne fiszki i wiesz, na co zwracać uwagę.</li>" +
                    "<li>Eksperymentujesz z czasem przerw i nauki, aby zobaczyć, co najlepiej sprawdza się w Twoim przypadku.</li>" +
                    "<li>Wdrożyłeś/aś w życie swoją rutynę przed nauką - i powtarzasz ją za każdym razem przed rozpoczęciem kolejnej sesji. </li>" +
                    "<li>Wiesz, w jakiej kolejności najlepiej się uczyć. </li>" +
                    "<li>Dostosowałeś/aś swój Plan Dominacji do wprowadzenia w życie zmian z tego tygodnia. </li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później! <br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 6.",
            },
        ]
    },
    {
        title: "Optymalizacja",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                description: "W tej lekcji dowiesz się, jak wygląda szósty tydzień Kursu oraz czego się w nim spodziewać.",
                vimeoUrl: "https://vimeo.com/1072179611",
            },
            {
                title: "Rola snu",
                vimeoUrl: "https://vimeo.com/1070557661",
                description: "W tym filmie przyjrzymy się tematowi snu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego sen jest istotny (przypomnienie). O tym była już mowa w 4 Tygodniu Kursu.</li>" +
                    "<li>Sposoby na optymalizację snu i poprawienie jego jakości.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Poprawa jakości snu Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W6/W6E2+-+Poprawa+jakos%CC%81ci+snu+(Cheat-Sheet).pdf"
                    }
                ]
            },
            {
                title: "Rola jedzenia",
                vimeoUrl: "https://vimeo.com/1070557697",
                description: "W tym filmie przyjrzymy się tematowi jedzenia i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>W jaki sposób jedzenie na Ciebie wpływa.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "</ul>" +
                    "Naszym celem jest przede wszystkim zbudowanie świadomości.",
            },
            {
                title: "Rola sportu",
                vimeoUrl: "https://vimeo.com/1070557733",
                description: "W tym filmie przyjrzymy się tematowi sportu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego uprawianie sportu jest istotne.</li>" +
                    "<li>Obalanie błędnych przekonań na temat sportu.</li>" +
                    "<li>Jak wdrożyć sport do swojej rutyny.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "</ul>",
            },
            {
                title: "Rola odpoczynku",
                vimeoUrl: "https://vimeo.com/1070557759",
                description: "W tym filmie przyjrzymy się tematowi odpoczynku i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego odpoczynek jest istotny.</li>" +
                    "<li>Różnice między \"aktywnym\" a \"pasywnym\" odpoczynkiem.</li>" +
                    "<li>Jak aktywnie odpoczywać.</li>" +
                    "<li>Jak wdrożyć odpoczynek do swojej codziennej rutyny.</li>" +
                    "</ul>" +
                    "Pamiętaj, że odpoczynek to nie luksus, to <b>konieczność</b>.",
            },
            {
                title: "Radzenie sobie ze stresem",
                description: "Przygotowaliśmy dla Ciebie gotowy Cheat-Sheet do radzenia sobie ze stresem! Uzyskaj do niego dostęp klikając w link w sekcji \"Materiały\". <br/><br/>" +
                    "Opisaliśmy tam wszystko, co powinieneś/powinnaś wiedzieć na temat stresu.",
                resources: [
                    {
                        title: "Cheat-Sheet",
                        link: "https://docs.google.com/document/d/1Grmi86vPJv-hX0TB90NQXjBauDFctuaqfh30o81xTgQ/edit?usp=sharing"
                    }
                ]
            },
            {
                title: "BONUS: Medytacja prowadzona",
                description: "Uzyskaj dostęp do medytacji klikając w link w sekcji \"Materiały\".<br/><br/>" +
                    "Ta 10-minutowa praktyka wprowadza w świat uważności poprzez skupienie się na oddechu i odczuciach płynących z ciała. Podczas medytacji uczysz się obserwować swoje myśli bez angażowania się w nie, co pozwala Ci pozostać w teraźniejszości – tu i teraz.<br/><br/>" +
                    "Dlaczego warto praktykować:<br/>" +
                    "<ul>" +
                    "<li>Redukuje stres i niepokój związany z codziennymi wyzwaniami</li>" +
                    "<li>Poprawia koncentrację i wyniki w nauce</li>" +
                    "<li>Pomaga lepiej radzić sobie z emocjami</li>" +
                    "<li>Wspiera zdrowy sen</li>" +
                    "<li>Buduje samoświadomość i pewność siebie</li>" +
                    "<li>Uczy cierpliwości i spokoju w świecie pełnym bodźców</li>" +
                    "</ul>" +
                    "Ta medytacja jest idealnym sposobem na zrobienie przerwy w czasie nauki, uwolnienia się od presji szkolnej i innych stresorów. <br/><br/>" +
                    "Pamiętaj, że nawet krótka, regularna praktyka może przynieść znaczące korzyści dla Twojego dobrostanu psychicznego.<br/><br/>" +
                    "Nie musisz mieć żadnego doświadczenia w medytowaniu – po prostu znajdź ciche miejsce, usiądź wygodnie i bądź w chwili obecnej. ",
                resources: [
                    {
                        title: "Medytacja",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W6/W6E7+-+Medytacja.mp3"
                    }
                ]
            },
            {
                title: "Pomiar wydajności",
                vimeoUrl: "https://vimeo.com/1070557786",
                description: "W tym filmie omówimy sobie, czym jest narzędzie 'Pomiar Wydajności' i w jaki sposób z niego korzystać.<br/><br/>" +
                    "Pomoże on Ci w upewnieniu się, że jesteś na dobrej drodze oraz w podniesieniu swojej samoświadomości.",
                resources: [
                    {
                        title: "Pomiar wydajności - Arkusz",
                        link: "https://docs.google.com/spreadsheets/d/1gGF8CXiDct2WhUFWaqTDybKpWs8RYiUYykmocF7wsAI/edit?usp=sharing"
                    }
                ]
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Wiesz, w jaki sposób sen na Ciebie wpływa oraz zdajesz sobie sprawę, jak można go zoptymalizować.</li>" +
                    "<li>Znasz rolę jedzenia w efektywnym działaniu i podchodzisz do tego tematu bardziej świadomie.</li>" +
                    "<li>Wdrożyłeś/aś sport do swojej codziennej rutyny.</li>" +
                    "<li>Zdajesz sobie sprawę z istoty odpoczynku. Wiesz, że to nie luksus, to konieczność.</li>" +
                    "<li>Coraz lepiej potrafisz radzić sobie ze stresem i wiesz, jaki techniki wykorzystywać na co dzień.</li>" +
                    "<li>Zacząłeś/zaczęłaś korzystać z pomiaru wydajności i dajesz z siebie wszystko, aby uzupełniać go regularnie. :)</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później! <br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 7.",
            },
        ]
    },
    {
        title: "Top 1% uczniów",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1072179662",
                description: "W tej lekcji dowiesz się, jak wygląda siódmy tydzień Kursu oraz czego się w nim spodziewać.",
            },
            {
                title: "Kiedy najlepiej zapamiętujemy?",
                vimeoUrl: "https://vimeo.com/1071356418",
                description: "W tym filmie zajmiemy się tematem zapamiętywania i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Co nasz mózg najlepiej zapamiętuje.</li>" +
                    "<li>Jak wykorzystać to na naszą korzyść w kontekście efektywnej nauki.</li>" +
                    "</ul>" +
                    "Jest to wstęp do kolejnej lekcji - nauki poprzez dociekanie.",
            },
            {
                title: "Nauka poprzez dociekanie",
                vimeoUrl: "https://vimeo.com/1071356451",
                description: "W tym filmie zajmiemy się tematem zapamiętywania i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym jest \"Nauka poprzez dociekanie\".</li>" +
                    "<li>Jak stosować ją w praktyce.</li>" +
                    "</ul>" +
                    "Temat nauki poprzez dociekanie będzie kontynuowany w lekcjach na temat map myśli.",
                resources: [
                    {
                        title: "Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E3+-+Nauka+poprzez+dociekanie+-+Cheat-Sheet.pdf"
                    }
                ]
            },
            {
                title: "Mapy myśli - część I",
                vimeoUrl: "https://vimeo.com/1071356548",
                description: "W tym filmie zajmiemy się tematem map myśli i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego mapy myśli są istotne.</li>" +
                    "<li>Jak tworzyć skuteczne mapy myśli i na co zwracać uwagę.</li>" +
                    "</ul>" +
                    "Jest to lekcja bardziej teoretyczna. W kolejnym filmie będziemy wspólnie tworzyć mapę myśli od zera.",
                resources: [
                    {
                        title: "Skutecznie tworzenie mapy myśli (Na co zwracać uwagę)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E4+-+Jak+skutecznie+tworzyc%CC%81+mapy+mysli.pdf"
                    },
                    {
                        title: "Omówione przykłady",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E4+-+Omo%CC%81wione+przyk%C5%82ady.png"
                    },
                    {
                        title: "Przykład poprawionej mapy myśli do znaków",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E4+-+Przyk%C5%82ad+poprawionej+mysli+do+znakow.png"
                    }
                ]
            },
            {
                title: "Mapy myśli - część II",
                vimeoUrl: "https://vimeo.com/1071356879",
                description: "W tym filmie będziemy kontynuować temat map myśli i omówimy sobie, w jaki sposób robić mapy myśli w praktyce. Będziemy wspólnie tworzyć mapę myśli od zera z wykorzystaniem nauki poprzez dociekanie.<br/>",
                resources: [
                    {
                        title: "Mapa myśli z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E5+-+Mapa+mys%CC%81li+z+filmu.png"
                    }
                ]
            },
            {
                title: "Efektywna nauka do przedmiotów ścisłych",
                vimeoUrl: "https://vimeo.com/1071357058",
                description: "W tym filmie zajmiemy się efektywną nauką do przedmiotów ścisłych i omówimy sobie, w jaki sposób robić to skutecznie.<br/>",
                resources: [
                    {
                        title: "Przykłady z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E6+-+Przedmioty+s%CC%81cis%C5%82e+-+Przyk%C5%82ady+z+filmu.pdf"
                    },
                    {
                        title: "Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E6+-+Efektywna+nauka+do+przedmioto%CC%81w+s%CC%81cis%C5%82ych+-+Cheat-Sheet.pdf"
                    },
                    {
                        title: "Wolfram Alpha (Kalkulator Internetowy)",
                        link: "https://www.wolframalpha.com/"
                    }
                ]
            },
            {
                title: "Wykorzystanie AI do efektywnej nauki",
                vimeoUrl: "https://vimeo.com/1071357164",
                description: "W tym filmie zajmiemy się tematem AI w kontekście efektywnej nauki i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym w ogóle jest sztuczna inteligencja i jak ona działa.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "<li>W jaki sposób możemy wykorzystać AI do efektywnej nauki.</li>" +
                    "</ul>" +
                    "Jest to lekcja bardziej teoretyczna. W kolejnym filmie będziemy wspólnie tworzyć mapę myśli od zera.",
                resources: [
                    {
                        title: "Chat Produkacji",
                        link: "https://produkacja.pl/produkt/chat"
                    },
                    {
                        title: "Na co zwracać uwagę",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E7+-+Na+co+zwracac%CC%81+uwage%CC%A8.pdf"
                    },
                    {
                        title: "Jak wykorzystać AI do efektywnej nauki (Cheat-sheet)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W7/W7E7+-+Wykorzystanie+AI+do+Efektywnej+Nauki.pdf"
                    }
                ]
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Wiesz, na czym polega nauka poprzez dociekanie i stosujesz ją w swoim życiu.</li>" +
                    "<li>Uczysz się robić mapy myśli i zrobiłeś/aś już przynajmniej 3 własne.</li>" +
                    "<li>Dodajesz i modyfikujesz zmienne w zadaniach do przedmiotów ścisłych.</li>" +
                    "<li>Potrafisz wykorzystać AI do bardziej efektywnej nauki i wiesz, na co zwracać uwagę.</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później! <br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 8.",
            },
        ]
    },
    {
        title: "Boost",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1072179796",
                description: "W tej lekcji dowiesz się, jak wygląda ósmy tydzień Kursu oraz czego się w nim spodziewać.",
            },
            {
                title: "Stan flow",
                vimeoUrl: "https://vimeo.com/1072179851",
                description: "W tym filmie zajmiemy się tematem stanu flow i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym jest stan flow i dlaczego jest on istotny.</li>" +
                    "<li>Jak wchodzić w stan flow.</li>" +
                    "</ul>",
            },
            {
                title: "Miesiąc w dzień",
                vimeoUrl: "https://vimeo.com/1072179986",
                description: "W tym filmie omówimy sobie, w jaki sposób można nadrobić lub nauczyć się ogromnej ilości materiału w jeden dzień, oraz pokażemy sobie przykładowy harmonogram takiego dnia.<br/>",
                resources: [
                    {
                        title: "Na co zwrócić uwagę przed (Cheat-Sheet)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W8/W8E3+-+Na+co+zwro%CC%81cic%CC%81+uwage%CC%A8+PRZED.pdf"
                    },
                    {
                        title: "Przykładowy harmonogram",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W8/W8E3+-+Przyk%C5%82adowy+harmonogram.pdf"
                    }
                ]

            },
            {
                title: "Wygrywaj każdego dnia",
                vimeoUrl: "https://vimeo.com/1072180087",
                description: "W tym filmie zajmiemy się tematem dziennika i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego prowadzenie dziennika jest istotne.</li>" +
                    "<li>W jaki sposób prowadzić dziennik.</li>" +
                    "<li>Porównanie dziennika i Cyklu Kolba.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Afirmacje Cheat-Sheet",
                        link: "https://docs.google.com/document/d/1b4nw4a8wLAehG8wV8EcX00AbV3cqsDwZ4Gye_8fmFog/edit?usp=sharing"
                    },
                    {
                        title: "Przykładowa forma ustrukturyzowana",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W8/W8E4+-+Przyk%C5%82adowa+forma+ustrukturyzowana.pdf"
                    }
                ]
            },
            {
                title: "Skuteczna realizacja celów krok po kroku",
                vimeoUrl: "https://vimeo.com/1072180183",
                description: "W tym filmie omówimy sobie protokół skutecznej realizacji celów krok po kroku.<br/>",
                resources: [
                    {
                        title: "Protokół Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W8/W8E5+-+Protoko%CC%81%C5%82+Cheat-Sheet.pdf"
                    },
                    {
                        title: "Konsekwentne działanie Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/W8/W8E5+-+Konsekwentne+dzia%C5%82anie+Cheat-Sheet.pdf"
                    }
                ]
            },
            {
                title: "Brain dump",
                showNotes: true,
                description: "Twoim celem jest opisanie wszystkiego, czego nauczyłeś/aś się do tej pory z Kursu.<br/><br/>" +
                    "Pomyśl, że jutro masz z tego sprawdzian i chcesz powtórzyć cały materiał. <br/><br/>" +
                    "Daj z siebie wszystko, a następnie przejrzyj poprzednie tygodnie i zobacz, czy o wszystkim pamiętałeś/aś i czy wszystko jest zrozumiałe.<br/><br/>" +
                    "Możesz wykorzystać do tego miejsce na notatki powyżej.<br/><br/>" +
                    "Zobaczysz, że poświęcenie 1-2h na zebranie wszystkiego w całość pomoże Ci to jeszcze lepiej zrozumieć. <br/><br/>" +
                    "Powodzenia!"
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Przed przejściem do kolejnego tygodnia, upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Wiesz, czym jest stan flow, dlaczego jest istotny oraz w jaki sposób w niego wchodzić.</li>" +
                    "<li>Znasz koncepcję miesiąca w jeden dzień i wiesz, w jaki sposób można nadrobić/nauczyć się ogromnej ilości materiału.</li>" +
                    "<li>Wiesz, w jaki sposób korzystać z dziennika, do czego on służy, oraz starasz się wprowadzić pisanie w nim do swojej codziennej rutyny.</li>" +
                    "<li>Znasz protokół do skutecznej realizacji swoich celów i wiesz, na co zwracać uwagę i jak się za to zabrać.</li>" +
                    "<li>Wykonałeś/aś zrzut pamięci na temat całego Kursu.</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>" +
                    "P.S. Kolejny tydzień odblokuje się automatycznie po 7 dniach od rozpoczęcia oglądania pierwszego filmu z tego tygodnia. Jeżeli nie jest on jeszcze dla Ciebie dostępny, nie przejmuj się. <br/><br/>" +
                    "Pamiętaj, że <b>praktyka > teoria</b>. Poświęć więcej czasu na przećwiczenie zagadnień, które omówiliśmy sobie w tym tygodniu i podziękuj sobie później! <br/><br/>" +
                    "Informacje o czasie odblokowania kolejnego tygodnia znajdziesz na stronie głównej kursu: Przegląd Kursu -> Tydzień 9.",
            },
        ]
    },
    {
        title: "Następny poziom",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1072180326",
                description: "W tej lekcji dowiesz się, jak wygląda dziewiąty (ostatni) tydzień Kursu oraz czego się w nim spodziewać.",
            },
            {
                title: "Bądź sobą",
                vimeoUrl: "https://vimeo.com/1072180408",
                description: "W tym filmie zajmiemy się tematem spójności i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym jest spójność i dlaczego działanie w spójności (w zgodzie ze sobą) jest istotne.</li>" +
                    "<li>Przykład osób o wysokiej i o niskiej spójności.</li>" +
                    "<li>Jak osiągnąć spójność.</li>" +
                    "</ul>",
            },
            {
                title: "Przestać tryhardować",
                description: "<i>Tryhardować</i>, czyli przesadnie się starać, robić coś na siłę, nie jest najlepszym podejściem.<br/><br/>" +
                    "Weźmy pod uwagę prosty przykład: Pomyśl sobie o 3 grupach osób, które przygotowują się na sprawdzian.<br/><br/>" +
                    "Pierwsza grupa ciągle się uczy, robi mnóstwo notatek, powtórek, poświęca aż za dużo czasu na naukę, zaniedbuje sen na rzecz nauki, a później przed sprawdzianem narzeka, że kompletnie nic nie potrafi i że materiału jest mnóóóstwo!<br/><br/>" +
                    "Druga grupa w ogóle się nie uczy. Mają sprawdzian \"w dupie\" i w ogóle im nie zależy. Nie robią nic w jego kierunku i po prostu olewają temat.<br/><br/>" +
                    "Trzecia grupa podchodzi pewnie do nauki, robi to co powinna zrobić i wychodzi z założenia, że i tak im się uda. Że wszystko idzie po ich myśli. Że mimo tego, że może nie uczyli się bardzo długo, to i tak pewnie pójdzie im bardzo dobrze. <br/><br/>" +
                    "Jak myślisz, która grupa osób najlepiej napisze sprawdzian?<br/><br/>" +
                    "Na 99% będzie to <b>trzecia grupa</b>. Dlaczego? Ponieważ nie robią aż za dużo, nie pchają, nie starają się za wszelką cenę nauczyć wszystkiego, tylko potrafią podejść do tego rozsądnie. <br/><br/>" +
                    "W momencie, gdy przestajesz działać na siłę, świat zaczyna działać na Twoją korzyść. <br/><br/>" +
                    "Oczywiście, osoby z grupy pierwszej również osiągną dość dobre wyniki, natomiast czy gra jest warta świeczki? <br/><br/>" +
                    "Dużo stresu, dużo niepokoju i dużo zmarnowanej energii, podczas gdy można wejść do Trzeciej grupy, trochę odpuścić, trochę zwolnić, trochę wyluzować - i nagle wszystko zaczyna działać na Twoją korzyść. <br/><br/>" +
                    "Nie do końca w to wierzysz? <br/><br/>" +
                    "Pomyśl sobie o swojej przeszłości i o swojej obecnej klasie/grupie. Komu szło/idzie najlepiej? Komu zawsze się udaje? Kto ma najwięcej \"szczęścia\"? <br/><br/>" +
                    "Na 99% nie jest to osoba, która robi najwięcej, która przesadnie się stara i która działa na siłę. <br/><br/>" +
                    "Pomyśl sobie na ten temat i zaczniesz zauważać pewne zależności. <br/><br/>" +
                    "Powodzenia :)"
            },
            {
                title: "Twój obraz siebie",
                vimeoUrl: "https://vimeo.com/1072180539",
                description: "W tym filmie zajmiemy się tematem obrazu siebie i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Jak postrzeganie siebie wpływa na Twoją rzeczywistość.</li>" +
                    "<li>Istota samooceny i wiary w swoje możliwości.</li>" +
                    "<li>W jaki sposób skutecznie pracować nad swoją samooceną.</li>" +
                    "</ul>",
            },
            {
                title: "Rola przekonań",
                vimeoUrl: "https://vimeo.com/1072180711",
                description: "W tym filmie zajmiemy się tematem przekonań i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym są przekonania i dlaczego są istotne.</li>" +
                    "<li>Jak pracować nad swoimi przekonaniami.</li>" +
                    "<li>Jak przekonania Twoich bliskich wpływają na Ciebie.</li>" +
                    "<li>Przykład przekonań w kontekście postanowień noworocznych.</li>" +
                    "<li>Jak skutecznie zmienić swój \"stan\".</li>" +
                    "</ul>",
            },
            {
                title: "Stwórz swoją przyszłość",
                description: "Istnieje bardzo ciekawe ćwiczenie o nazwie 'Alchemy of self'. " +
                    "Wpisując tę frazę w Internet można znaleźć przykłady, na czym ono polega. <br/><br/>" +
                    "Jest ono dużo dokładniejsze od dokumentu BEST Self. Jeżeli spodobało Ci się projektowanie swojej najlepszej wersji siebie, to to ćwiczenie tym bardziej Ci się spodoba. <br/><br/>" +
                    "Jeżeli chcesz, żebyśmy nagrali film na ten temat i pokazali krok po kroku, na czym ono polega, kliknij w przycisk \"Prześlij feedback\" i daj nam o tym znać! <br/><br/>" +
                    "Nie jest ono w żaden sposób obowiązkowe, jest za to bardzo ciekawym i inspirującym dodatkiem."
            },
            {
                title: "Podsumowanie tygodnia",
                description: "Gratulacje, ostatni tydzień już za Tobą! Upewnij się, że: <br/><br/>" +
                    "<ul>" +
                    "<li>Wiesz, czym jest spójność, dlaczego jest ona istotna oraz dajesz z siebie wszystko, aby rzeczywiście żyć w spójności.</li>" +
                    "<li>Zdajesz sobie sprawę, że ciągłe parcie do przodu nie jest rozwiązaniem.</li>" +
                    "<li>Aktywnie pracujesz nad swoim obrazem siebie.</li>" +
                    "<li>Wiesz, dlaczego praca nad przekonaniami jest istotna oraz zmieniasz ograniczające przekonania na bardziej wspierające.</li>" +
                    "</ul>" +
                    "<br/>Jeżeli masz jakieś pytania, śmiało napisz na Discordzie lub weź udział w cotygodniowych spotkaniach online. <br/><br/>" +
                    "Jeżeli chcesz się z nami podzielić czymś na temat Kursu, kliknij w przycisk \"Prześlij Feedback, zgłoś błąd\" i napisz nam, co uważasz. Dziękujemy :) <br/><br/>",
            },
            {
                title: "Podsumowanie Kursu",
                vimeoUrl: "https://vimeo.com/1072180868",
                description: "Gratulacje! <br/><br/>" +
                    "Dziękuję Ci za wspólną podróż i życzę Ci powodzenia! Masz już wszystko, czego potrzebujesz, aby stać się najlepszą wersją siebie."
            },
        ]
    },
] as LearningCourseWeek[]

export const pedCourseStructure = [
    {
        title: "Podstawy Efektywnego Działania",
        episodes: [
            {
                title: "Wprowadzenie",
                vimeoUrl: "https://vimeo.com/1064599541",
                description: "W tym filmie dowiesz się jak wygląda Kurs Podstaw Efektywnego Działania i czego się w nim spodziewać."
            },
            {
                title: 'Najlepsza wersja siebie',
                vimeoUrl: 'https://vimeo.com/1064731798',
                description: "W tej lekcji przejdziemy przez ćwiczenie polegające na stworzeniu idealnej wersji siebie. Zaczniemy od analizy sytuacji obecnej, a następnie stworzymy personę, którą chcesz się stać i do której dążysz. Na podstawie tego ćwiczenia, będziesz mógł/mogła jasno określić dalsze działania konieczne do stawania się najlepszą wersją siebie.",
                resources: [
                    {
                        link: 'https://docs.google.com/document/d/1muaPqx4UlmK9taEOqH4Qxw8pWY-Eo317eyNV_bo-sL8/edit?usp=sharing',
                        title: 'Najlepsza wersja siebie (Wersja podstawowa)'
                    },
                    {
                        link: 'https://docs.google.com/document/d/1H_ogNwmD6PN27LEvW-4_itdbP339IJJ2iQI8afWsooQ/edit?usp=sharing',
                        title: 'Najlepsza wersja siebie (Wersja rozszerzona)'
                    }
                ]
            },
            {
                // Plan Dominacji w kontekście nauki [Praca na dokumencie]
                title: "Skuteczne planowanie nauki",
                vimeoUrl: "https://vimeo.com/1064599697",
                description: "W tym filmie dokładnie omówimy sobie nasz autorski dokument \"Roczny Plan Dominacji\", który od tej pory będzie Twoim dobrym przyjacielem podczas planowania. <br/><br/> Nowość: Ostatnio zintegrowaliśmy Plan Dominacji bezpośrednio z naszą platformą. <a href='/produkt/plan-dominacji' target='_blank' class='text-success text-decoration-underline'>Przetestuj już teraz</a>",
                resources: [
                    {
                        title: "Roczny Plan Dominacji 2026",
                        link: "https://docs.google.com/spreadsheets/d/1PPD1KpJW3GgoyVy_kIdVY1_tHTUziSizPXHUgZ210j4/edit?usp=sharing"
                    },
                    {
                        title: "Plan Dominacji na Produkacji",
                        link: "/produkt/plan-dominacji"
                    },
                    {
                        title: "Planer nauki na Produkacji",
                        link: "/produkt/planer-nauki"
                    }
                ]
            },
            {
                // Pokonywanie prokrastynacji na zasadzie nawyków [Praca na tablicy]
                title: "Systematyczne działanie",
                vimeoUrl: "https://vimeo.com/1064599956",
                description: "W tym filmie omówimy sobie, w jaki sposób działać systematycznie i raz na zawsze pokonać prokrastynację.",
                resources: [
                    {
                        title: "Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/ped/W0E4+-+systematyczne+dzialanie.png"
                    }
                ]
            },
            {
                // Pokazanie, na co zwrócić uwagę w kontekście biurka itp. [Praca na prezentacji]
                title: "Optymalizacja środowiska",
                vimeoUrl: "https://vimeo.com/1064600191",
                description: "W tym filmie omówimy sobie, w jaki sposób zoptymalizować swoje środowisko do maksymalnej produktywności. Usuniemy wszystkie rozpraszacze i upewnimy się, że sprzyja ono rozwojowi.",
            },
            {
                // Omówienie POP wraz z konkretnymi przykładami [Praca na prezentacji / tablicy]
                title: "Efektywna nauka",
                vimeoUrl: "https://vimeo.com/1064600305",
                description: "W tym filmie zbudujemy solidne podstawy do Efektywnej Nauki. Omówimy sobie następujące zagadnienia:" +
                    "<ul>" +
                    "<li>Czym jest POP</li>" +
                    "<li>Jak przeciwdziałać krzywej zapominania</li>" +
                    "<li>Na co zwrócić uwagę przed sprawdzianami/egzaminami</li>" +
                    "<li>Jakie techniki nauki możemy stosować</li>",
                resources: [
                    {
                        title: "Krzywa zapominania (notatki z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/ped/W0E6+-+krzywa+zapominania.png"
                    },
                    {
                        title: "Fazy snu (notatki z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/ped/W0E6+-+fazy+snu.png"
                    }
                ]
            },
            {
                // Pokazanie prezentacji -> Czyli 1. Dokument BEST Self zrobiony, 2. Optymalizacja środowiska 3. Plan Dominacji - i wykorzystanie tego, czego się nauczyliśmy.
                title: "Jasny plan działania",
                vimeoUrl: "https://vimeo.com/1064600556",
                description: "W tym filmie stworzymy jasny plan działania, abyś miał/a pewność, że potrafisz wykorzystać całą wiedzę z tego Kursu w praktyce!"
            },
            {
                // Sprzedaż głównego Kursu + Pokazanie go i omówienie, czego się nauczyć można.
                title: "Co dalej?",
                description: "<h5>Gratulacje 🏆</h5>" +
                    "Udało Ci się ukończyć cały Kurs Podstaw Efektywnego Działania.  <br/><br/>" +
                    "Jesteśmy z Ciebie bardzo dumni. To naprawdę bardzo dobrze o Tobie świadczy. <br/><br/>" +
                    "Spokojnie wprowadzaj w życie zmiany, a pozytywne rezultaty zobaczysz już po kilku dniach! <br/><br/>" +
                    "Był to pierwszy poziom Efektywnego Działania (podstawy). Jeżeli ten Kurs Ci się spodobał i przydał, jesteśmy przekonani, że pokochasz pełny Kurs Efektywnego Działania i naprawdę dużo się z niego nauczysz.<br/><br/>" +
                    "<b>Czym jest pełny Kurs Efektywnego Działania?</b><br/>" +
                    "Jest to 9-tygodniowy program wchodzący w szczegóły Efektywnego Działania oraz zagłębiający się w bardziej zaawansowane ćwiczenia i techniki. <br/><br/>" +
                    "W ramach Kursu dostajesz dostęp do ~15h filmów online, ćwiczeń oraz cheat-sheetów, a także cotygodniowe spotkania bezpośrednio z Twórcą Kursu oraz dostęp do prywatnej społeczności nastawionych na rozwój nastolatków.<br/><br/>" +
                    "Chcesz kontynuować przygodę z Efektywnym Działaniem?<br/>" +
                    "<a class='text-decoration-underline text-success' href='/produkt/zakup/kurs-efektywnego-dzialania'>Kliknij tutaj, aby uzyskać dostęp do Kursu.</a>"
            },
        ]
    }
] as LearningCourseWeek[]

// TODO: TBC
export const znCourseStructure = [
    {
        title: "Zrozumieć Nastolatka",
        episodes: [
            {
                title: "Wstęp",
                vimeoUrl: "https://vimeo.com/1099086834",
                description: "W tym filmie dowiesz się jak wygląda Kurs 'Zrozumieć Nastolatka' i czego się w nim spodziewać."
            },
            {
                title: "Zrozumieć Nastolatka",
                vimeoUrl: "https://vimeo.com/1099086843",
                description: "W tym filmie dowiesz się, co siedzi w głowie nastolatka, a także:" +
                    "<ul>" +
                    "<li>Biologiczne i hormonalne zmiany u nastolatków.</li>" +
                    "<li>Kluczowe potrzeby nastolatków.</li>" +
                    "</ul>" +
                    "W sekcji z materiałami możesz pobrać całą prezentację, aby móć wrócić do tego w dowolnym dla siebie czasie.",
                resources:
                    [
                        {
                            title: "Prezentacja",
                            link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/zn/E2+-+Zrozumiec%CC%81+nastolatka.pdf"
                        }
                    ]
            },
            {
                title: "Efektywna Komunikacja z Nastolatkiem",
                vimeoUrl: "https://vimeo.com/1099086888",
                description: "W tym filmie dowiesz się, w jaki sposób komunikować się z nastolatkiem w taki sposób, aby chciał Cię słuchać. Omówimy sobie między innymi:" +
                    "<ul>" +
                    "<li>Efektywną komunikację</li>" +
                    "<li>Regulowanie emocji</li>" +
                    "<li>Sytuacje kryzysowe, konflikty</li>" +
                    "</ul>" +
                    "W sekcji z materiałami możesz pobrać całą prezentację, aby móć wrócić do tego w dowolnym dla siebie czasie.",
                resources: [
                    {
                        title: "Prezentacja",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/zn/E3+-+Komunikacja.pdf"
                    }
                ]
            },
            {
                title: "Wspieranie Nastolatka w Edukacji",
                vimeoUrl: "https://vimeo.com/1099086931",
                description: "W tym filmie dowiesz się, w jaki sposób najlepiej wspierać swoje dziecko w edukacji. Omówimy sobie między innymi:" +
                    "<ul>" +
                    "<li>Korepetycje - czy rzeczywiście warto?</li>" +
                    "<li>Czym jest efektywne działanie?</li>" +
                    "<li>Różnice pomiędzy Fixed i Growth mindset</li>" +
                    "<li>Czy brak chęci do działania to lenistwo?</li>" +
                    "<li>Jak motywować do nauki?</li>" +
                    "</ul>" +
                    "W sekcji z materiałami możesz pobrać całą prezentację, aby móć wrócić do tego w dowolnym dla siebie czasie.",
                resources: [
                    {
                        title: "Prezentacja",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/zn/E4+-+Wsparcie+w+edukacji.pdf"
                    }
                ]
            },
            {
                title: "Zakończenie",
                vimeoUrl:
                    "https://vimeo.com/1099086951",
            },
        ]
    }
] as LearningCourseWeek[]

export const kedV2CourseStructure = [
    {
        title: "Organizacja",
        episodes: [
            {
                title: "Przywitanie",
                vimeoUrl: "https://vimeo.com/1141415569",
                description: "Witaj w Kursie Efektywnego Działania 2.0!<br/><br/>" +
                    "W tym filmie przedstawię Ci, czego się spodziewać po Kursie. Dowiesz się, czego się nauczysz i jakie rezultaty możesz osiągnąć. <br/><br/>" +
                    "<b>Zadanie:</b> Zapisz w notatkach swoje oczekiwania wobec Kursu. Co chcesz osiągnąć?",
                attachFiles: true,
                showNotes: true,
                tasks: [
                    "Zapisałem/am swoje oczekiwania wobec Kursu",
                    "Określiłem/am, co chcę osiągnąć"
                ]
            },
            {
                title: "Czego się spodziewać?",
                vimeoUrl: "https://vimeo.com/1140733830",
                description: "W tej lekcji dowiesz się, czego spodziewać się po Kursie. <br/><br/>" +
                    "Omówimy sobie" +
                    "<ul>" +
                    "<li>Jak wygląda Kurs Efektywnego Działania?</li>" +
                    "<li>Od czego należy zacząć?</li>" +
                    "<li>Jak najszybciej zobaczyć rezultaty?</li>" +
                    "<li>Co wyróżnia osoby wynoszące 100% z Kursu?</li>" +
                    "<li>Najczęstsze błędy oraz jak ich uniknąć</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Cotygodniowe spotkania",
                        link: "/produkt/spolecznosc/spotkania"
                    },
                    {
                        title: "Discord",
                        link: "/produkt/spolecznosc"
                    }
                ],
            },
            {
                title: "Przedstawienie platformy",
                vimeoUrl: "https://vimeo.com/1177108555",
                description: "W tej lekcji dowiesz się, w jaki sposób korzystać z Produkacja OS.<br/><br/> Dodatkowo, zachęcam Cię, aby dołączyć na Discorda (Sekcja 'Społeczność' na samej górze strony) oraz zapisać się na najbliższe spotkanie grupowe (Sekcja 'Społeczność' -> 'Cotygodniowe spotkania').",
                tasks: [
                    "Dołączyłem/am na Discorda",
                    "Zapisałem/am się na cotygodniowe spotkanie (nieobowiązkowe, ale warto zobaczyć jak to wygląda :))"
                ],
                resources: [
                    {
                        title: "Produkacja OS",
                        link: "/produkt"
                    },
                    {
                        title: "Cotygodniowe spotkania",
                        link: "/produkt/spolecznosc/spotkania"
                    },
                    {
                        title: "Discord",
                        link: "/produkt/spolecznosc"
                    }
                ],
            },
            {
                title: "Zbiór dodatkowych narzędzi",
                vimeoUrl: "",
                description: "Tutaj znajdziesz dodatkowe narzędzia, które pomogą Ci w codziennym funkcjonowaniu i które będziemy omawiać w dalszej części Kursu. <br/>" +
                    "<ul>" +
                    "<li><b>Freedom</b> - blokowanie rozpraszających stron i aplikacji</li>" +
                    "<li><b>Brain.FM</b> - muzyka wspomagająca koncentrację</li>" +
                    "<li><b>OneSec</b> - aplikacja pomagająca w redukcji czasu spędzanego na mediach społecznościowych</li>" +
                    "</ul>" +
                    "Nie musisz korzystać ze wszystkich - wybierz te, które są dla Ciebie najbardziej przydatne.",
                resources: [
                    {
                        title: "Freedom App",
                        link: "https://freedom.to/"
                    },
                    {
                        title: "Brain.FM",
                        link: "https://www.brain.fm/produkacja"
                    },
                    {
                        title: "OneSec",
                        link: "https://web.one-sec.app/store?deal=tsjn9c"
                    },
                ],
            },
            {
                title: "Zbiór dodatkowych materiałów",
                vimeoUrl: "",
                description: "Tutaj znajdziesz dodatkowe materiały, które mogą Ci pomóc w codziennej nauce oraz bardzo dobrym zdaniu egzaminów. <br/><br/>" +
                    "<ul>" +
                    "<li><b>Prometeusze Fizyki</b> - Autorski program maturalny absolwenta Oxfordu, który uczy fizyki od totalnego zera, przywracając wiarę w świetny wynik nawet tym, którzy dawno stracili nadzieję na zrozumienie przedmiotu. <br/><br/> Zamiast bezmyślnego wkuwania wzorów, Kurs stawia na budowanie żelaznej intuicji i logicznego myślenia, tłumacząc trudne zjawiska m.in. na przykładach z gier wideo i popkultury.</li>" +
                    "<br/><li><b>MineAcademy</b> - Kurs uczący programowania oraz logicznego myślenia poprzez grę Minecraft - świetny dla osób, którzy lubią Minecrafta oraz myślą o wybraniu ścieżki IT w przyszłości. Ten program dostępny jest tylko w języku angielskim. <br/> Sam przerobiłem go 6+ lat temu i z własnego doświadczenia mogę go polecić.</li>" +
                    "<br/><li><b>YouTube Produkacji</b> - Nasz oficjalny kanał na YouTube, na którym co tydzień dzielimy się nową dawką wiedzy. Filmy mogą być świetnym dopełenieniem wiedzy z Kursu. </li>" +
                    "<br/><li><b>Produkacja OS</b> - Zbiór narzędzi, które pomogą Ci w codziennej, systematycznej nauce. Masz już do niej podstawowy dostęp. </li>" +
                    "</ul>" +
                    "<br/>To są oczywiście dodatkowe rekomendacje - nie musisz z nich korzystać. <br/>Z czasem pojawi się tutaj więcej materiałów.",
                resources: [
                    {
                        title: "Prometeusze Fizyki",
                        link: "https://prometeuszefizyki.pl/produkacja/"
                    },
                    {
                        title: "MineAcademy",
                        link: "https://mineacademy.org/?st=mikolaj&sc=redir"
                    },
                    {
                        title: "YouTube Produkacji",
                        link: "https://www.youtube.com/@produkacja/"
                    },
                    {
                        title: "Produkacja OS",
                        link: "/produkt"
                    },
                ],
            }
        ]
    },
    {
        title: "Świadomość & Środowisko",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1141620980",
                description: "Jest to odcinek organizacyjny i pokazujący, czego dokładnie spodziewać się po pierwszym tygodniu. ",
            },
            {
                title: "Świadomość - a na co to komu?",
                vimeoUrl: "https://vimeo.com/1140697081",
                description: "W tej lekcji dowiesz się, czym jest świadomość i dlaczego jest ona kluczowa w efektywnym działaniu.",
            },
            {
                title: "BEST Self - Idealna wersja siebie",
                vimeoUrl: "https://vimeo.com/1140696975",
                description: "W tej lekcji przejdziemy przez kluczowe ćwiczenie - stworzenie dokumentu BEST Self. <br/><br/>" +
                    "Zdefiniujesz:" +
                    "<ul>" +
                    "<li>Kim jesteś teraz (obecna wersja siebie)</li>" +
                    "<li>Kim chcesz się stać (idealna wersja siebie)</li>" +
                    "<li>Jakie zmiany są konieczne, aby się tam dostać</li>" +
                    "</ul>" +
                    "<b>To ćwiczenie jest kluczowe dla całego Kursu - poświęć mu odpowiednio dużo czasu!</b>",
                attachFiles: true,
                resources: [
                    {
                        link: 'https://docs.google.com/document/d/1muaPqx4UlmK9taEOqH4Qxw8pWY-Eo317eyNV_bo-sL8/edit?usp=sharing',
                        title: 'Najlepsza wersja siebie (Wersja podstawowa)'
                    },
                    {
                        link: 'https://docs.google.com/document/d/1H_ogNwmD6PN27LEvW-4_itdbP339IJJ2iQI8afWsooQ/edit?usp=sharing',
                        title: 'Najlepsza wersja siebie (Wersja rozszerzona)'
                    }
                ],
                tasks: [
                    "Opisałem/am swoją obecną wersję siebie",
                    "Opisałem/am idealną wersję siebie",
                    "Określiłem/am kluczowe zmiany do wprowadzenia"
                ]
            },
            {
                title: "Środowisko sprzyjające nauce",
                vimeoUrl: "https://vimeo.com/1140697512",
                description: "W tej lekcji dowiesz się, jak stworzyć środowisko sprzyjające nauce i efektywnemu działaniu. <br/><br/>" +
                    "Pokażę Ci:" +
                    "<ul>" +
                    "<li>Jak stworzyć produktywne miejsce pracy</li>" +
                    "<li>Na co zwrócić uwagę</li>" +
                    "</ul>" +
                    "<b>Zadanie:</b> Zoptymalizuj swoje środowisko według wskazówek z filmu.",
                tasks: [
                    "Uporządkowałem/am biurko i usunąłem/usunęłam zbędne przedmioty",
                    "Usunąłem/usunęłam rozpraszacze z mojego otoczenia"
                ]
            },
            {
                title: "Optymalizacja telefonu",
                vimeoUrl: "https://vimeo.com/1140696708",
                description: "W tej lekcji dowiesz się, jak zoptymalizować telefon, aby nie rozpraszał Cię podczas pracy czy nauki. <br/><br/>" +
                    "<b>Zadanie:</b> Przetestuj zaproponowane zmiany na swoim telefonie.",
                tasks: [
                    "Wyłączyłem/am zbędne powiadomienia",
                    "Wyczyściłem/am ekran główny",
                ],
                resources: [
                    {
                        title: "Freedom App",
                        link: "https://freedom.to/"
                    },
                    {
                        title: "OneSec",
                        link: "https://one-sec.app/"
                    },
                    {
                        title: "OneSec (1 miesiąc pro bezpłatny)",
                        link: "https://web.one-sec.app/store?deal=tsjn9c"
                    },
                ],
            },
            {
                title: "Optymalizacja komputera",
                vimeoUrl: "https://vimeo.com/1140696461",
                description: "W tej lekcji dowiesz się, jak zoptymalizować swój komputer do efektywnej pracy i nauki. <br/><br/>" +
                    "W sekcji z materiałami znajdziesz cheat-sheet ze wszystkimi omówionymi rozszerzeniami.",
                tasks: [
                    "Wyłączyłem/am powiadomienia z aplikacji",
                    "Zainstalowałem/am zaproponowane rozszerzenia",
                ],
                resources: [
                    {
                        title: "Lista rozszerzeń",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W1E6-rozszerzenia-przegladarka.pdf"
                    }
                ]
            },
            {
                title: "Plan Dominacji",
                vimeoUrl: "https://vimeo.com/1140697983",
                description: "W tej lekcji dowiesz się, jak korzystać z Planu Dominacji - Twojego osobistego narzędzia do planowania swojego czasu.<br/><br/>" +
                    "Został on zintegrowany z Produkacja OS i jest dla Ciebie w 100% bezpłatny na zawsze. <br/><br/>" +
                    "<b>Zadanie:</b> Zapisz swój plan na najbliższe dni/tygodnie.",
                tasks: [
                    "Zapisałem/am w Planie Dominacji najważniejsze aktywności na najbliższe dni"
                ],
                resources: [
                    {
                        title: "Plan Dominacji",
                        link: "/produkt/plan-dominacji"
                    }
                ]
            },
            {
                title: "Rola naszego nastawienia",
                vimeoUrl: "https://vimeo.com/1140697154",
                description: "W tej lekcji dowiesz się o różnicach między Fixed Mindset (Nastawienie na stagnację) i Growth Mindset (Nastawienie na rozwój). <br/><br/>" +
                    "Zrozumiesz:" +
                    "<ul>" +
                    "<li>Dlaczego nasze nastawienie jest istotne</li>" +
                    "<li>Czym różni się <i>Fixed Mindset</li> od <i>Growth Mindset</i>" +
                    "<li>Jak pracować z nastawieniem</li>" +
                    "</ul>" +
                    "Growth Mindset jest niezbędny, aby przejść przez cały Kurs i osiągać topowe wyniki!",
            },
            {
                title: "Technika małych wygranych",
                vimeoUrl: "https://vimeo.com/1140697857",
                description: "W tej lekcji dowiesz się, jak w kilka minut można wygrywać każdego dnia. <br/><br/>" +
                    "Co sobie omówimy?" +
                    "<ul>" +
                    "<li>Czym są marginalne zyski (Wprowadzenie, kontynuacja w kolejnych tygodniach)</li>" +
                    "<li>Codzienny 5-minutowy rytuał, który wzmocni Twoją samoocenę i motywację</li>" +
                    "</ul>" +
                    "To prosta technika, która pomaga budować momentum i świadomość własnego postępu.",
                attachFiles: true
            }
        ],
        quiz: {
            title: "Quiz - Świadomość & Środowisko",
            passingScore: 70,
            questions: [
                {
                    id: "v2w1q1",
                    type: "multiple-choice",
                    question: "Co oznacza 'Growth Mindset'?",
                    options: [
                        {
                            id: "a",
                            text: "Przekonanie, że nasze umiejętności są stałe i nie można ich zmienić",
                            isCorrect: false
                        },
                        {
                            id: "b",
                            text: "Przekonanie, że możemy rozwijać swoje umiejętności poprzez pracę i naukę",
                            isCorrect: true
                        },
                        {id: "c", text: "Skupienie się tylko na osiąganiu szybkich rezultatów", isCorrect: false},
                        {id: "d", text: "Unikanie wyzwań, aby nie popełniać błędów", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q3",
                    type: "true-false",
                    question: "Optymalizacja środowiska (telefonu, komputera, biurka) ma duży wpływ na efektywność działania.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q4",
                    type: "multiple-choice",
                    question: "Co powinno znaleźć się w 'Planie Dominacji'?",
                    options: [
                        {id: "a", text: "Tylko cele długoterminowe", isCorrect: false},
                        {id: "b", text: "Cele krótko- i długoterminowe oraz konkretne działania", isCorrect: true},
                        {id: "c", text: "Tylko listę zadań na dziś", isCorrect: false},
                        {id: "d", text: "Harmonogram snu", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q5",
                    type: "true-false",
                    question: "Technika małych wygranych polega na codziennym zapisywaniu tego, co poszło dobrze i co można poprawić.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q6",
                    type: "multiple-choice",
                    question: "Systematyczność jest ważniejsza niż intensywność, ponieważ:",
                    options: [
                        {
                            id: "a",
                            text: "Regularne małe działania dają lepsze efekty niż rzadkie intensywne sesje",
                            isCorrect: true
                        },
                        {id: "b", text: "Nie trzeba się wtedy tak bardzo starać", isCorrect: false},
                        {id: "c", text: "Można wtedy unikać trudnych zadań", isCorrect: false},
                        {id: "d", text: "To pozwala na prokrastynację", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q7",
                    type: "true-false",
                    question: "Świadomość to fundament, na którym budujemy wszystkie inne umiejętności efektywnego działania.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q10",
                    type: "true-false",
                    question: "Fixed Mindset wspiera rozwój i pomaga w osiąganiu celów.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                }
            ]
        }
    },
    {
        title: "Podstawy Efektywnego Działania",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1143197692",
                description: "Jest to odcinek organizacyjny i pokazujący, czego dokładnie spodziewać się po drugim tygodniu. ",
            },
            {
                title: "Skończ z odkładaniem",
                vimeoUrl: "https://vimeo.com/1143197287",
                description: "W tej lekcji omówimy sobie temat prokrastynacji i pokażemy, co można zrobić, aby w końcu zacząć działać systematycznie, bez polegania na motywacji. <br/><br/>",
                resources: [
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W2E2-notatki-prokrastynacja.pdf",
                        title: "Notatki z filmu"
                    }
                ]
            },
            {
                title: "Techniki antyprokrastynacyjne",
                vimeoUrl: "https://vimeo.com/1143197035",
                description: "W tej lekcji omówimy 5 technik, które skutecznie pomogą Ci w walce z prokrastynacją."
            },
            {
                title: "Koncentracja",
                vimeoUrl: "https://vimeo.com/1143196638",
                description: "W tej lekcji dowiesz się, jak poprawić swoją koncentrację i utrzymać uwagę przez dłuższy czas bez ciągłego rozpraszania się.",
                resources: [
                    {
                        title: "Cheat-Sheet: Co poprawia koncentrację?",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W2E4-poprawa-koncentracji-cheat-sheet.pdf"
                    },
                    {
                        title: "Brain.FM",
                        link: "https://www.brain.fm/produkacja"
                    },
                ]
            },
            {
                title: "Określanie priorytetów",
                vimeoUrl: "https://vimeo.com/1143196411",
                tasks: [
                    "Określiłem/am swoje priorytety na najbliższy czas",
                ],
                description: "W tej lekcji zagłębimy się w temat określania priorytetów.<br/><br/>" +
                    "Omówimy sobie dokładnie Matrycę Eisenhowera, na podstawie której określimy zadania w kategoriach WAŻNE / PILNE oraz pokażemy, na co zwrócić uwagę podczas planowania.",
            },
            {
                title: "Świadomość czasu",
                vimeoUrl: "https://vimeo.com/1143196050",
                description: "W tej lekcji omówimy arkusz 'Świadomość czasu' oraz 'Mapa mocy' - na czym polegają i jak zastosować je w praktyce. Po wykonaniu tych ćwiczeń, odzyskasz kontrolę nad swoim czasem.",
                attachFiles: true,
                tasks: [
                    "Zacząłem/zaczęłam tworzyć świadomość czasu",
                    "Zrobiłem/am swoją świadomość czasu, a następnie wyciągnąłem/am z niej wnioski przy pomocy Mapy Mocy",
                ],
                resources: [
                    {
                        title: "Arkusz 'Świadomość czasu'",
                        link: 'https://docs.google.com/spreadsheets/d/1GnxxyYwwpZ1-56YhCC1Ek7zLoTMs2hw99yjonX6cpsU/edit?usp=sharing'
                    },
                    {
                        title: "Arkusz 'Mapa mocy'",
                        link: "https://docs.google.com/spreadsheets/d/1OVvW0Ntq7kbMgzR9Ci7HoaYJiM4bFaEvsFmNOG4rFcg/edit?usp=sharing"
                    }
                ]
            },
            {
                title: "Chronotypy snu",
                vimeoUrl: "https://vimeo.com/1143195624",
                description: "W tym filmie przyjrzymy się tematowi chronotypów snu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym są chronotypy snu.</li>" +
                    "<li>Wyznacznie Twojego chronotypu.</li>" +
                    "<li>Charakteryzowanie każdego z chronotypów.</li>" +
                    "</ul>" +
                    "W sekcji z materiałami znajdziesz link do testu na chronotyp snu oraz do bardziej szczegółowego opisu każdego z nich.",
                attachFiles: true,
                tasks: [
                    "Określiłem/am swój chronotyp snu",
                    "Zapoznałem/am się z cheat-sheetem dla mojego chronotypu snu"
                ],
                resources: [
                    {
                        title: "Test na chronotyp",
                        link: "https://produkacja.pl/chronotypy"
                    },
                    {
                        title: "Chronotyp DELFIN",
                        link: "https://docs.google.com/document/d/1mn_wWiWHqDOwST20XQyaHf7vYk8Xw4LfM1KMdHrTkKM/edit?usp=sharing",
                    },
                    {
                        title: "Chronotyp LEW",
                        link: "https://docs.google.com/document/d/1KO_UpB_KPn3IlIoMaAsNTCqgxUMdMRM4AVk0KBEZvAk/edit?usp=sharing"
                    },
                    {
                        title: "Chronotyp NIEDŹWIEDŹ",
                        link: "https://docs.google.com/document/d/1qSwgBKCW6TzPKLZLa0udIL05b8vFErQNYHGUX4sBB2M/edit?usp=sharing"
                    },
                    {
                        title: "Chronotyp WILK",
                        link: "https://docs.google.com/document/d/1_7l1ElBPG9o4yAz21ImC943YO-9kJ-DOW1XgdiPztmQ/edit?usp=sharing"
                    },
                ]
            },
            {
                title: "Marginalne zyski",
                vimeoUrl: "https://vimeo.com/1143393395",
                description: "W tej lekcji skupimy się na marginalnych zyskach - małych zmianach, które nałożone na siebie, dają w długoterminowej perspektywie ogromne rezultaty. <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Przykład marginalnych zysków na podstawie historii Brytyjskich kolarzy.</li>" +
                    "<li>Czym są marginalne zyski.</li>" +
                    "<li>Dlaczego marginalne zyski są istotne.</li>" +
                    "<li>W jaki sposób mierzyć marginalne zyski.</li>" +
                    "</ul>",
                tasks: [
                    "Określiłem/am swój długoterminowy cel, określiłem/am swój obecny i docelowy poziom, a teraz pracuję nad znajdowaniem 1%."
                ],
                attachFiles: true,
                resources: [
                    {
                        title: "Historia Brytyjskich kolarzy (dla zainteresowanych)",
                        link: "https://jamesclear.com/marginal-gains"
                    },
                    {
                        title: "Cheat-Sheet: Mierzenie marginalnych zysków",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W2E8-mierzenie-marginalnych-zyskow.pdf"
                    }
                ]
            },
            {
                title: "Cykl Kolba",
                vimeoUrl: "https://vimeo.com/1143195151",
                description: "W tej lekcji zajmiemy się dokładnym zrozumieniem Cyklu Kolba.<br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Czym jest Cykl Kolba i dlaczego jest on istotny.</li>" +
                    "<li>Jak tworzyć Cykl Kolba.</li>" +
                    "<li>Przykład Cyklu Kolba.</li>" +
                    "</ul>" +
                    "Po przerobieniu tej lekcji, <b>Twoim zadaniem będzie stworzenie przynajmniej dwóch Cyklów Kolba</b>. ",
                attachFiles: true,
                tasks: [
                    "Stworzyłem/am przynajmniej dwa własne Cykle Kolba"
                ],
                resources: [
                    {
                        title: 'Cykl Kolba - Cheat Sheet',
                        link: 'https://docs.google.com/document/d/1bsmkEtrmOgDHhBmo5MYiRo0duydQIP9btpFDDtLJ468/edit?usp=sharing'
                    },
                    {
                        title: 'Inny przykład Cyklu Kolba',
                        link: 'https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/Przyk%C5%82ad+Cyklu+Kolba+z+filmu.pdf'
                    },
                    {
                        title: 'Przykłady innych cyklów Kolba (blog)',
                        link: 'https://produkacja.pl/blog/2i5Lz6X464cb7STIj8W75WMKfA7'
                    }
                ]
            },
        ],
        quiz: {
            title: "Quiz - Podstawy Efektywnego Działania",
            passingScore: 70,
            questions: [
                {
                    id: "v2w2q1",
                    type: "multiple-choice",
                    question: "Dlaczego nawyki są lepsze niż motywacja?",
                    options: [
                        {id: "a", text: "Bo są łatwiejsze do zbudowania", isCorrect: false},
                        {
                            id: "b",
                            text: "Bo działają niezależnie od tego, czy czujemy się zmotywowani",
                            isCorrect: true
                        },
                        {id: "c", text: "Bo nie wymagają żadnego wysiłku", isCorrect: false},
                        {id: "d", text: "Bo motywacja w ogóle nie działa", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q2",
                    type: "true-false",
                    question: "Koncentracja to umiejętność, którą można trenować jak mięsień.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q3",
                    type: "multiple-choice",
                    question: "Jak najlepiej radzić sobie z dużymi, przytłaczającymi zadaniami?",
                    options: [
                        {id: "a", text: "Odłożyć je na później", isCorrect: false},
                        {id: "b", text: "Podzielić je na mniejsze, łatwiejsze do wykonania części", isCorrect: true},
                        {id: "c", text: "Robić je tylko gdy jest motywacja", isCorrect: false},
                        {id: "d", text: "Zignorować je całkowicie", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q4",
                    type: "multiple-choice",
                    question: "W Matrycy Eisenhowera, które zadania powinniśmy wykonywać jako pierwsze?",
                    options: [
                        {id: "a", text: "Ważne i pilne", isCorrect: true},
                        {id: "b", text: "Nieważne i pilne", isCorrect: false},
                        {id: "c", text: "Ważne i niepilne", isCorrect: false},
                        {id: "d", text: "Nieważne i niepilne", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q5",
                    type: "multiple-choice",
                    question: "Ile chronotypów snu wyróżniamy?",
                    options: [
                        {id: "a", text: "2", isCorrect: false},
                        {id: "b", text: "3", isCorrect: false},
                        {id: "c", text: "4", isCorrect: true},
                        {id: "d", text: "5", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q6",
                    type: "true-false",
                    question: "Marginalne zyski to małe zmiany, które w długoterminowej perspektywie dają ogromne rezultaty.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q7",
                    type: "multiple-choice",
                    question: "Ile kroków ma Cykl Kolba?",
                    options: [
                        {id: "a", text: "2", isCorrect: false},
                        {id: "b", text: "3", isCorrect: false},
                        {id: "c", text: "4", isCorrect: true},
                        {id: "d", text: "5", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q8",
                    type: "multiple-choice",
                    question: "Do czego służy 'Świadomość czasu'?",
                    options: [
                        {id: "a", text: "Do planowania posiłków", isCorrect: false},
                        {
                            id: "b",
                            text: "Do uświadomienia sobie, na co dokładnie poświęcamy swój czas",
                            isCorrect: true
                        },
                        {id: "c", text: "Do zapisywania celów życiowych", isCorrect: false},
                        {id: "d", text: "Do mierzenia postępów w nauce", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q9",
                    type: "multiple-choice",
                    question: "Który chronotyp charakteryzuje się najwyższą produktywnością rano?",
                    options: [
                        {id: "a", text: "Wilk", isCorrect: false},
                        {id: "b", text: "Niedźwiedź", isCorrect: false},
                        {id: "c", text: "Lew", isCorrect: true},
                        {id: "d", text: "Delfin", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q10",
                    type: "multiple-choice",
                    question: "Co NIE jest jednym z 4 etapów Cyklu Kolba?",
                    options: [
                        {id: "a", text: "Refleksja", isCorrect: false},
                        {id: "b", text: "Doświadczenie", isCorrect: false},
                        {id: "c", text: "Abstrakcja", isCorrect: false},
                        {id: "d", text: "Zapytanie", isCorrect: true}
                    ]
                },
            ]
        }
    },
    {
        title: "Wstęp do Efektywnej Nauki",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1145197524",
                description: "Odcinek organizacyjny i pokazujący, czego dokładnie spodziewać się w trzecim tygodniu. ",
            },
            {
                title: "Podstawy Efektywnej Nauki",
                vimeoUrl: "https://vimeo.com/1145197571",
                description: "W tej lekcji poznasz metodę POP - jeden z najskuteczniejszych sposobów na efektywną naukę. <br/><br/>" +
                    "POP to skrót od:" +
                    "<ul>" +
                    "<li><b>P</b>owtarzanie</li>" +
                    "<li><b>O</b>dzyskiwanie</li>" +
                    "<li><b>P</b>rzeplatanie</li>" +
                    "</ul>" +
                    "W kolejnych lekcjach omówimy każdy element szczegółowo.",
            },
            {
                title: "Powtórki",
                vimeoUrl: "https://vimeo.com/1145197642",
                description: "W tym filmie zajmiemy się tematem powtórek i omówimy sobie: <br/><br/>" +
                    "<ul>" +
                    "<li>Czym jest krzywa zapominania i jak z nią walczyć.</li>" +
                    "<li>Jak często należy robić powtórki.</li>" +
                    "<li>Na co zwracać uwagę podczas powtórek.</li>" +
                    "</ul>",
                tasks: [
                    "Zaplanowałem/am swoje powtórki w Planie Dominacji"
                ],
                resources: [
                    {
                        title: "Krzywa zapominania - Notatki z Filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E3-Krzywa+zapominania.png"
                    },
                    {
                        title: "Częstotliwość powtórek - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E3-cze%CC%A8stotliwos%CC%81c%CC%81-powto%CC%81rek.pdf"
                    }
                ]
            },
            {
                title: "Odzyskiwanie + Sen",
                vimeoUrl: "https://vimeo.com/1145198077",
                description: "W tym filmie zajmiemy się tematem odzyskiwania i omówimy sobie: <br/><br/>" +
                    "<ul>" +
                    "<li>Dlaczego odzyskiwanie jest istotne.</li>" +
                    "<li>Dwie zasady dotyczące skutecznego odzyskiwania.</li>" +
                    "<li>Istotna snu w kontekście odzyskiwania.</li>" +
                    "<li>Optymalny sposób planowania nauki przed sprawdzianami.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Istota snu - Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E4-Istota+snu.png"
                    },
                    {
                        title: "Przykładowy plan nauki przed sprawdzianem - Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E4-Przyk%C5%82adowy+plan+nauki+przed+sprawdzianem.png"
                    }
                ]
            },
            {
                title: "Przeplatanie - techniki",
                vimeoUrl: "https://vimeo.com/1145198513",
                description: "W tej lekcji zajmiemy się tematem przeplatania i omówimy: <br/><br/>" +
                    "<ul>" +
                    "<li>Na czym polega „przeplatanie” różnych technik.</li>" +
                    "<li>Jakie techniki można stosować.</li>" +
                    "</ul>" +
                    "W filmie poruszymy pokrótce temat map myśli, o których wiecej będzie w tygodniu 5.",
                tasks: [
                    "Przetestowałem/am techniki zaproponowane w filmie podczas swojej własnej sesji nauki"
                ],
                resources: [
                    {
                        title: "Jakie techniki możemy przeplatać - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E5-Przeplatanie+ro%CC%81z%CC%87nych+technik.pdf"
                    }
                ]
            },
            {
                title: "Przeplatanie z AI",
                vimeoUrl: "https://vimeo.com/1145206758",
                description: "W tej lekcji dowiesz się, jak wykorzystać AI do przeplatania i nauki. ",
                tasks: [
                    "Przetestowałem/am Edukacyjny Chat do przeplatania."
                ],
                resources: [
                    {
                        title: "Do czego można wykorzystać AI - ściąga",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E6-Do+czego+moz%CC%87na+wykorzystac%CC%81%C2%A0AI.pdf"
                    },
                    {
                        title: "Edukacyjny Chat (Narzędzie z Filmu)",
                        link: "/produkt/chat"
                    }
                ]
            },
            {
                title: "Planowanie nauki SMART",
                vimeoUrl: "https://vimeo.com/1145198782",
                description: "W tym filmie przyjrzymy się tematowi planowania \"SMART\". <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Na czym polega planowanie \"SMART\".</li>" +
                    "<li>Przykłady celów \"SMART\" i celów nie-\"SMART\".</li>" +
                    "<li>Jak skutecznie stawiać cele \"SMART\".</li>" +
                    "<li>Bonus: Łączenie tego z Planem Dominacji.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Cele \"SMART\" - Ściąga",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E7-Cele+SMART.pdf"
                    },
                    {
                        title: "Pytania pomocnicze do tworzenia celów \"SMART\"",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E7-Pytania+do+celo%CC%81w+SMART.pdf"
                    }
                ],
                tasks: [
                    "Zaplanowałem/am naukę na najbliższe dni wykorzystując cele SMART",
                    "Cele SMART zostały dodane do Planu Dominacji"
                ]
            },
            {
                title: "Planowanie nauki z AI",
                vimeoUrl: "https://vimeo.com/1145199255",
                description: "<b>Uwaga: Planer Nauki został zastąpiony Produkacją AI. </b> <br/><br/>Od końca marca, plany nauki tworzą się automatycznie po dodaniu nowego sprawdzianu/kartkówki z poziomu Dashboardu. <br/><br/>" +
                    "Aby zobaczyć, co dokładnie się zmieniło, przejdź do Tygodnia 0 odcinka 3 - \"Przedstawienie Platformy\" - Znajdziesz tam zaktualizowany film.",
                resources: [
                    {
                        title: "Przedstawienie Produkacja OS",
                        link: "/produkt/kurs-efektywnego-dzialania-v2?w=0&e=3"
                    },
                    {
                        title: "Produkacja OS (nowość)",
                        link: "/produkt"
                    }
                ]
            }
        ],
        quiz: {
            title: "Quiz - Wstęp do Efektywnej Nauki",
            passingScore: 70,
            questions: [
                {
                    id: "v2w3q1",
                    type: "fill",
                    question: "POP to skrót od: Powtarzanie, Odzyskiwanie i ___",
                    correctAnswer: "Przeplatanie"
                },
                {
                    id: "v2w3q2",
                    type: "multiple-choice",
                    question: "Jakie są zalecane interwały powtórek?",
                    options: [
                        {id: "a", text: "1 dzień, 2 dni, 3 dni", isCorrect: false},
                        {id: "b", text: "1 dzień, 2-3 dni, 5-10 dni, 10-20dni", isCorrect: true},
                        {id: "c", text: "Codziennie przez miesiąc", isCorrect: false},
                        {id: "d", text: "Nie ma znaczenia", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q3",
                    type: "true-false",
                    question: "Przeplatanie jest skuteczniejsze niż przeglądanie notatek.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q4",
                    type: "multiple-choice",
                    question: "Co oznacza 'M' w metodzie SMART?",
                    options: [
                        {id: "a", text: "Mizerne", isCorrect: false},
                        {id: "b", text: "Mierzalne", isCorrect: true},
                        {id: "c", text: "Matematyczne", isCorrect: false},
                        {id: "d", text: "Mądre", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q5",
                    type: "true-false",
                    question: "Przeplatanie polega na nauce różnych zagadnień z wykorzystaniem różnych technik, co zwiększa elastyczność myślenia i poziom zapamiętywania.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q6",
                    type: "multiple-choice",
                    question: "Na ile zasad dzielą się cele SMART?",
                    options: [
                        {id: "a", text: "2", isCorrect: false},
                        {id: "b", text: "3", isCorrect: false},
                        {id: "c", text: "4", isCorrect: false},
                        {id: "d", text: "5", isCorrect: true}
                    ]
                },
                {
                    id: "v2w3q7",
                    type: "true-false",
                    question: "Sen nie ma większego znaczenia dla konsolidacji pamięci i nauki.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
                {
                    id: "v2w3q8",
                    type: "true-false",
                    question: "AI może pomóc w generowaniu pytań testujących i tworzeniu quizów.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q9",
                    type: "multiple-choice",
                    question: "Krzywa zapominania pokazuje, że:",
                    options: [
                        {id: "a", text: "Zapominamy najwięcej w pierwszych dniach po nauce", isCorrect: true},
                        {id: "b", text: "Zapominamy równomiernie przez cały czas", isCorrect: false},
                        {id: "c", text: "Nie zapominamy nic, jeśli się skupimy", isCorrect: false},
                        {id: "d", text: "Zapominamy tylko trudne rzeczy", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q10",
                    type: "multiple-choice",
                    question: "Kiedy powinniśmy skończyć naukę nowych zagadnień przygotowując się do sprawdzianu?",
                    options: [
                        {id: "a", text: "Na ostatniej przerwie przed sprawdzianem", isCorrect: false},
                        {id: "b", text: "Dwa dni wcześniej", isCorrect: true},
                        {id: "c", text: "W ostatni wieczór", isCorrect: false},
                        {id: "d", text: "To nie ma żadnego znaczenia", isCorrect: false}
                    ]
                },
            ]
        }
    },
    {
        title: "Totalny ogar",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1147706005",
                description: "Odcinek organizacyjny i pokazujący, czego dokładnie spodziewać się w czwartym tygodniu. ",
            },
            {
                title: "Nauka na lekcji",
                vimeoUrl: "https://vimeo.com/1147706076",
                description: "W tej lekcji dowiesz się, jak wycisnąć maksimum z lekcji w szkole. <br/><br/>" +
                    "Omówimy" +
                    "<ul>" +
                    "<li>Na co zwrócić uwagę podczas nauki w szkole.</li>" +
                    "<li>3-stopniowy proces wynoszenia z lekcji 100%.</li>" +
                    "</ul>" +
                    "Jeśli dobrze wykorzystasz czas w szkole, nauka w domu będzie dużo krótsza i przyjemniejsza.",
            },
            {
                title: "Techniki egzaminacyjne",
                vimeoUrl: "https://vimeo.com/1147706422",
                description: "W tej lekcji poznasz sprawdzone techniki przygotowania do egzaminów i sprawdzianów. <br/><br/>" +
                    "Omówimy:" +
                    "<ul>" +
                    "<li>5-stopniowy proces pisania sprawdzianów na topowe wyniki.</li>" +
                    "<li>W jaki sposób pokonać stres przed testem. (Cheat-sheet z 7 poradami w sekcji z zasobami)</li>" +
                    "</ul>",
                tasks: [
                    "Stworzyłem/am własną checklistę przed testami"
                ],
                resources: [
                    {
                        title: "Pokonaj stres przed testem - 7 Porad (Cheat-sheet)",
                        link: "https://docs.google.com/document/d/1xacXncyKn3alT26SvB8Fah6PYh0pZ6n0TeH-xnrnW5Q/edit?usp=sharing"
                    },
                    {
                        title: "Równe tempo i sprawdzanie odpowiedzi (Notatki z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E3+-+Techniki+egzaminacyjne+notatki.png"
                    },
                    {
                        title: "Techniki egzaminacyjne - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E3-Techniki+Cheat-Sheet.pdf"
                    }
                ]
            },
            {
                title: "Efektywne notatki",
                vimeoUrl: "https://vimeo.com/1147706907",
                description: "W tej lekcji zajmiemy się tematem efektywnych notatek i omówimy, na co zwrócić uwagę podczas robienia notatek. <br/><br/>W kolejnym tygodniu zajmiemy się tematem map myśli, gdzie wejdziemy na poziom wyżej.",
            },
            {
                title: "Fiszki",
                vimeoUrl: "https://vimeo.com/1147707037",
                description: "W tej lekcji dowiesz się, jak skutecznie używać fiszek do nauki. <br/><br/>" +
                    "Omówimy:" +
                    "<ul>" +
                    "<li>Czym są fiszki i dlaczego są one skuteczne.</li>" +
                    "<li>Kiedy fiszki sprawdzą się najlepiej.</li>" +
                    "<li>Jak skutecznie tworzyć fiszki.</li>" +
                    "</ul>" +
                    "W sekcji z zasobami znajdziesz nasze autorskie narzędzie - Fiszki na Produkacji",
                resources: [
                    {
                        title: "Fiszki na Produkacji",
                        link: "/produkt/fiszki"
                    }
                ]
            },
            {
                title: "Przerwy",
                vimeoUrl: "https://vimeo.com/1147707348",
                description: "W tej lekcji zajmiemy się tematem przerw. <br/><br/>" +
                    "Omówimy:" +
                    "<ul>" +
                    "<li>Co ile robić przerwy.</li>" +
                    "<li>Co najlepiej robić podczas przerw.</li>" +
                    "</ul>",
            },
            {
                title: "Rutyna przed nauką",
                vimeoUrl: "",
                tasks: [
                    "Przemyślałem/am swoją rutynę przed nauką."
                ],
                description: "Aby nasz mózg automatycznie wchodził w stan koncentracji, świetnie sprawdzi się wykonywanie zawsze tej samej czynności przed każdą sesją nauki. <br/><br/>" +
                    "Może być to na przykład słuchanie zawsze tej samej piosenki czy robienie sobie zawsze tej samej herbaty. Możliwości jest wiele, jednak dobrze, żeby nie trwało to więcej niż 5 minut. <br/><br/>" +
                    "Dzięki temu, Twój mózg zacznie kojarzyć tę konkretną aktywność z koniecznością skupienia się. Wykształcenie takiej reakcji zajmuje kilka tygodni, jednak po tym czasie zobaczysz, że jeszcze łatwiej będzie Ci wejść w \"stan nauki\".<br/><br/>" +
                    "Ten schemat można również stosować w przypadku sprawdzianów / egzaminów. Czyli za każdym razem przed testem, wykonujemy tę samą czynność. <br/><br/>" +
                    "Eksperymentuj i patrz, jak to działa w Twoim przypadku!<br/><br/>" +
                    "<b>Ta lekcja nie zawiera filmu video.</b>",
            },
            {
                title: "Kolejność nauki",
                vimeoUrl: "https://vimeo.com/1147703262",
                description: "W tej lekcji zajmiemy się tematem kolejności nauki. <br/><br/>" +
                    "Omówimy:" +
                    "<ul>" +
                    "<li>Czy kolejność nauki ma znaczenie?</li>" +
                    "<li>W jakiej kolejności powinniśmy się uczyć?</li>" +
                    "</ul>",
            },
            {
                title: "Radzenie sobie ze stresem",
                vimeoUrl: "https://vimeo.com/1147707565",
                description: "W tej lekcji dowiesz się, w jaki sposób radzić sobie ze stresem. <br/><br/>" +
                    "Poruszymy natępujące tematy:" +
                    "<ul>" +
                    "<li>Reakcja stresowa</li>" +
                    "<li>Skutki przewlekłego stresu</li>" +
                    "<li>Stres a nauka</li>" +
                    "<li>Chwilowy stres - jak reagować?</li>" +
                    "<li>Przewlekły stres - jak się nim zająć?</li>" +
                    "</ul>" +
                    "W sekcji z zasobami znajdziesz dwa nagrania technik oddechowych. <br/><br/>" +
                    "<b>Pierwsze nagranie: Oddech Pudełkowy</b><br/>" +
                    "Wdech 4s<br/>" +
                    "Zatrzymanie 4s<br/>" +
                    "Wydech 4s<br/><br/>" +
                    "Reguluje oddech oraz tętno, redukuje stres, wspiera koncentrację. <br/><br/><hr/><br/>" +
                    "<b>Drugie nagranie: Oddech Naprzemienny</b><br/>" +
                    "Zamknięcie prawej dziurki prawym kciukiem, wdech lewą.<br/>" +
                    "Zatkanie lewej palcem serdecznym wydech prawą.<br/><br/>" +
                    "Redukuje stres, uspokaja układ nerwowy, równoważy działanie półkul, poprawia koncentrację.",
                tasks: [
                    "Wypróbowałem/am przynajmniej jedną z technik oddechowych"
                ],
                resources: [
                    {
                        title: "Oddech pudełkowy",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/techniki-oddechowe/Oddech+pude%C5%82kowy.WAV"
                    },
                    {
                        title: "Oddech naprzemienny",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/techniki-oddechowe/Oddech+naprzemienny.WAV"
                    }
                ],
            },
            {
                title: "Realizacja celów krok po kroku",
                vimeoUrl: "https://vimeo.com/1147703420",
                description: "W tej lekcji poznasz protokół do skutecznej realizacji dowolnego celu. <br/><br/>",
                resources: [
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E9-protoko%CC%81%C5%82+skutecznej+realizacji+dowolnego+celu.pdf",
                        title: "Protokół realizacji celów krok po kroku - Cheat-Sheet"
                    },
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E9+-+konsekwentne+dzia%C5%82anie+cheat-sheet.pdf",
                        title: "Konsekwentne działanie - Cheat-Sheet"
                    }
                ]
            },
        ],
        quiz: {
            title: "Quiz - Totalny ogar",
            passingScore: 70,
            questions: [
                {
                    id: "v2w4q1",
                    type: "multiple-choice",
                    question: "Ile czasu powinno trwać Prestudy (Nauka przed zajeciami)?",
                    options: [
                        {id: "a", text: "A co to?", isCorrect: false},
                        {id: "b", text: "5-15min", isCorrect: true},
                        {id: "c", text: "30-60min", isCorrect: false},
                        {id: "d", text: "Im więcej tym lepiej", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q2",
                    type: "multiple-choice",
                    question: "Co powinno się zrobić w domu po lekcjach w szkole?",
                    options: [
                        {id: "a", text: "Od razu zapomnieć o materiale", isCorrect: false},
                        {id: "b", text: "Poświęcić chwilę minut na powtórzenie materiału", isCorrect: true},
                        {id: "c", text: "Grać w gry ile wlezie", isCorrect: false},
                        {id: "d", text: "Nic - w szkole wystarczy słuchać", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q3",
                    type: "true-false",
                    question: "Fiszki to jedno z najskuteczniejszych narzędzi do zapamiętywania.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q4",
                    type: "multiple-choice",
                    question: "W jakiej kolejności powinniśmy się uczyć",
                    options: [
                        {id: "a", text: "Tak jak jest w podręczniku.", isCorrect: false},
                        {id: "b", text: "Zawsze od najtrudniejszych do najłatwiejszych tematów.", isCorrect: false},
                        {id: "c", text: "Zawsze od najłatwiejszych do najtrudniejszych tematów.", isCorrect: false},
                        {id: "d", text: "W takiej, która ma dla nas najwięcej sensu.", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q5",
                    type: "multiple-choice",
                    question: "Co NAJSZYBCIEJ pomaga odzyskać kontrolę przy chwilowym stresie?",
                    options: [
                        {id: "a", text: "Scrollowanie telefonu", isCorrect: false},
                        {id: "b", text: "Wydłużenie wydechu", isCorrect: true},
                        {id: "c", text: "Rozmyślanie „co jeśli…”", isCorrect: false},
                        {id: "d", text: "Ocenianie siebie", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q6",
                    type: "true-false",
                    question: "Przerwy zmniejszają produktywność i powinno się ich unikać.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q7",
                    type: "multiple-choice",
                    question: "Co jest ważne podczas robienia notatek?",
                    options: [
                        {id: "a", text: "Przepisywanie wszystkiego słowo w słowo", isCorrect: false},
                        {
                            id: "b",
                            text: "Pisanie własnymi słowami, dodawanie elementów graficznych i wyróżnianie najważniejszych informacji",
                            isCorrect: true
                        },
                        {id: "c", text: "Robienie notatek tylko gdy nauczyciel każe", isCorrect: false},
                        {id: "d", text: "Używanie tylko kolorowych pisaków", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q8",
                    type: "true-false",
                    question: "Rutyna przed nauką pomaga szybciej wejść w stan koncentracji.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q9",
                    type: "multiple-choice",
                    question: "Która technika NIE pomaga w radzeniu sobie ze stresem?",
                    options: [
                        {id: "a", text: "Techniki oddechowe", isCorrect: false},
                        {id: "b", text: "Medytacja", isCorrect: false},
                        {id: "c", text: "Aktywność fizyczna", isCorrect: false},
                        {id: "d", text: "Ignorowanie stresu i uczuć", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q10",
                    type: "true-false",
                    question: "Stres jest zawsze czymś złym i należy go unikać.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q11",
                    type: "true-false",
                    question: "Scrollowanie social mediów wspiera regenerację układu nerwowego.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
            ]
        }
    },
    {
        title: "Efektywna nauka 2.0",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1150853754",
                description: "Odcinek organizacyjny i pokazujący, czego dokładnie spodziewać się w piątym tygodniu.",
            },
            {
                title: "Kiedy najlepiej zapamiętujemy?",
                vimeoUrl: "https://vimeo.com/1150853787",
                description: "W tej lekcji dowiesz się, kiedy najlepiej zapamiętujemy. <br/><br/>" +
                    "Omówimy sobie:" +
                    "<ul>" +
                    "<li>Co nasz mózg najlepiej zapamiętuje.</li>" +
                    "<li>Jak wykorzystać to na naszą korzyść w kontekście efektywnej nauki.</li>" +
                    "</ul>",
            },
            {
                title: "Nauka poprzez dociekanie",
                vimeoUrl: "https://vimeo.com/1150853838",
                description: "W tej lekcji zajmiemy się tematem nauki poprzez dociekanie. <br/><br/>" +
                    "Omówimy sobie:" +
                    "<ul>" +
                    "<li>Czy właściwie jest <i>Nauka poprzez dociekanie</i>.</li>" +
                    "<li>Jak stosować ją w praktyce.</li>" +
                    "</ul>",
                resources: [
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E3-Nauka-poprzez-dociekanie-cheat-sheet.pdf",
                        title: "Nauka poprzez dociekanie: Cheat-sheet"
                    }
                ]
            },
            {
                title: "Mapy myśli",
                vimeoUrl: "https://vimeo.com/1150853908",
                description: "W tym filmie zajmiemy się tematem map myśli i omówimy sobie:" +
                    "<ul>" +
                    "<li>Dlaczego mapy myśli są istotne.</li>" +
                    "<li>Jak tworzyć skuteczne mapy myśli i na co zwracać uwagę.</li>" +
                    "<li>Przykłady map myśli.</li>" +
                    "</ul>" +
                    "Jest to najdłuższa lekcja z całego Kursu.",
                attachFiles: true,
                tasks: [
                    "Przećwiczyłem/am robienie map myśli w praktyce, np. podczas nauki do sprawdzianu."
                ],
                resources: [
                    {
                        link: "https://tablicanakorki.pl/t/35QEaaSqoduMIwImgRYULBfkilm",
                        title: "Przykłady map myśli z filmu"
                    },
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E4-Jak-tworzyc-mapy-mysli.pdf",
                        title: "Jak tworzyć mapy myśli - Cheat-Sheet"
                    }
                ]
            },
            {
                title: "Nauka do przedmiotów ścisłych",
                vimeoUrl: "https://vimeo.com/1150855393",
                description: "W tym filmie zajmiemy się efektywną nauką do przedmiotów ścisłych i omówimy sobie, w jaki sposób robić to skutecznie.",
                resources: [
                    {
                        title: "Przykład z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E5-Przyklad-z-filmu.png"
                    }
                ]
            },
            {
                title: "Stan flow",
                vimeoUrl: "https://vimeo.com/1150855463",
                description: "W tym filmie zajmiemy się tematem stanu flow i omówimy sobie:" +
                    "<ul>" +
                    "<li>Czym jest stan flow i dlaczego jest on istotny.</li>" +
                    "<li>Jak wchodzić w stan flow.</li>" +
                    "</ul>",
            },
            {
                title: "Miesiąc w jeden dzień",
                vimeoUrl: "https://vimeo.com/1150855560",
                description: "W tym filmie omówimy sobie, w jaki sposób można nadrobić lub nauczyć się ogromnej ilości materiału w jeden dzień, oraz pokażemy sobie przykładowy harmonogram takiego dnia.",
                resources: [
                    {
                        title: "Na co zwracać uwagę przed - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E7-Na-co-zwracac-uwage-przed.pdf"
                    },
                    {
                        title: "Przykładowy harmonogram",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E7-Przykladowy-harmonogram.pdf"
                    }
                ]
            },
            {
                title: "Zrzut Pamięci",
                vimeoUrl: "",
                description: "Twoim zadaniem jest opisanie wszystkiego, czego się do tej pory nauczyłeś/aś. Pomyśl, że niedługo masz egzamin z materiału z Kursu i musisz się do niego przygotować. To pomoże Ci ugrunotwać całą zdobytą tutaj wiedzę :). <br/><br/>" +
                    "Możesz do tego wykorzystać sekcję z notatkami lub załączyć własny plik.",
                showNotes: true,
                attachFiles: true,
                tasks: [
                    "Zapisałem/am wszystko, czego się do tej pory nauczyłem/am."
                ]
            },
            {
                title: "Podsumowanie tematu nauki",
                vimeoUrl: "https://vimeo.com/1150855627",
                description: "W tej lekcji podsumujemy sobie temat nauki i omówimy: <br/><br/>" +
                    "<ul>" +
                    "<li>Jak połączyć wszystko, czego się nauczyliśmy i wykorzystać to w praktyce.</li>" +
                    "<li>Jak działać i na co zwracać uwagę.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Działanie w szkole - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E9-Dzialanie-w-szkole.pdf"
                    },
                    {
                        title: "Działanie w domu - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E9-Dzialanie-w-domu.pdf"
                    },
                ]
            }
        ],
        quiz: {
            title: "Quiz - Efektywna nauka 2.0",
            passingScore: 70,
            questions: [
                {
                    id: "v2w5q1",
                    type: "multiple-choice",
                    question: "Kiedy nasz mózg najlepiej zapamiętuje informacje?",
                    options: [
                        {id: "a", text: "Kiedy coś nas bardzo ciekawi", isCorrect: true},
                        {id: "b", text: "Kiedy mamy mało nauki", isCorrect: false},
                        {id: "c", text: "Tylko w szkole", isCorrect: false},
                        {id: "d", text: "Jak mama każe się uczyć", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q2",
                    type: "true-false",
                    question: "Nauka poprzez dociekanie polega na tworzeniu pytań, które nas ciekawią, a następnie odpowiadanie na nie.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q3",
                    type: "multiple-choice",
                    question: "Jaki jest jeden z głównych powodów, dla których mapy myśli są istotne?",
                    options: [
                        {id: "a", text: "Pomagają pisać dłuższe notatki", isCorrect: false},
                        {id: "b", text: "Utrudniają zapamiętywanie, ale porządkują wiedzę", isCorrect: false},
                        {id: "c", text: "Jasno pokazują powiązania między tematami", isCorrect: true},
                        {id: "d", text: "Zastępują naukę i rozumienie tematu", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q4",
                    type: "multiple-choice",
                    question: "Od czego powinno się zaczynać tworzenie mapy myśli?",
                    options: [
                        {id: "a", text: "Od szczegółów i przykładów", isCorrect: false},
                        {id: "b", text: "Od ogółu, przechodząc do szczegółu", isCorrect: true},
                        {id: "c", text: "Od definicji i wzorów", isCorrect: false},
                        {id: "d", text: "Od spisywania pełnych zdań", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q5",
                    type: "fill",
                    question: "Stan ___ to pełne zaangażowanie w zadanie, podczas którego tracimy poczucie czasu.",
                    correctAnswer: "flow"
                },
                {
                    id: "v2w5q6",
                    type: "multiple-choice",
                    question: "Ile powiązań między zagadnieniami powinna mieć mapa myśli według zasad z prezentacji?",
                    options: [
                        {id: "a", text: "1-2", isCorrect: false},
                        {id: "b", text: "2–4", isCorrect: true},
                        {id: "c", text: "5-8", isCorrect: false},
                        {id: "d", text: "Dowolnie dużo", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q7",
                    type: "true-false",
                    question: "Skuteczna nauka polega na tym, żeby od razu przejść do rozwiązywania losowych zadań bez ogarniania działu.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
                {
                    id: "v2w5q8",
                    type: "multiple-choice",
                    question: "Jakie pytanie warto sobie zadawać, gdy poznajesz nowe definicje/wzory/zagadnienia?",
                    options: [
                        {id: "a", text: "Czy to będzie na sprawdzianie?", isCorrect: false},
                        {id: "b", text: "Jak to wygląda w teorii?", isCorrect: false},
                        {id: "c", text: "Jak wykorzystać to w praktyce?", isCorrect: true},
                        {id: "d", text: "Czy mogę to przepisać z zeszytu?", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q9",
                    type: "true-false",
                    question: "Emocje wzmacniają zapamiętywanie informacji.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q10",
                    type: "multiple-choice",
                    question: "Co pomaga w osiągnięciu stanu flow?",
                    options: [
                        {id: "a", text: "Multitasking", isCorrect: false},
                        {id: "b", text: "Wyeliminowanie rozpraszaczy i jasny cel", isCorrect: true},
                        {id: "c", text: "Bardzo łatwe zadania", isCorrect: false},
                        {id: "d", text: "Włączenie wszystkich powiadomień, żeby być na bieżąco", isCorrect: false}
                    ]
                }
            ]
        }
    },
    {
        title: "Poziom wyżej",
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1152167078",
                description: "Odcinek organizacyjny i pokazujący, czego dokładnie spodziewać się w piątym tygodniu."
            },
            {
                title: "Wygrywaj każdego dnia",
                vimeoUrl: "https://vimeo.com/1152167135",
                description: "W tym filmie zajmiemy się tematem dziennika i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego prowadzenie dziennika jest istotne.</li>" +
                    "<li>W jaki sposób prowadzić dziennik.</li>" +
                    "<li>Porównanie dziennika i Cyklu Kolba.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Przykładowa forma ustrukturyzowana",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W6E2-Przykladowa-forma-ustrukturyzowana-dziennik.pdf"
                    }
                ],
                tasks: [
                    "Określiłem/am sposób, w jaki chcę prowadzić dziennik."
                ]
            },
            {
                title: "Bądź sobą",
                vimeoUrl: "https://vimeo.com/1152168021",
                description: "W tym filmie zajmiemy się tematem spójności i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym jest spójność i dlaczego działanie w spójności (w zgodzie ze sobą) jest istotne.</li>" +
                    "<li>Przykład osób o wysokiej i o niskiej spójności.</li>" +
                    "<li>Jak osiągnąć spójność.</li>" +
                    "</ul>",
            },
            {
                title: "Z kim się przystajesz takim się stajesz",
                vimeoUrl: "https://vimeo.com/1152168472",
                description: "W tej lekcji dowiesz się o wpływie otoczenia na Twój rozwój i życie. <br/><br/>" +
                    "Kluczowe wnioski:" +
                    "<ul>" +
                    "<li>Jesteśmy średnią 5 osób, z którymi spędzamy najwięcej czasu</li>" +
                    "<li>Otoczenie wpływa na nasze nawyki, przekonania i cele</li>" +
                    "<li>Ważne jest świadome budowanie swojego środowiska</li>" +
                    "<li>Nie musisz rezygnować ze starych znajomych, ale buduj nowe relacje z inspirującymi ludźmi</li>" +
                    "</ul>"
            },
            {
                title: "Obraz siebie",
                vimeoUrl: "https://vimeo.com/1152170990",
                description: "W tym filmie zajmiemy się tematem obrazu siebie i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Jak postrzeganie siebie wpływa na Twoją rzeczywistość.</li>" +
                    "<li>Istota samooceny i wiary w swoje możliwości.</li>" +
                    "<li>W jaki sposób skutecznie pracować nad swoją samooceną.</li>" +
                    "</ul>",
            },
            {
                title: "Rola przekonań",
                vimeoUrl: "https://vimeo.com/1152171228",
                description: "W tym filmie zajmiemy się tematem przekonań i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Czym są przekonania i dlaczego są istotne.</li>" +
                    "<li>Jak pracować nad swoimi przekonaniami.</li>" +
                    "<li>Jak przekonania Twoich bliskich wpływają na Ciebie.</li>" +
                    "<li>Przykład przekonań w kontekście postanowień noworocznych.</li>" +
                    "<li>Jak skutecznie zmienić swój \"stan\".</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Afirmacje Cheat-Sheet",
                        link: "https://docs.google.com/document/d/1b4nw4a8wLAehG8wV8EcX00AbV3cqsDwZ4Gye_8fmFog/edit?usp=sharing"
                    },
                    {
                        title: "Zmiana stanu - Przykład z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W6E6-Zmiana-stanu-nauka.pdf"
                    }
                ],
                tasks: [
                    "Zidentyfikowałem/am przekonania, które chcę zmienić - i zaczynam wdrażać w życie zmiany."
                ]
            },
            {
                title: "Myśl jak zwycięzca",
                vimeoUrl: "https://vimeo.com/1152169983",
                description: "W tym filmie zajmiemy się naszym sposobem myślenia i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Jak myślą najlepsi.</li>" +
                    "<li>Jak to wykorzystać na swoją korzyść.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Myśl jak zwycięzca - Ćwiczenie z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W6E7-Mysl-jak-zwyciezca-cwiczenie.pdf"
                    }
                ],
                tasks: [
                    "Wykonałem/am ćwiczenie z filmu przynajmniej raz."
                ]
            },
            {
                title: "Podsumowanie Kursu",
                vimeoUrl: "https://vimeo.com/1152170178",
                description: "Gratulacje! <br/><br/>" +
                    "Dziękuję Ci za wspólną podróż i życzę Ci powodzenia! Masz już wszystko, czego potrzebujesz, aby stać się najlepszą wersją siebie."
            },
            {
                title: "Co dalej?",
                vimeoUrl: "",
                description: "Jeszcze raz gratuluję ukończenia całego Kursu! 🔥🎉<br/> <i>(pssst... jest jeszcze bonusowy tydzień)</i><br/><br/>" +
                    "Następne kroki:" +
                    "<ul>" +
                    "<li>Kontynuuj nawyki, które zbudowałeś/aś.</li>" +
                    "<li>Wracaj do materiałów z Kursu, gdy czujesz, że tego potrzebujesz.</li>" +
                    "<li>Nawiązuj nowe znajomości na społeczności na Discordzie.</li>" +
                    "<li>Jeżeli tylko pojawią się jakieś pytania, śmiało bierz udział w cotygodniowych spotkaniach online.</li>" +
                    "<li>Dziel się swoimi postępami.</li>" +
                    "<li>Pomagaj innym - ucząc innych, sam/a się uczysz</li>" +
                    "</ul>" +
                    "<br/><b>Pamiętaj: To nie koniec, to dopiero początek!</b>",
            },
            {
                title: "Odblokuj bonusowy tydzień!",
                vimeoUrl: "",
                description: "Mamy dla Ciebie niespodziankę - <b>Tydzień Bonusowy!</b><br/><br/>" +
                    "Aby odblokować dostęp do dodatkowych materiałów, podziel się z nami swoją opinią o kursie. " +
                    "Twoja recenzja pomoże nam ulepszać kurs, a Tobie da dostęp do ekskluzywnych bonusowych lekcji!<br/><br/>" +
                    "<b>Co musisz zrobić:</b><br/>" +
                    "<ol>" +
                    "<li>Oceń kurs (1-5 gwiazdek)</li>" +
                    "<li>Napisz swoją opinię na temat Kursu (minimum 250 znaków)</li>" +
                    "<li>Kliknij 'Odblokuj tydzień bonusowy'</li>" +
                    "</ol>",
                showTestimonialForm: true
            }
        ],
        quiz: {
            title: "Quiz - Poziom wyżej",
            passingScore: 70,
            questions: [
                {
                    id: "v2w6q1",
                    type: "multiple-choice",
                    question: "Na czym polega journaling?",
                    options: [
                        {id: "a", text: "Na czytaniu książek o rozwoju", isCorrect: false},
                        {id: "b", text: "Na spisywaniu myśli, odczuć, planów i przeżyć", isCorrect: true},
                        {id: "c", text: "Na uczeniu się na pamięć notatek", isCorrect: false},
                        {id: "d", text: "Na planowaniu wyłącznie celów sportowych", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q2",
                    type: "multiple-choice",
                    question: "Jakie są korzyści z prowadzenia dziennika?",
                    options: [
                        {id: "a", text: "Tylko śledzenie postępów", isCorrect: false},
                        {
                            id: "b",
                            text: "Budowanie świadomości, przetwarzanie emocji, śledzenie postępów i rozwijanie wdzięczności",
                            isCorrect: true
                        },
                        {id: "c", text: "Tylko pisanie o problemach", isCorrect: false},
                        {id: "d", text: "Nie ma żadnych korzyści", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q3",
                    type: "multiple-choice",
                    question: "Jaki najłatwiej wykształcić w sobie nawyk pisania w dzienniku?",
                    options: [
                        {id: "a", text: "Zaczynać od bardzo długich wpisów", isCorrect: false},
                        {id: "b", text: "Pisać tylko wtedy, kiedy masz zły humor", isCorrect: false},
                        {id: "c", text: "Unikać stałej rutyny", isCorrect: false},
                        {
                            id: "d",
                            text: "Zaczynać od notatek ustrukturyzowanych (np. rano i wieczorem)",
                            isCorrect: true
                        }
                    ]
                },
                {
                    id: "v2w6q4",
                    type: "multiple-choice",
                    question: "Czym jest spójność?",
                    options: [
                        {id: "a", text: "Byciem zawsze miłym dla innych", isCorrect: false},
                        {id: "b", text: "Robieniem tego, co robi większość", isCorrect: false},
                        {
                            id: "c",
                            text: "Harmonią między wartościami, przekonaniami, emocjami i działaniami",
                            isCorrect: true
                        },
                        {id: "d", text: "Zawsze osiąganiem sukcesów", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q5",
                    type: "true-false",
                    question: "Przekonania są zawsze obiektywne i prawdziwe.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
                {
                    id: "v2w6q6",
                    type: "multiple-choice",
                    question: "Na co wpływa Twoje otoczenie?",
                    options: [
                        {id: "a", text: "Tylko na wyniki w nauce", isCorrect: false},
                        {id: "b", text: "Na wartości, motywację, nawyki i emocje", isCorrect: true},
                        {id: "c", text: "Tylko na zainteresowania", isCorrect: false},
                        {id: "d", text: "Wyłącznie na zdolności fizyczne", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q7",
                    type: "true-false",
                    question: "Wysoka samoocena oznacza, że nie popełniasz błędów i nie doświadczasz porażek.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: false},
                        {id: "false", text: "Fałsz", isCorrect: true}
                    ]
                },
                {
                    id: "v2w6q8",
                    type: "multiple-choice",
                    question: "Jakie zachowanie jest charakterystyczne dla niskiej samooceny?",
                    options: [
                        {id: "a", text: "Unikanie wyzwań i krytyczny wewnętrzny głos", isCorrect: true},
                        {id: "b", text: "Otwartość na wyzwania i akceptacja porażek", isCorrect: false},
                        {id: "c", text: "Pewność w działaniu i stabilność emocjonalna", isCorrect: false},
                        {id: "d", text: "Umiejętność podejmowania ryzyka bez stresu", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q9",
                    type: "true-false",
                    question: "Przekonania działają jak filtry, przez które postrzegasz świat.",
                    options: [
                        {id: "true", text: "Prawda", isCorrect: true},
                        {id: "false", text: "Fałsz", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q10",
                    type: "multiple-choice",
                    question: "Przekonania to:",
                    options: [
                        {id: "a", text: "Fakty na temat świata", isCorrect: false},
                        {id: "b", text: "Emocje pojawiające się chwilowo", isCorrect: false},
                        {id: "c", text: "Cele i plany na przyszłość", isCorrect: false},
                        {
                            id: "d",
                            text: "Głęboko zakorzenione opinie i wierzenia o sobie, świecie i innych",
                            isCorrect: true
                        }
                    ]
                }
            ]
        }
    },
    // Bonus week - only visible after bonusWeekUnlocked
    {
        title: "Tydzień Bonusowy",
        isBonus: true,
        episodes: [
            {
                title: "Przedstawienie tygodnia",
                vimeoUrl: "https://vimeo.com/1153905904",
                description: "Gratulacje! Tydzień bonusowy został odblokowany!<br/><br/>" +
                    "W tym filmie pokażę Ci, czego się spodziewać oraz czego się nauczysz :)",
                showNotes: true
            },
            {
                title: "Rola snu",
                vimeoUrl: "https://vimeo.com/1153905612",
                description: "W tym filmie przyjrzymy się tematowi snu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego sen jest istotny.</li>" +
                    "<li>Sposoby na optymalizację snu i poprawienie jego jakości.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Sposoby na optymalizację snu (Cheat-Sheet)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W7E2-Sposoby-na-optymalizacje-snu.pdf"

                    }
                ],
                showNotes: true
            },
            {
                title: "Rola jedzenia",
                vimeoUrl: "https://vimeo.com/1153905825",
                description: "W tym filmie przyjrzymy się tematowi jedzenia i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>W jaki sposób jedzenie na Ciebie wpływa.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "</ul>" +
                    "Naszym celem jest przede wszystkim zbudowanie świadomości.",
                showNotes: true
            },
            {
                title: "Rola sportu",
                vimeoUrl: "https://vimeo.com/1153906114",
                description: "W tym filmie przyjrzymy się tematowi sportu i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego uprawianie sportu jest istotne.</li>" +
                    "<li>Obalanie błędnych przekonań na temat sportu.</li>" +
                    "<li>Jak wdrożyć sport do swojej rutyny.</li>" +
                    "<li>Na co zwracać uwagę.</li>" +
                    "</ul>",
                showNotes: true
            },
            {
                title: "Rola odpoczynku",
                vimeoUrl: "https://vimeo.com/1153905943",
                description: "W tym filmie przyjrzymy się tematowi odpoczynku i omówimy sobie:<br/>" +
                    "<ul>" +
                    "<li>Dlaczego odpoczynek jest istotny.</li>" +
                    "<li>Różnice między \"aktywnym\" a \"pasywnym\" odpoczynkiem.</li>" +
                    "<li>Jak aktywnie odpoczywać.</li>" +
                    "<li>Jak wdrożyć odpoczynek do swojej codziennej rutyny.</li>" +
                    "</ul>" +
                    "Trudno jest Ci odpoczywać? Pamiętaj, że odpoczynek to nie luksus, to <b>konieczność</b>.",
                showNotes: true
            },
            {
                title: "Dodatkowe materiały",
                vimeoUrl: "",
                description: "Jeżeli chcesz dalej rozwijać swoje umiejętności Efektywnego Działania, poniżej znajdziesz kilka przydanych narzędzi.<br/><br/>" +
                    "<ol>" +
                    "<li><a href='https://www.youtube.com/@produkacja' class='text-success text-decoration-underline'>Kanał na YouTube</a>, gdzie co tydzień udostępniamy materiały związane z działaniem.</li> <br/>" +
                    "<li><a href='https://www.youtube.com/@riandoris/videos' class='text-success text-decoration-underline'>Kanał na YouTube</a>, który porusza tematy związane z wysoką wydajnością</li> <br/>" +
                    "<li><a href='https://www.scotthyoung.com/blog/ultralearning/' class='text-success text-decoration-underline'>Książka <i>\"Ultralearning\"</i></a> wchodząca w jeszcze większe szczegóły na temat efektywnej nauki. </li> <br/>" +
                    "<li><a href='https://www.brain.fm/produkacja' class='text-success text-decoration-underline'>Aplikacja <i>\"Brain.FM\"</i></a>, która pomaga w skupieniu się i efektywnej nauce. </li>" +
                    "</ol>" +
                    "<br/>Z czasem będziemy rozszerzać tę bazę materiałów :)"
            },
            {
                title: "Podziękowanie",
                vimeoUrl: "",
                description: "Gratulacje! Tydzień bonusowy został ukończony.<br/><br/>" +
                    "Dziękujemy za Twoją opinię o kursie i życzymy powodzenia w dalszej nauce!"
            }
        ]
    }
] as LearningCourseWeek[]

export const easCourseStructure = [
    {
        title: "Getting Started",
        episodes: [
            {
                title: "Welcome",
                vimeoUrl: "https://vimeo.com/1141415569",
                description: "Welcome to the Effective Action System!<br/><br/>" +
                    "In this video, I'll show you what to expect from the Course. You'll learn what you'll be studying and what results you can achieve. <br/><br/>" +
                    "<b>Task:</b> Write down your expectations for the Course in the notes. What do you want to achieve?",
                attachFiles: true,
                showNotes: true,
                tasks: [
                    "I wrote down my expectations for the Course",
                    "I defined what I want to achieve"
                ]
            },
            {
                title: "What to expect?",
                vimeoUrl: "https://vimeo.com/1140733830",
                description: "In this lesson, you'll learn what to expect from the Course. <br/><br/>" +
                    "We'll cover" +
                    "<ul>" +
                    "<li>What does the Effective Action System look like?</li>" +
                    "<li>Where should you start?</li>" +
                    "<li>How to see results as fast as possible?</li>" +
                    "<li>What sets apart people who get 100% out of the Course?</li>" +
                    "<li>Most common mistakes and how to avoid them</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Weekly meetings",
                        link: "/produkt/spolecznosc/spotkania"
                    },
                    {
                        title: "Discord",
                        link: "/produkt/spolecznosc"
                    }
                ],
            },
            {
                title: "Platform overview",
                vimeoUrl: "https://vimeo.com/1141622155",
                description: "In this lesson, you'll learn where to find help and how to use the educational platform.",
                tasks: [
                    "I joined the Discord server",
                    "I signed up for the weekly meeting (optional, but worth checking out :))"
                ],
                resources: [
                    {
                        title: "Weekly meetings",
                        link: "/produkt/spolecznosc/spotkania"
                    },
                    {
                        title: "Discord",
                        link: "/produkt/spolecznosc"
                    }
                ],
            },
            {
                title: "Collection of additional tools",
                vimeoUrl: "",
                description: "Here you'll find additional tools that will help you in your daily life and that we'll discuss later in the Course. <br/>" +
                    "<ul>" +
                    "<li><b>Freedom</b> - blocking distracting websites and apps</li>" +
                    "<li><b>Brain.FM</b> - music that supports concentration</li>" +
                    "<li><b>OneSec</b> - an app that helps reduce time spent on social media</li>" +
                    "</ul>" +
                    "You don't have to use all of them - choose the ones that are most useful for you.",
                resources: [
                    {
                        title: "Freedom App",
                        link: "https://freedom.to/"
                    },
                    {
                        title: "Brain.FM",
                        link: "https://www.brain.fm/produkacja"
                    },
                    {
                        title: "OneSec",
                        link: "https://web.one-sec.app/store?deal=tsjn9c"
                    },
                ],
            },
            {
                title: "Collection of additional materials",
                vimeoUrl: "",
                description: "Here you'll find additional materials that can help you with your daily learning and performing well on exams. <br/><br/>" +
                    "<ul>" +
                    "<li><b>Prometeusze Fizyki</b> - An original physics program by an Oxford graduate that teaches physics from absolute zero, restoring faith in a great score even for those who have long lost hope of understanding the subject. <br/><br/> Instead of mindless formula memorization, the Course focuses on building rock-solid intuition and logical thinking, explaining difficult phenomena using examples from video games and pop culture.</li>" +
                    "<br/><li><b>Produkacja YouTube</b> - Our official YouTube channel, where we share a new dose of knowledge every week. The videos can be a great complement to the Course material. </li>" +
                    "<br/><li><b>Produkacja Educational Platform</b> - A collection of tools that will help you with daily, systematic learning. You already have basic access to it. </li>" +
                    "</ul>" +
                    "<br/>These are of course additional recommendations - you don't have to use them. More materials will appear here over time.",
                resources: [
                    {
                        title: "Prometeusze Fizyki",
                        link: "https://prometeuszefizyki.pl/produkacja/"
                    },
                    {
                        title: "Produkacja YouTube",
                        link: "https://www.youtube.com/@produkacja//"
                    },
                    {
                        title: "Produkacja Educational Platform",
                        link: "/produkt"
                    },
                ],
            }
        ]
    },
    {
        title: "Self-Awareness & Environment",
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1141620980",
                description: "This is an organizational episode showing what exactly to expect from the first week. ",
            },
            {
                title: "Awareness - why does it matter?",
                vimeoUrl: "https://vimeo.com/1140697081",
                description: "In this lesson, you'll learn what awareness is and why it's crucial for effective action.",
            },
            {
                title: "BEST Self - Your ideal version",
                vimeoUrl: "https://vimeo.com/1140696975",
                description: "In this lesson, we'll go through a key exercise - creating your BEST Self document. <br/><br/>" +
                    "You'll define:" +
                    "<ul>" +
                    "<li>Who you are now (your current self)</li>" +
                    "<li>Who you want to become (your ideal self)</li>" +
                    "<li>What changes are necessary to get there</li>" +
                    "</ul>" +
                    "<b>This exercise is key for the entire Course - give it plenty of time!</b>",
                attachFiles: true,
                resources: [
                    {
                        link: 'https://docs.google.com/document/d/1muaPqx4UlmK9taEOqH4Qxw8pWY-Eo317eyNV_bo-sL8/edit?usp=sharing',
                        title: 'Best version of yourself (Basic version)'
                    },
                    {
                        link: 'https://docs.google.com/document/d/1H_ogNwmD6PN27LEvW-4_itdbP339IJJ2iQI8afWsooQ/edit?usp=sharing',
                        title: 'Best version of yourself (Extended version)'
                    }
                ],
                tasks: [
                    "I described my current self",
                    "I described my ideal self",
                    "I identified key changes to implement"
                ]
            },
            {
                title: "Environment that supports learning",
                vimeoUrl: "https://vimeo.com/1140697512",
                description: "In this lesson, you'll learn how to create an environment that supports learning and effective action. <br/><br/>" +
                    "I'll show you:" +
                    "<ul>" +
                    "<li>How to create a productive workspace</li>" +
                    "<li>What to pay attention to</li>" +
                    "</ul>" +
                    "<b>Task:</b> Optimize your environment according to the tips from the video.",
                tasks: [
                    "I organized my desk and removed unnecessary items",
                    "I removed distractions from my surroundings"
                ]
            },
            {
                title: "Phone optimization",
                vimeoUrl: "https://vimeo.com/1140696708",
                description: "In this lesson, you'll learn how to optimize your phone so it doesn't distract you during work or studying. <br/><br/>" +
                    "<b>Task:</b> Test the suggested changes on your phone.",
                tasks: [
                    "I turned off unnecessary notifications",
                    "I cleaned up my home screen",
                ],
                resources: [
                    {
                        title: "Freedom App",
                        link: "https://freedom.to/"
                    },
                    {
                        title: "OneSec",
                        link: "https://one-sec.app/"
                    },
                    {
                        title: "OneSec (1 month pro free)",
                        link: "https://web.one-sec.app/store?deal=tsjn9c"
                    },
                ],
            },
            {
                title: "Computer optimization",
                vimeoUrl: "https://vimeo.com/1140696461",
                description: "In this lesson, you'll learn how to optimize your computer for effective work and learning. <br/><br/>" +
                    "In the resources section, you'll find a cheat-sheet with all the discussed extensions.",
                tasks: [
                    "I turned off app notifications",
                    "I installed the suggested extensions",
                ],
                resources: [
                    {
                        title: "List of extensions",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W1E6-rozszerzenia-przegladarka.pdf"
                    }
                ]
            },
            {
                title: "Domination Plan",
                vimeoUrl: "https://vimeo.com/1140697983",
                description: "In this lesson, you'll learn how to use the Domination Plan - your personal tool for planning your time.<br/><br/>" +
                    "It has been integrated with our educational platform and is 100% free for you forever. <br/><br/>" +
                    "<b>Task:</b> Plan the upcoming days/weeks.",
                tasks: [
                    "I wrote down the most important activities for the upcoming days in the Domination Plan"
                ],
                resources: [
                    {
                        title: "Domination Plan",
                        link: "/produkt/plan-dominacji"
                    }
                ]
            },
            {
                title: "The role of our mindset",
                vimeoUrl: "https://vimeo.com/1140697154",
                description: "In this lesson, you'll learn about the differences between Fixed Mindset and Growth Mindset. <br/><br/>" +
                    "You'll understand:" +
                    "<ul>" +
                    "<li>Why our mindset matters</li>" +
                    "<li>How <i>Fixed Mindset</i> differs from <i>Growth Mindset</i></li>" +
                    "<li>How to work with your mindset</li>" +
                    "</ul>" +
                    "Growth Mindset is essential to get through the entire Course and achieve top results!",
            },
            {
                title: "The small wins technique",
                vimeoUrl: "https://vimeo.com/1140697857",
                description: "In this lesson, you'll learn how to win every day in just a few minutes. <br/><br/>" +
                    "What we'll cover:" +
                    "<ul>" +
                    "<li>What are marginal gains (Introduction, continuation in the following weeks)</li>" +
                    "<li>A daily 5-minute ritual that will strengthen your self-esteem and motivation</li>" +
                    "</ul>" +
                    "This is a simple technique that helps build momentum and awareness of your own progress.",
                attachFiles: true
            }
        ],
        quiz: {
            title: "Quiz - Self-Awareness & Environment",
            passingScore: 70,
            questions: [
                {
                    id: "v2w1q1",
                    type: "multiple-choice",
                    question: "What does 'Growth Mindset' mean?",
                    options: [
                        {
                            id: "a",
                            text: "The belief that our abilities are fixed and cannot be changed",
                            isCorrect: false
                        },
                        {
                            id: "b",
                            text: "The belief that we can develop our abilities through work and learning",
                            isCorrect: true
                        },
                        {id: "c", text: "Focusing only on achieving quick results", isCorrect: false},
                        {id: "d", text: "Avoiding challenges to prevent making mistakes", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q3",
                    type: "true-false",
                    question: "Optimizing your environment (phone, computer, desk) has a big impact on effectiveness.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q4",
                    type: "multiple-choice",
                    question: "What should be included in the 'Domination Plan'?",
                    options: [
                        {id: "a", text: "Only long-term goals", isCorrect: false},
                        {id: "b", text: "Short- and long-term goals along with specific actions", isCorrect: true},
                        {id: "c", text: "Only a to-do list for today", isCorrect: false},
                        {id: "d", text: "A sleep schedule", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q5",
                    type: "true-false",
                    question: "The small wins technique involves daily recording of what went well and what can be improved.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q6",
                    type: "multiple-choice",
                    question: "Consistency is more important than intensity because:",
                    options: [
                        {
                            id: "a",
                            text: "Regular small actions produce better results than rare intense sessions",
                            isCorrect: true
                        },
                        {id: "b", text: "You don't have to try as hard then", isCorrect: false},
                        {id: "c", text: "You can avoid difficult tasks that way", isCorrect: false},
                        {id: "d", text: "It allows for procrastination", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q7",
                    type: "true-false",
                    question: "Awareness is the foundation on which we build all other effective action skills.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w1q10",
                    type: "true-false",
                    question: "Fixed Mindset supports growth and helps achieve goals.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                }
            ]
        }
    },
    {
        title: "Foundations of Effective Action",
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1143197692",
                description: "This is an organizational episode showing what exactly to expect from the second week. ",
            },
            {
                title: "Stop procrastinating",
                vimeoUrl: "https://vimeo.com/1143197287",
                description: "In this lesson, we'll discuss the topic of procrastination and show you what you can do to finally start acting consistently, without relying on motivation. <br/><br/>",
                resources: [
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W2E2-notatki-prokrastynacja.pdf",
                        title: "Notes from the video"
                    }
                ]
            },
            {
                title: "Anti-procrastination techniques",
                vimeoUrl: "https://vimeo.com/1143197035",
                description: "In this lesson, we'll discuss 5 techniques that will effectively help you fight procrastination."
            },
            {
                title: "Concentration",
                vimeoUrl: "https://vimeo.com/1143196638",
                description: "In this lesson, you'll learn how to improve your concentration and maintain focus for longer periods without constantly getting distracted.",
                resources: [
                    {
                        title: "Cheat-Sheet: What improves concentration?",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W2E4-poprawa-koncentracji-cheat-sheet.pdf"
                    },
                    {
                        title: "Brain.FM",
                        link: "https://www.brain.fm/produkacja"
                    },
                ]
            },
            {
                title: "Setting priorities",
                vimeoUrl: "https://vimeo.com/1143196411",
                tasks: [
                    "I defined my priorities for the near future",
                ],
                description: "In this lesson, we'll dive into the topic of setting priorities.<br/><br/>" +
                    "We'll go through the Eisenhower Matrix in detail, categorizing tasks as IMPORTANT / URGENT, and show you what to pay attention to when planning.",
            },
            {
                title: "Time awareness",
                vimeoUrl: "https://vimeo.com/1143196050",
                description: "In this lesson, we'll discuss the 'Time awareness' worksheet and the 'Power map' - what they are and how to apply them in practice. After completing these exercises, you'll regain control over your time.",
                attachFiles: true,
                tasks: [
                    "I started building my time awareness",
                    "I completed my time awareness exercise, then drew conclusions using the Power Map",
                ],
                resources: [
                    {
                        title: "'Time awareness' worksheet",
                        link: 'https://docs.google.com/spreadsheets/d/1GnxxyYwwpZ1-56YhCC1Ek7zLoTMs2hw99yjonX6cpsU/edit?usp=sharing'
                    },
                    {
                        title: "'Power map' worksheet",
                        link: "https://docs.google.com/spreadsheets/d/1OVvW0Ntq7kbMgzR9Ci7HoaYJiM4bFaEvsFmNOG4rFcg/edit?usp=sharing"
                    }
                ]
            },
            {
                title: "Sleep chronotypes",
                vimeoUrl: "https://vimeo.com/1143195624",
                description: "In this video, we'll look at the topic of sleep chronotypes and discuss:<br/>" +
                    "<ul>" +
                    "<li>What sleep chronotypes are.</li>" +
                    "<li>Determining your chronotype.</li>" +
                    "<li>Characterizing each chronotype.</li>" +
                    "</ul>" +
                    "In the resources section, you'll find a link to a chronotype test and a more detailed description of each one.",
                attachFiles: true,
                tasks: [
                    "I determined my sleep chronotype",
                    "I reviewed the cheat-sheet for my sleep chronotype"
                ],
                resources: [
                    {
                        title: "Chronotype test",
                        link: "https://produkacja.pl/chronotypy"
                    },
                    {
                        title: "DOLPHIN chronotype",
                        link: "https://docs.google.com/document/d/1mn_wWiWHqDOwST20XQyaHf7vYk8Xw4LfM1KMdHrTkKM/edit?usp=sharing",
                    },
                    {
                        title: "LION chronotype",
                        link: "https://docs.google.com/document/d/1KO_UpB_KPn3IlIoMaAsNTCqgxUMdMRM4AVk0KBEZvAk/edit?usp=sharing"
                    },
                    {
                        title: "BEAR chronotype",
                        link: "https://docs.google.com/document/d/1qSwgBKCW6TzPKLZLa0udIL05b8vFErQNYHGUX4sBB2M/edit?usp=sharing"
                    },
                    {
                        title: "WOLF chronotype",
                        link: "https://docs.google.com/document/d/1_7l1ElBPG9o4yAz21ImC943YO-9kJ-DOW1XgdiPztmQ/edit?usp=sharing"
                    },
                ]
            },
            {
                title: "Marginal gains",
                vimeoUrl: "https://vimeo.com/1143393395",
                description: "In this lesson, we'll focus on marginal gains - small changes that, when stacked over time, produce massive results in the long run. <br/><br/>" +
                    "We'll cover the following topics:" +
                    "<ul>" +
                    "<li>An example of marginal gains based on the story of British cyclists.</li>" +
                    "<li>What marginal gains are.</li>" +
                    "<li>Why marginal gains matter.</li>" +
                    "<li>How to measure marginal gains.</li>" +
                    "</ul>",
                tasks: [
                    "I defined my long-term goal, determined my current and target level, and am now working on finding the 1%."
                ],
                attachFiles: true,
                resources: [
                    {
                        title: "The story of British cyclists (for those interested)",
                        link: "https://jamesclear.com/marginal-gains"
                    },
                    {
                        title: "Cheat-Sheet: Measuring marginal gains",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W2E8-mierzenie-marginalnych-zyskow.pdf"
                    }
                ]
            },
            {
                title: "Kolb's Cycle",
                vimeoUrl: "https://vimeo.com/1143195151",
                description: "In this lesson, we'll thoroughly understand Kolb's Cycle.<br/><br/>" +
                    "We'll cover the following topics:" +
                    "<ul>" +
                    "<li>What Kolb's Cycle is and why it matters.</li>" +
                    "<li>How to create a Kolb's Cycle.</li>" +
                    "<li>An example of Kolb's Cycle.</li>" +
                    "</ul>" +
                    "After completing this lesson, <b>your task will be to create at least two Kolb's Cycles</b>. ",
                attachFiles: true,
                tasks: [
                    "I created at least two of my own Kolb's Cycles"
                ],
                resources: [
                    {
                        title: "Kolb's Cycle - Cheat Sheet",
                        link: 'https://docs.google.com/document/d/1bsmkEtrmOgDHhBmo5MYiRo0duydQIP9btpFDDtLJ468/edit?usp=sharing'
                    },
                    {
                        title: "Another example of Kolb's Cycle",
                        link: 'https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/Przyk%C5%82ad+Cyklu+Kolba+z+filmu.pdf'
                    },
                    {
                        title: "Examples of other Kolb's Cycles (blog)",
                        link: 'https://produkacja.pl/blog/2i5Lz6X464cb7STIj8W75WMKfA7'
                    }
                ]
            },
        ],
        quiz: {
            title: "Quiz - Foundations of Effective Action",
            passingScore: 70,
            questions: [
                {
                    id: "v2w2q1",
                    type: "multiple-choice",
                    question: "Why are habits better than motivation?",
                    options: [
                        {id: "a", text: "Because they are easier to build", isCorrect: false},
                        {
                            id: "b",
                            text: "Because they work regardless of whether we feel motivated",
                            isCorrect: true
                        },
                        {id: "c", text: "Because they don't require any effort", isCorrect: false},
                        {id: "d", text: "Because motivation doesn't work at all", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q2",
                    type: "true-false",
                    question: "Concentration is a skill that can be trained like a muscle.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q3",
                    type: "multiple-choice",
                    question: "What is the best way to deal with large, overwhelming tasks?",
                    options: [
                        {id: "a", text: "Put them off for later", isCorrect: false},
                        {id: "b", text: "Break them down into smaller, easier-to-complete parts", isCorrect: true},
                        {id: "c", text: "Only do them when you feel motivated", isCorrect: false},
                        {id: "d", text: "Ignore them completely", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q4",
                    type: "multiple-choice",
                    question: "In the Eisenhower Matrix, which tasks should we do first?",
                    options: [
                        {id: "a", text: "Important and urgent", isCorrect: true},
                        {id: "b", text: "Unimportant and urgent", isCorrect: false},
                        {id: "c", text: "Important and not urgent", isCorrect: false},
                        {id: "d", text: "Unimportant and not urgent", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q5",
                    type: "multiple-choice",
                    question: "How many sleep chronotypes do we distinguish?",
                    options: [
                        {id: "a", text: "2", isCorrect: false},
                        {id: "b", text: "3", isCorrect: false},
                        {id: "c", text: "4", isCorrect: true},
                        {id: "d", text: "5", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q6",
                    type: "true-false",
                    question: "Marginal gains are small changes that produce massive results in the long run.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q7",
                    type: "multiple-choice",
                    question: "How many steps does Kolb's Cycle have?",
                    options: [
                        {id: "a", text: "2", isCorrect: false},
                        {id: "b", text: "3", isCorrect: false},
                        {id: "c", text: "4", isCorrect: true},
                        {id: "d", text: "5", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q8",
                    type: "multiple-choice",
                    question: "What is the purpose of 'Time awareness'?",
                    options: [
                        {id: "a", text: "To plan meals", isCorrect: false},
                        {
                            id: "b",
                            text: "To become aware of exactly how we spend our time",
                            isCorrect: true
                        },
                        {id: "c", text: "To write down life goals", isCorrect: false},
                        {id: "d", text: "To measure learning progress", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q9",
                    type: "multiple-choice",
                    question: "Which chronotype is characterized by the highest productivity in the morning?",
                    options: [
                        {id: "a", text: "Wolf", isCorrect: false},
                        {id: "b", text: "Bear", isCorrect: false},
                        {id: "c", text: "Lion", isCorrect: true},
                        {id: "d", text: "Dolphin", isCorrect: false}
                    ]
                },
                {
                    id: "v2w2q10",
                    type: "multiple-choice",
                    question: "What is NOT one of the 4 stages of Kolb's Cycle?",
                    options: [
                        {id: "a", text: "Reflection", isCorrect: false},
                        {id: "b", text: "Experience", isCorrect: false},
                        {id: "c", text: "Abstraction", isCorrect: false},
                        {id: "d", text: "Inquiry", isCorrect: true}
                    ]
                },
            ]
        }
    },
    {
        title: "Introduction to Effective Learning",
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1145197524",
                description: "An organizational episode showing what exactly to expect from the third week. ",
            },
            {
                title: "Fundamentals of Effective Learning",
                vimeoUrl: "https://vimeo.com/1145197571",
                description: "In this lesson, you'll learn the RRI method - one of the most effective ways to learn. <br/><br/>" +
                    "RRI stands for:" +
                    "<ul>" +
                    "<li><b>R</b>epetition</li>" +
                    "<li><b>R</b>etrieval</li>" +
                    "<li><b>I</b>nterleaving</li>" +
                    "</ul>" +
                    "In the following lessons, we'll discuss each element in detail.",
            },
            {
                title: "Spaced repetition",
                vimeoUrl: "https://vimeo.com/1145197642",
                description: "In this video, we'll cover the topic of reviews and discuss: <br/><br/>" +
                    "<ul>" +
                    "<li>What the forgetting curve is and how to fight it.</li>" +
                    "<li>How often you should do reviews.</li>" +
                    "<li>What to pay attention to during reviews.</li>" +
                    "</ul>",
                tasks: [
                    "I planned my reviews in the Domination Plan"
                ],
                resources: [
                    {
                        title: "Forgetting curve - Notes from the video",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E3-Krzywa+zapominania.png"
                    },
                    {
                        title: "Review frequency - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E3-cze%CC%A8stotliwos%CC%81c%CC%81-powto%CC%81rek.pdf"
                    }
                ]
            },
            {
                title: "Active recall",
                vimeoUrl: "https://vimeo.com/1145198077",
                description: "In this video, we'll cover the topic of retrieval and discuss: <br/><br/>" +
                    "<ul>" +
                    "<li>Why retrieval is important.</li>" +
                    "<li>Two principles of effective retrieval.</li>" +
                    "<li>The importance of sleep in the context of retrieval.</li>" +
                    "<li>The optimal way to plan studying before tests.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "The importance of sleep - Notes from the video",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E4-Istota+snu.png"
                    },
                    {
                        title: "Example study plan before a test - Notes from the video",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E4-Przyk%C5%82adowy+plan+nauki+przed+sprawdzianem.png"
                    }
                ]
            },
            {
                title: "Interleaving - techniques",
                vimeoUrl: "https://vimeo.com/1145198513",
                description: "In this lesson, we'll cover the topic of interleaving and discuss: <br/><br/>" +
                    "<ul>" +
                    "<li>What \"interleaving\" different techniques means.</li>" +
                    "<li>Which techniques can be used.</li>" +
                    "</ul>" +
                    "In the video, we'll briefly touch on the topic of mind maps, which we'll cover in more detail in week 5.",
                tasks: [
                    "I tested the techniques suggested in the video during my own study session"
                ],
                resources: [
                    {
                        title: "Which techniques can we interleave - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E5-Przeplatanie+ro%CC%81z%CC%87nych+technik.pdf"
                    }
                ]
            },
            {
                title: "Interleaving with AI",
                vimeoUrl: "https://vimeo.com/1145206758",
                description: "In this lesson, you'll learn how to use AI for interleaving and learning. ",
                tasks: [
                    "I tested the Educational Chat for interleaving."
                ],
                resources: [
                    {
                        title: "What can AI be used for - cheat sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E6-Do+czego+moz%CC%87na+wykorzystac%CC%81%C2%A0AI.pdf"
                    },
                    {
                        title: "Educational Chat (Tool from the video)",
                        link: "/produkt/chat"
                    }
                ]
            },
            {
                title: "SMART study planning",
                vimeoUrl: "https://vimeo.com/1145198782",
                description: "In this video, we'll look at the topic of \"SMART\" planning. <br/><br/>" +
                    "We'll cover the following topics:" +
                    "<ul>" +
                    "<li>What \"SMART\" planning is about.</li>" +
                    "<li>Examples of \"SMART\" goals and non-\"SMART\" goals.</li>" +
                    "<li>How to effectively set \"SMART\" goals.</li>" +
                    "<li>Bonus: Combining this with the Domination Plan.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "\"SMART\" Goals - Cheat Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E7-Cele+SMART.pdf"
                    },
                    {
                        title: "Helpful questions for creating \"SMART\" goals",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E7-Pytania+do+celo%CC%81w+SMART.pdf"
                    }
                ],
                tasks: [
                    "I planned my study sessions for the upcoming days using SMART goals",
                    "SMART goals have been added to the Domination Plan"
                ]
            },
            {
                title: "Study planning with AI",
                vimeoUrl: "https://vimeo.com/1145199255",
                description: "In this lesson, we'll show you how to use AI on the Produkacja platform for study planning. <br/><br/>" +
                    "The study planner will help you:" +
                    "<ul>" +
                    "<li>Plan studying for a specific test</li>" +
                    "<li>Spread the material across the right days</li>" +
                    "<li>Practice the material with specially tailored exercises</li>" +
                    "</ul>" +
                    "This tool plans everything for you!",
                resources: [
                    {
                        title: "Study planner",
                        link: "/produkt/planer-nauki"
                    }
                ]
            }
        ],
        quiz: {
            title: "Quiz - Introduction to Effective Learning",
            passingScore: 70,
            questions: [
                {
                    id: "v2w3q1",
                    type: "fill",
                    question: "RRI stands for: Repetition, Retrieval, and ___",
                    correctAnswer: "Interleaving"
                },
                {
                    id: "v2w3q2",
                    type: "multiple-choice",
                    question: "What are the recommended review intervals?",
                    options: [
                        {id: "a", text: "1 day, 2 days, 3 days", isCorrect: false},
                        {id: "b", text: "1 day, 2-3 days, 5-10 days, 10-20 days", isCorrect: true},
                        {id: "c", text: "Every day for a month", isCorrect: false},
                        {id: "d", text: "It doesn't matter", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q3",
                    type: "true-false",
                    question: "Interleaving is more effective than reviewing notes.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q4",
                    type: "multiple-choice",
                    question: "What does the 'M' in the SMART method stand for?",
                    options: [
                        {id: "a", text: "Mediocre", isCorrect: false},
                        {id: "b", text: "Measurable", isCorrect: true},
                        {id: "c", text: "Mathematical", isCorrect: false},
                        {id: "d", text: "Mindful", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q5",
                    type: "true-false",
                    question: "Interleaving involves studying different topics using different techniques, which increases thinking flexibility and retention.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q6",
                    type: "multiple-choice",
                    question: "How many principles do SMART goals consist of?",
                    options: [
                        {id: "a", text: "2", isCorrect: false},
                        {id: "b", text: "3", isCorrect: false},
                        {id: "c", text: "4", isCorrect: false},
                        {id: "d", text: "5", isCorrect: true}
                    ]
                },
                {
                    id: "v2w3q7",
                    type: "true-false",
                    question: "Sleep doesn't matter much for memory consolidation and learning.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
                {
                    id: "v2w3q8",
                    type: "true-false",
                    question: "AI can help generate test questions and create quizzes.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q9",
                    type: "multiple-choice",
                    question: "The forgetting curve shows that:",
                    options: [
                        {id: "a", text: "We forget the most in the first days after learning", isCorrect: true},
                        {id: "b", text: "We forget evenly over time", isCorrect: false},
                        {id: "c", text: "We don't forget anything if we focus", isCorrect: false},
                        {id: "d", text: "We only forget difficult things", isCorrect: false}
                    ]
                },
                {
                    id: "v2w3q10",
                    type: "multiple-choice",
                    question: "When should we stop learning new topics when preparing for a test?",
                    options: [
                        {id: "a", text: "During the last break before the test", isCorrect: false},
                        {id: "b", text: "Two days before", isCorrect: true},
                        {id: "c", text: "The last evening", isCorrect: false},
                        {id: "d", text: "It doesn't matter at all", isCorrect: false}
                    ]
                },
            ]
        }
    },
    {
        title: "Total Mastery",
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1147706005",
                description: "An organizational episode showing what exactly to expect from the fourth week. ",
            },
            {
                title: "Learning in class",
                vimeoUrl: "https://vimeo.com/1147706076",
                description: "In this lesson, you'll learn how to get the most out of classes at school. <br/><br/>" +
                    "We'll cover" +
                    "<ul>" +
                    "<li>What to pay attention to when learning at school.</li>" +
                    "<li>A 3-step process for getting 100% out of lessons.</li>" +
                    "</ul>" +
                    "If you make good use of time at school, studying at home will be much shorter and more enjoyable.",
            },
            {
                title: "Exam techniques",
                vimeoUrl: "https://vimeo.com/1147706422",
                description: "In this lesson, you'll learn proven techniques for preparing for exams and tests. <br/><br/>" +
                    "We'll cover:" +
                    "<ul>" +
                    "<li>A 5-step process for acing tests.</li>" +
                    "<li>How to overcome pre-test stress. (Cheat-sheet with 7 tips in the resources section)</li>" +
                    "</ul>",
                tasks: [
                    "I created my own pre-test checklist"
                ],
                resources: [
                    {
                        title: "Overcome test stress - 7 Tips (Cheat-sheet)",
                        link: "https://docs.google.com/document/d/1xacXncyKn3alT26SvB8Fah6PYh0pZ6n0TeH-xnrnW5Q/edit?usp=sharing"
                    },
                    {
                        title: "Steady pace and checking answers (Notes from the video)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E3+-+Techniki+egzaminacyjne+notatki.png"
                    },
                    {
                        title: "Exam techniques - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E3-Techniki+Cheat-Sheet.pdf"
                    }
                ]
            },
            {
                title: "Effective notes",
                vimeoUrl: "https://vimeo.com/1147706907",
                description: "In this lesson, we'll cover the topic of effective notes and discuss what to pay attention to when taking notes. <br/><br/>In the next week, we'll cover mind maps, where we'll take it to the next level.",
            },
            {
                title: "Flashcards",
                vimeoUrl: "https://vimeo.com/1147707037",
                description: "In this lesson, you'll learn how to effectively use flashcards for studying. <br/><br/>" +
                    "We'll cover:" +
                    "<ul>" +
                    "<li>What flashcards are and why they are effective.</li>" +
                    "<li>When flashcards work best.</li>" +
                    "<li>How to create effective flashcards.</li>" +
                    "</ul>" +
                    "In the resources section, you'll find our custom tool - Flashcards on Produkacja",
                resources: [
                    {
                        title: "Flashcards on Produkacja",
                        link: "/produkt/fiszki"
                    }
                ]
            },
            {
                title: "Breaks",
                vimeoUrl: "https://vimeo.com/1147707348",
                description: "In this lesson, we'll cover the topic of breaks. <br/><br/>" +
                    "We'll cover:" +
                    "<ul>" +
                    "<li>How often to take breaks.</li>" +
                    "<li>What's best to do during breaks.</li>" +
                    "</ul>",
            },
            {
                title: "Pre-study routine",
                vimeoUrl: "",
                tasks: [
                    "I thought about my pre-study routine."
                ],
                description: "To get our brain to automatically enter a state of concentration, it works great to always do the same activity before each study session. <br/><br/>" +
                    "It can be, for example, always listening to the same song or always making the same tea. There are many possibilities, but it's good if it doesn't take more than 5 minutes. <br/><br/>" +
                    "Thanks to this, your brain will start associating that specific activity with the need to focus. Developing such a response takes a few weeks, but after that time you'll see that it's even easier to enter a \"study mode\".<br/><br/>" +
                    "This pattern can also be applied to tests / exams. That is, every time before a test, we do the same activity. <br/><br/>" +
                    "Experiment and see how it works for you!",
            },
            {
                title: "Learning order",
                vimeoUrl: "https://vimeo.com/1147703262",
                description: "In this lesson, we'll cover the topic of learning order. <br/><br/>" +
                    "We'll cover:" +
                    "<ul>" +
                    "<li>Does the order of learning matter?</li>" +
                    "<li>In what order should we study?</li>" +
                    "</ul>",
            },
            {
                title: "Dealing with stress",
                vimeoUrl: "https://vimeo.com/1147707565",
                description: "In this lesson, you'll learn how to deal with stress. <br/><br/>" +
                    "We'll cover the following topics:" +
                    "<ul>" +
                    "<li>Stress response</li>" +
                    "<li>Effects of chronic stress</li>" +
                    "<li>Stress and learning</li>" +
                    "<li>Momentary stress - how to react?</li>" +
                    "<li>Chronic stress - how to address it?</li>" +
                    "</ul>" +
                    "In the resources section, you'll find two recordings of breathing techniques. <br/><br/>" +
                    "<b>First recording: Box Breathing</b><br/>" +
                    "Inhale 4s<br/>" +
                    "Hold 4s<br/>" +
                    "Exhale 4s<br/><br/>" +
                    "Regulates breathing and heart rate, reduces stress, supports concentration. <br/><br/><hr/><br/>" +
                    "<b>Second recording: Alternate Nostril Breathing</b><br/>" +
                    "Close the right nostril with the right thumb, inhale through the left.<br/>" +
                    "Close the left with the ring finger, exhale through the right.<br/><br/>" +
                    "Reduces stress, calms the nervous system, balances brain hemisphere activity, improves concentration.",
                tasks: [
                    "I tried at least one of the breathing techniques"
                ],
                resources: [
                    {
                        title: "Box breathing",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/techniki-oddechowe/Oddech+pude%C5%82kowy.WAV"
                    },
                    {
                        title: "Alternate nostril breathing",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/materialy/techniki-oddechowe/Oddech+naprzemienny.WAV"
                    }
                ],
            },
            {
                title: "Achieving goals step by step",
                vimeoUrl: "https://vimeo.com/1147703420",
                description: "In this lesson, you'll learn a protocol for effectively achieving any goal. <br/><br/>",
                resources: [
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E9-protoko%CC%81%C5%82+skutecznej+realizacji+dowolnego+celu.pdf",
                        title: "Goal achievement protocol step by step - Cheat-Sheet"
                    },
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W4E9+-+konsekwentne+dzia%C5%82anie+cheat-sheet.pdf",
                        title: "Consistent action - Cheat-Sheet"
                    }
                ]
            },
        ],
        quiz: {
            title: "Quiz - Total Mastery",
            passingScore: 70,
            questions: [
                {
                    id: "v2w4q1",
                    type: "multiple-choice",
                    question: "How long should Prestudy (Pre-class learning) take?",
                    options: [
                        {id: "a", text: "What's that?", isCorrect: false},
                        {id: "b", text: "5-15min", isCorrect: true},
                        {id: "c", text: "30-60min", isCorrect: false},
                        {id: "d", text: "The more the better", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q2",
                    type: "multiple-choice",
                    question: "What should you do at home after school lessons?",
                    options: [
                        {id: "a", text: "Immediately forget about the material", isCorrect: false},
                        {id: "b", text: "Spend a few minutes reviewing the material", isCorrect: true},
                        {id: "c", text: "Play games as much as possible", isCorrect: false},
                        {id: "d", text: "Nothing - listening at school is enough", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q3",
                    type: "true-false",
                    question: "Flashcards are one of the most effective tools for memorization.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q4",
                    type: "multiple-choice",
                    question: "In what order should we study?",
                    options: [
                        {id: "a", text: "As it is in the textbook.", isCorrect: false},
                        {id: "b", text: "Always from the hardest to the easiest topics.", isCorrect: false},
                        {id: "c", text: "Always from the easiest to the hardest topics.", isCorrect: false},
                        {id: "d", text: "In whatever order makes the most sense for us.", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q5",
                    type: "multiple-choice",
                    question: "What FASTEST helps regain control during momentary stress?",
                    options: [
                        {id: "a", text: "Scrolling on phone", isCorrect: false},
                        {id: "b", text: "Extending the exhale", isCorrect: true},
                        {id: "c", text: "Thinking \"what if...\"", isCorrect: false},
                        {id: "d", text: "Judging yourself", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q6",
                    type: "true-false",
                    question: "Breaks decrease productivity and should be avoided.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q7",
                    type: "multiple-choice",
                    question: "What is important when taking notes?",
                    options: [
                        {id: "a", text: "Copying everything word for word", isCorrect: false},
                        {
                            id: "b",
                            text: "Writing in your own words, adding visual elements, and highlighting the most important information",
                            isCorrect: true
                        },
                        {id: "c", text: "Taking notes only when the teacher says to", isCorrect: false},
                        {id: "d", text: "Using only colored markers", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q8",
                    type: "true-false",
                    question: "A pre-study routine helps enter a state of concentration faster.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w4q9",
                    type: "multiple-choice",
                    question: "Which technique does NOT help with dealing with stress?",
                    options: [
                        {id: "a", text: "Breathing techniques", isCorrect: false},
                        {id: "b", text: "Meditation", isCorrect: false},
                        {id: "c", text: "Physical activity", isCorrect: false},
                        {id: "d", text: "Ignoring stress and feelings", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q10",
                    type: "true-false",
                    question: "Stress is always something bad and should be avoided.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
                {
                    id: "v2w4q11",
                    type: "true-false",
                    question: "Scrolling social media supports nervous system recovery.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
            ]
        }
    },
    {
        title: "Effective Learning 2.0",
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1150853754",
                description: "An organizational episode showing what exactly to expect from the fifth week.",
            },
            {
                title: "When do we memorize best?",
                vimeoUrl: "https://vimeo.com/1150853787",
                description: "In this lesson, you'll learn when we memorize best. <br/><br/>" +
                    "We'll cover:" +
                    "<ul>" +
                    "<li>What our brain remembers best.</li>" +
                    "<li>How to use this to our advantage in the context of effective learning.</li>" +
                    "</ul>",
            },
            {
                title: "Inquiry-based learning",
                vimeoUrl: "https://vimeo.com/1150853838",
                description: "In this lesson, we'll cover the topic of inquiry-based learning. <br/><br/>" +
                    "We'll discuss:" +
                    "<ul>" +
                    "<li>What <i>Inquiry-based learning</i> actually is.</li>" +
                    "<li>How to apply it in practice.</li>" +
                    "</ul>",
                resources: [
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E3-Nauka-poprzez-dociekanie-cheat-sheet.pdf",
                        title: "Inquiry-based learning: Cheat-sheet"
                    }
                ]
            },
            {
                title: "Mind maps",
                vimeoUrl: "https://vimeo.com/1150853908",
                description: "In this video, we'll cover the topic of mind maps and discuss:" +
                    "<ul>" +
                    "<li>Why mind maps are important.</li>" +
                    "<li>How to create effective mind maps and what to pay attention to.</li>" +
                    "<li>Examples of mind maps.</li>" +
                    "</ul>" +
                    "This is the longest lesson in the entire Course.",
                attachFiles: true,
                tasks: [
                    "I practiced making mind maps in practice, e.g., while studying for a test."
                ],
                resources: [
                    {
                        link: "https://tablicanakorki.pl/t/35QEaaSqoduMIwImgRYULBfkilm",
                        title: "Mind map examples from the video"
                    },
                    {
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E4-Jak-tworzyc-mapy-mysli.pdf",
                        title: "How to create mind maps - Cheat-Sheet"
                    }
                ]
            },
            {
                title: "Studying for STEM subjects",
                vimeoUrl: "https://vimeo.com/1150855393",
                description: "In this video, we'll cover effective studying for STEM subjects and discuss how to do it efficiently.",
                resources: [
                    {
                        title: "Example from the video",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E5-Przyklad-z-filmu.png"
                    }
                ]
            },
            {
                title: "Flow state",
                vimeoUrl: "https://vimeo.com/1150855463",
                description: "In this video, we'll cover the topic of flow state and discuss:" +
                    "<ul>" +
                    "<li>What flow state is and why it matters.</li>" +
                    "<li>How to enter flow state.</li>" +
                    "</ul>",
            },
            {
                title: "A month in one day",
                vimeoUrl: "https://vimeo.com/1150855560",
                description: "In this video, we'll discuss how to catch up on or learn a huge amount of material in one day, and show an example schedule for such a day.",
                resources: [
                    {
                        title: "What to pay attention to before - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E7-Na-co-zwracac-uwage-przed.pdf"
                    },
                    {
                        title: "Example schedule",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E7-Przykladowy-harmonogram.pdf"
                    }
                ]
            },
            {
                title: "Brain Dump",
                vimeoUrl: "",
                description: "Your task is to write down everything you've learned so far. Imagine you have an exam on the Course material coming up and you need to prepare for it. This will help you solidify all the knowledge you've gained here :). <br/><br/>" +
                    "You can use the notes section for this or attach your own file.",
                showNotes: true,
                attachFiles: true,
                tasks: [
                    "I wrote down everything I've learned so far."
                ]
            },
            {
                title: "Learning topic summary",
                vimeoUrl: "https://vimeo.com/1150855627",
                description: "In this lesson, we'll summarize the topic of learning and discuss: <br/><br/>" +
                    "<ul>" +
                    "<li>How to combine everything we've learned and apply it in practice.</li>" +
                    "<li>How to act and what to pay attention to.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Actions at school - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E9-Dzialanie-w-szkole.pdf"
                    },
                    {
                        title: "Actions at home - Cheat-Sheet",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W5E9-Dzialanie-w-domu.pdf"
                    },
                ]
            }
        ],
        quiz: {
            title: "Quiz - Effective Learning 2.0",
            passingScore: 70,
            questions: [
                {
                    id: "v2w5q1",
                    type: "multiple-choice",
                    question: "When does our brain memorize information best?",
                    options: [
                        {id: "a", text: "When something really interests us", isCorrect: true},
                        {id: "b", text: "When we have little to study", isCorrect: false},
                        {id: "c", text: "Only at school", isCorrect: false},
                        {id: "d", text: "When mom tells us to study", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q2",
                    type: "true-false",
                    question: "Inquiry-based learning involves creating questions that interest us and then answering them.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q3",
                    type: "multiple-choice",
                    question: "What is one of the main reasons why mind maps are important?",
                    options: [
                        {id: "a", text: "They help write longer notes", isCorrect: false},
                        {id: "b", text: "They make memorization harder but organize knowledge", isCorrect: false},
                        {id: "c", text: "They clearly show connections between topics", isCorrect: true},
                        {id: "d", text: "They replace learning and understanding the topic", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q4",
                    type: "multiple-choice",
                    question: "Where should you start when creating a mind map?",
                    options: [
                        {id: "a", text: "From details and examples", isCorrect: false},
                        {id: "b", text: "From the general, moving to specifics", isCorrect: true},
                        {id: "c", text: "From definitions and formulas", isCorrect: false},
                        {id: "d", text: "From writing full sentences", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q5",
                    type: "fill",
                    question: "The ___ state is full engagement in a task during which we lose track of time.",
                    correctAnswer: "flow"
                },
                {
                    id: "v2w5q6",
                    type: "multiple-choice",
                    question: "How many connections between topics should a mind map have according to the principles from the presentation?",
                    options: [
                        {id: "a", text: "1-2", isCorrect: false},
                        {id: "b", text: "2-4", isCorrect: true},
                        {id: "c", text: "5-8", isCorrect: false},
                        {id: "d", text: "As many as possible", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q7",
                    type: "true-false",
                    question: "Effective studying means jumping straight to solving random problems without understanding the topic first.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
                {
                    id: "v2w5q8",
                    type: "multiple-choice",
                    question: "What question is worth asking yourself when learning new definitions/formulas/concepts?",
                    options: [
                        {id: "a", text: "Will this be on the test?", isCorrect: false},
                        {id: "b", text: "What does this look like in theory?", isCorrect: false},
                        {id: "c", text: "How can I use this in practice?", isCorrect: true},
                        {id: "d", text: "Can I copy this from my notebook?", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q9",
                    type: "true-false",
                    question: "Emotions strengthen the memorization of information.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w5q10",
                    type: "multiple-choice",
                    question: "What helps achieve flow state?",
                    options: [
                        {id: "a", text: "Multitasking", isCorrect: false},
                        {id: "b", text: "Eliminating distractions and having a clear goal", isCorrect: true},
                        {id: "c", text: "Very easy tasks", isCorrect: false},
                        {id: "d", text: "Turning on all notifications to stay up to date", isCorrect: false}
                    ]
                }
            ]
        }
    },
    {
        title: "Next Level",
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1152167078",
                description: "An organizational episode showing what exactly to expect from the fifth week."
            },
            {
                title: "Win every day",
                vimeoUrl: "https://vimeo.com/1152167135",
                description: "In this video, we'll cover the topic of journaling and discuss:<br/>" +
                    "<ul>" +
                    "<li>Why keeping a journal is important.</li>" +
                    "<li>How to keep a journal.</li>" +
                    "<li>Comparison between journaling and Kolb's Cycle.</li>" +
                    "<li>What to pay attention to.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Example structured format",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W6E2-Przykladowa-forma-ustrukturyzowana-dziennik.pdf"
                    }
                ],
                tasks: [
                    "I decided how I want to keep my journal."
                ]
            },
            {
                title: "Be yourself",
                vimeoUrl: "https://vimeo.com/1152168021",
                description: "In this video, we'll cover the topic of authenticity and discuss:<br/>" +
                    "<ul>" +
                    "<li>What authenticity is and why acting in alignment with yourself matters.</li>" +
                    "<li>Examples of people with high and low authenticity.</li>" +
                    "<li>How to achieve authenticity.</li>" +
                    "</ul>",
            },
            {
                title: "You become who you surround yourself with",
                vimeoUrl: "https://vimeo.com/1152168472",
                description: "In this lesson, you'll learn about the influence of your surroundings on your growth and life. <br/><br/>" +
                    "Key takeaways:" +
                    "<ul>" +
                    "<li>We are the average of the 5 people we spend the most time with</li>" +
                    "<li>Our environment affects our habits, beliefs, and goals</li>" +
                    "<li>It's important to consciously build your environment</li>" +
                    "<li>You don't have to give up old friends, but build new relationships with inspiring people</li>" +
                    "</ul>"
            },
            {
                title: "Self-image",
                vimeoUrl: "https://vimeo.com/1152170990",
                description: "In this video, we'll cover the topic of self-image and discuss:<br/>" +
                    "<ul>" +
                    "<li>How the way you see yourself affects your reality.</li>" +
                    "<li>The importance of self-esteem and belief in your abilities.</li>" +
                    "<li>How to effectively work on your self-esteem.</li>" +
                    "</ul>",
            },
            {
                title: "The role of beliefs",
                vimeoUrl: "https://vimeo.com/1152171228",
                description: "In this video, we'll cover the topic of beliefs and discuss:<br/>" +
                    "<ul>" +
                    "<li>What beliefs are and why they matter.</li>" +
                    "<li>How to work on your beliefs.</li>" +
                    "<li>How the beliefs of people close to you affect you.</li>" +
                    "<li>An example of beliefs in the context of New Year's resolutions.</li>" +
                    "<li>How to effectively change your \"state\".</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Affirmations Cheat-Sheet",
                        link: "https://docs.google.com/document/d/1b4nw4a8wLAehG8wV8EcX00AbV3cqsDwZ4Gye_8fmFog/edit?usp=sharing"
                    },
                    {
                        title: "Changing state - Example from the video",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W6E6-Zmiana-stanu-nauka.pdf"
                    }
                ],
                tasks: [
                    "I identified beliefs I want to change - and I'm starting to implement changes."
                ]
            },
            {
                title: "Think like a winner",
                vimeoUrl: "https://vimeo.com/1152169983",
                description: "In this video, we'll cover our way of thinking and discuss:<br/>" +
                    "<ul>" +
                    "<li>How the best think.</li>" +
                    "<li>How to use this to your advantage.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Think like a winner - Exercise from the video",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W6E7-Mysl-jak-zwyciezca-cwiczenie.pdf"
                    }
                ],
                tasks: [
                    "I completed the exercise from the video at least once."
                ]
            },
            {
                title: "Course Summary",
                vimeoUrl: "https://vimeo.com/1152170178",
                description: "Congratulations! <br/><br/>" +
                    "Thank you for this journey together and I wish you the best of luck! You already have everything you need to become the best version of yourself."
            },
            {
                title: "What's next?",
                vimeoUrl: "",
                description: "Congratulations once again on completing the entire Course! 🔥🎉<br/> <i>(psst... there's also a bonus week)</i><br/><br/>" +
                    "Next steps:" +
                    "<ul>" +
                    "<li>Continue the habits you've built.</li>" +
                    "<li>Come back to the Course materials when you feel you need them.</li>" +
                    "<li>Make new connections in the Discord community.</li>" +
                    "<li>If any questions come up, feel free to participate in the weekly online meetings.</li>" +
                    "<li>Share your progress.</li>" +
                    "<li>Help others - by teaching others, you learn yourself</li>" +
                    "</ul>" +
                    "<br/><b>Remember: This is not the end, it's just the beginning!</b>",
            },
            {
                title: "Unlock the bonus week!",
                vimeoUrl: "",
                description: "We have a surprise for you - <b>Bonus Week!</b><br/><br/>" +
                    "To unlock access to additional materials, share your opinion about the course with us. " +
                    "Your review will help us improve the course, and it will give you access to exclusive bonus lessons!<br/><br/>" +
                    "<b>What you need to do:</b><br/>" +
                    "<ol>" +
                    "<li>Rate the course (1-5 stars)</li>" +
                    "<li>Write your opinion about the Course (minimum 250 characters)</li>" +
                    "<li>Click 'Unlock bonus week'</li>" +
                    "</ol>",
                showTestimonialForm: true
            }
        ],
        quiz: {
            title: "Quiz - Next Level",
            passingScore: 70,
            questions: [
                {
                    id: "v2w6q1",
                    type: "multiple-choice",
                    question: "What is journaling about?",
                    options: [
                        {id: "a", text: "Reading self-development books", isCorrect: false},
                        {id: "b", text: "Writing down thoughts, feelings, plans, and experiences", isCorrect: true},
                        {id: "c", text: "Memorizing notes by heart", isCorrect: false},
                        {id: "d", text: "Planning only sports goals", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q2",
                    type: "multiple-choice",
                    question: "What are the benefits of keeping a journal?",
                    options: [
                        {id: "a", text: "Only tracking progress", isCorrect: false},
                        {
                            id: "b",
                            text: "Building awareness, processing emotions, tracking progress, and developing gratitude",
                            isCorrect: true
                        },
                        {id: "c", text: "Only writing about problems", isCorrect: false},
                        {id: "d", text: "There are no benefits", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q3",
                    type: "multiple-choice",
                    question: "What is the easiest way to develop the habit of writing in a journal?",
                    options: [
                        {id: "a", text: "Start with very long entries", isCorrect: false},
                        {id: "b", text: "Write only when you're in a bad mood", isCorrect: false},
                        {id: "c", text: "Avoid a fixed routine", isCorrect: false},
                        {
                            id: "d",
                            text: "Start with structured notes (e.g., morning and evening)",
                            isCorrect: true
                        }
                    ]
                },
                {
                    id: "v2w6q4",
                    type: "multiple-choice",
                    question: "What is authenticity?",
                    options: [
                        {id: "a", text: "Always being nice to others", isCorrect: false},
                        {id: "b", text: "Doing what the majority does", isCorrect: false},
                        {
                            id: "c",
                            text: "Harmony between values, beliefs, emotions, and actions",
                            isCorrect: true
                        },
                        {id: "d", text: "Always achieving success", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q5",
                    type: "true-false",
                    question: "Beliefs are always objective and true.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
                {
                    id: "v2w6q6",
                    type: "multiple-choice",
                    question: "What does your environment influence?",
                    options: [
                        {id: "a", text: "Only academic results", isCorrect: false},
                        {id: "b", text: "Values, motivation, habits, and emotions", isCorrect: true},
                        {id: "c", text: "Only interests", isCorrect: false},
                        {id: "d", text: "Only physical abilities", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q7",
                    type: "true-false",
                    question: "High self-esteem means you don't make mistakes and don't experience failure.",
                    options: [
                        {id: "true", text: "True", isCorrect: false},
                        {id: "false", text: "False", isCorrect: true}
                    ]
                },
                {
                    id: "v2w6q8",
                    type: "multiple-choice",
                    question: "What behavior is characteristic of low self-esteem?",
                    options: [
                        {id: "a", text: "Avoiding challenges and a critical inner voice", isCorrect: true},
                        {id: "b", text: "Openness to challenges and acceptance of failures", isCorrect: false},
                        {id: "c", text: "Confidence in actions and emotional stability", isCorrect: false},
                        {id: "d", text: "Ability to take risks without stress", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q9",
                    type: "true-false",
                    question: "Beliefs act as filters through which you perceive the world.",
                    options: [
                        {id: "true", text: "True", isCorrect: true},
                        {id: "false", text: "False", isCorrect: false}
                    ]
                },
                {
                    id: "v2w6q10",
                    type: "multiple-choice",
                    question: "Beliefs are:",
                    options: [
                        {id: "a", text: "Facts about the world", isCorrect: false},
                        {id: "b", text: "Momentary emotions", isCorrect: false},
                        {id: "c", text: "Goals and plans for the future", isCorrect: false},
                        {
                            id: "d",
                            text: "Deeply rooted opinions and convictions about yourself, the world, and others",
                            isCorrect: true
                        }
                    ]
                }
            ]
        }
    },
    // Bonus week - only visible after bonusWeekUnlocked
    {
        title: "Bonus Week",
        isBonus: true,
        episodes: [
            {
                title: "Week overview",
                vimeoUrl: "https://vimeo.com/1153905904",
                description: "Congratulations! The bonus week has been unlocked!<br/><br/>" +
                    "In this video, I'll show you what to expect and what you'll learn :)",
                showNotes: true
            },
            {
                title: "The role of sleep",
                vimeoUrl: "https://vimeo.com/1153905612",
                description: "In this video, we'll look at the topic of sleep and discuss:<br/>" +
                    "<ul>" +
                    "<li>Why sleep is important.</li>" +
                    "<li>Ways to optimize sleep and improve its quality.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Ways to optimize sleep (Cheat-Sheet)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W7E2-Sposoby-na-optymalizacje-snu.pdf"

                    }
                ],
                showNotes: true
            },
            {
                title: "The role of nutrition",
                vimeoUrl: "https://vimeo.com/1153905825",
                description: "In this video, we'll look at the topic of nutrition and discuss:<br/>" +
                    "<ul>" +
                    "<li>How food affects you.</li>" +
                    "<li>What to pay attention to.</li>" +
                    "</ul>" +
                    "Our main goal is to build awareness.",
                showNotes: true
            },
            {
                title: "The role of exercise",
                vimeoUrl: "https://vimeo.com/1153906114",
                description: "In this video, we'll look at the topic of exercise and discuss:<br/>" +
                    "<ul>" +
                    "<li>Why exercising is important.</li>" +
                    "<li>Debunking misconceptions about exercise.</li>" +
                    "<li>How to incorporate exercise into your routine.</li>" +
                    "<li>What to pay attention to.</li>" +
                    "</ul>",
                showNotes: true
            },
            {
                title: "The role of rest",
                vimeoUrl: "https://vimeo.com/1153905943",
                description: "In this video, we'll look at the topic of rest and discuss:<br/>" +
                    "<ul>" +
                    "<li>Why rest is important.</li>" +
                    "<li>Differences between \"active\" and \"passive\" rest.</li>" +
                    "<li>How to rest actively.</li>" +
                    "<li>How to incorporate rest into your daily routine.</li>" +
                    "</ul>" +
                    "Finding it hard to rest? Remember that rest is not a luxury, it's a <b>necessity</b>.",
                showNotes: true
            },
            {
                title: "Additional materials",
                vimeoUrl: "",
                description: "If you want to continue developing your Effective Action skills, below you'll find several useful tools.<br/><br/>" +
                    "<ol>" +
                    "<li><a href='https://www.youtube.com/@produkacja' class='text-success text-decoration-underline'>YouTube channel</a>, where we share action-related materials every week.</li> <br/>" +
                    "<li><a href='https://www.youtube.com/@riandoris/videos' class='text-success text-decoration-underline'>YouTube channel</a> covering topics related to high performance</li> <br/>" +
                    "<li><a href='https://www.scotthyoung.com/blog/ultralearning/' class='text-success text-decoration-underline'>The book <i>\"Ultralearning\"</i></a> going into even greater detail on effective learning. </li> <br/>" +
                    "<li><a href='https://www.brain.fm/produkacja' class='text-success text-decoration-underline'>The app <i>\"Brain.FM\"</i></a>, which helps with focus and effective learning. </li>" +
                    "</ol>" +
                    "<br/>We'll be expanding this resource base over time :)"
            },
            {
                title: "Thank you",
                vimeoUrl: "",
                description: "Congratulations! The bonus week has been completed.<br/><br/>" +
                    "Thank you for your review of the course and we wish you the best in your continued learning!"
            }
        ]
    }
] as LearningCourseWeek[]

// Quiz types
export type QuizQuestionType = 'multiple-choice' | 'true-false' | 'fill';

export interface QuizOption {
    id: string;
    text: string;
    isCorrect: boolean;
}

export interface QuizQuestion {
    id: string;
    type: QuizQuestionType;
    question: string;
    options?: QuizOption[]; // For multiple-choice and true-false
    correctAnswer?: string; // For fill questions
}

export interface Quiz {
    title: string;
    passingScore: number; // e.g., 70 for 70%
    questions: QuizQuestion[];
}

export interface QuizAnswer {
    questionId: string;
    questionText: string;
    answerId?: string | string[]; // For multiple-choice/true-false
    answerText: string | string[]; // Full answer text
    isCorrect: boolean;
}

export interface QuizAttempt {
    week: number;
    attemptNumber: number;
    answers: QuizAnswer[];
    score: number; // Percentage
    passed: boolean; // >= passingScore
    completedAt: string; // ISO timestamp
}

export interface LearningCourseWeek {
    title: string
    episodes: LearningCourseEpisode[]
    quiz?: Quiz // Optional quiz at end of week
    isBonus?: boolean // If true, this week is only visible after bonusWeekUnlocked
}

export interface LearningCourseEpisode {
    title: string
    description: string
    vimeoUrl: string
    resources?: Resource[]
    showNotes?: boolean
    attachFiles?: boolean // If true, show file upload section
    tasks?: string[] // Array of task descriptions for checkbox tasks
    showTestimonialForm?: boolean // If true, show testimonial form to unlock bonus week
}

export interface Resource {
    title: string
    link: string
}

export interface LastWatchedEpisode {
    w: number,
    e: number,
}

export interface CourseStatistics {
    totalWatchTimeInSeconds: number
    boughtAt: string // Date in ISO
    lastWatched: LastWatchedEpisode
    episodesCompleted: number
    name: string
    email: string
    maxIndividualSessionsNum: number,
    individualSessionsScheduledNum: number
    individualSessionUrl: string,
    weeksUnlocked: number
    unlockNextWeek: UnlockNextWeekSchedule
    discordId?: string,
    completedMandatoryFeedbackForm?: boolean
    completedEndCourseFeedbackForm?: boolean
    nextKedSession?: string
    // Gamification fields
    courseXP?: number
    currentStreak?: number
    longestStreak?: number
    lastStreakDate?: string
    activityDates?: string[]
    streakFreezeTokens?: number
    achievements?: string[]
    bonusWeekUnlocked?: boolean // True if user has unlocked the bonus week by submitting testimonial
}

interface UnlockNextWeekSchedule {
    week: number,
    unlockingAt: string
}

export interface CourseWeek {
    week: number
    isUnlocked: boolean
    episodesCompleted: number
    quizAttempts?: number
    quizBestScore?: number
    quizPassed?: boolean
}

export interface CourseEpisode {
    week: number
    episode: number
    isUnlocked: boolean
    watchTimeInSeconds: number
    currentWatchTime: number
    completed: boolean
    notes?: string
    uploadedFiles?: string[] // S3 keys for user-uploaded files
    uploadedLinks?: Array<{
        name: string;
        url: string;
        addedAt: number;
    }>
    completedTasks?: boolean[] // Array of task completion states
}

export interface CourseWeekAndEpisodes {
    week: CourseWeek
    episodes: CourseEpisode[]
    weeksUnlocked: number
}

export interface UpdateCourseWatchTimeRequest {
    week: number
    episode: number
    currentWatchTime: number
    increaseWatchTime: number
    course: AvailableCourses
}

export interface UpdateEpisodeNotes {
    week: number
    episode: number
    notes: string
    course: AvailableCourses
}

export interface CompleteEpisodeRequest {
    week: number
    episode: number
    completed: boolean
    course: AvailableCourses
}

export interface DiscordIdResponse {
    message: string
}

export interface GamificationUpdateResult {
    xpAwarded: number;
    newTotalXP: number;
    newStreak: number;
    longestStreak: number;
    newAchievements: string[];
    streakBonusAwarded: number;
}

// ===== Activity Feed & Leaderboard Types =====

export type ActivityEventType =
    | 'ACHIEVEMENT_EARNED'
    | 'QUIZ_PERFECT'
    | 'STREAK_MILESTONE'
    | 'WEEK_COMPLETED';

export interface CourseActivityEvent {
    id: string;
    courseName: string;
    eventType: ActivityEventType;
    userId: string;
    userName: string;
    eventData: {
        achievementId?: string;
        achievementName?: string;
        achievementIcon?: string;
        achievementImageUrl?: string;
        quizScore?: number;
        streakDays?: number;
        weekNumber?: number;
        xpGained?: number;
    };
    createdAt: string;
}

export interface ActivityFeedResponse {
    events: CourseActivityEvent[];
    nextPageKey?: string;
    hasMore: boolean;
}

export const spcCourseStructure = [
    {
        title: "System Planowania Czasu",
        episodes: [
            {
                title: "Wypełnienie cheat-sheetów",
                vimeoUrl: "https://vimeo.com/1176634318",
                description: "W tej lekcji zobaczysz przykładowe wypełnienie cheat-sheetu <i>\"Planowanie made easy\"</i>, który będzie Ci towarzyszył przy najbliższych sprawdzianach.",
                resources: [
                    {
                        title: "Cheat-Sheet: Planowanie made easy",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/materialy/system-planowania-czasu/Planowanie+-+Cheat-Sheet.pdf"
                    },
                    {
                        title: "Przykład wypełnienie (z filmu)",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/system-planowania-czasu/planowanie-made-easy-wypelnienie.png"
                    }
                ]
            },
            {
                title: "Twój Plan Dominacji",
                vimeoUrl: "https://vimeo.com/1176573301",
                description: "W tej lekcji dowiesz się, jak korzystać z Planu Dominacji - Twojego osobistego narzędzia do planowania swojego czasu.<br/><br/>" +
                    "Został on zintegrowany z Produkacja OS i jest dla Ciebie w 100% bezpłatny na zawsze. <br/><br/>" +
                    "<b>Zadanie:</b> Zapisz swój plan na najbliższe dni/tygodnie.",
                resources: [
                    {
                        title: "Plan Dominacji",
                        link: "/produkt/plan-dominacji"
                    }
                ]
            },
            {
                title: "Odzyskiwanie",
                vimeoUrl: "https://vimeo.com/1176573508",
                description: "W tym filmie zajmiemy się tematem odzyskiwania i omówimy sobie: <br/><br/>" +
                    "<ul>" +
                    "<li>Dlaczego odzyskiwanie jest istotne.</li>" +
                    "<li>Dwie zasady dotyczące skutecznego odzyskiwania.</li>" +
                    "<li>Istotna snu w kontekście odzyskiwania.</li>" +
                    "<li>Optymalny sposób planowania nauki przed sprawdzianami.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Istota snu - Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E4-Istota+snu.png"
                    },
                    {
                        title: "Przykładowy plan nauki przed sprawdzianem - Notatki z filmu",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E4-Przyk%C5%82adowy+plan+nauki+przed+sprawdzianem.png"
                    }
                ]
            },
            {
                title: "Cele SMART",
                vimeoUrl: "https://vimeo.com/1176573783",
                description: "W tym filmie przyjrzymy się tematowi planowania \"SMART\". <br/><br/>" +
                    "Omówimy następujące zagadanienia:" +
                    "<ul>" +
                    "<li>Na czym polega planowanie \"SMART\".</li>" +
                    "<li>Przykłady celów \"SMART\" i celów nie-\"SMART\".</li>" +
                    "<li>Jak skutecznie stawiać cele \"SMART\".</li>" +
                    "<li>Bonus: Łączenie tego z Planem Dominacji.</li>" +
                    "</ul>",
                resources: [
                    {
                        title: "Cele \"SMART\" - Ściąga",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E7-Cele+SMART.pdf"
                    },
                    {
                        title: "Pytania pomocnicze do tworzenia celów \"SMART\"",
                        link: "https://produkacja.s3.eu-central-1.amazonaws.com/web/kurs-efektywnego-dzialania/v2/materialy/W3E7-Pytania+do+celo%CC%81w+SMART.pdf"
                    }
                ],
            },
            {
                title: "Priorytety",
                vimeoUrl: "https://vimeo.com/1176574154",
                description: "W tej lekcji zagłębimy się w temat określania priorytetów.<br/><br/>" +
                    "Omówimy sobie dokładnie Matrycę Eisenhowera, na podstawie której określimy zadania w kategoriach WAŻNE / PILNE oraz pokażemy, na co zwrócić uwagę podczas planowania.",
            },
            {
                title: "Gratulacje! Co dalej?",
                vimeoUrl: "https://vimeo.com/1176634063",
                description: "Gratulacje! Udało Ci się przejść przez cały System Planowania Czasu 🔥<br/><br/>" +
                    "Jeżeli chcesz pójść krok dalej i wejść na następny poziom, zapraszam Cię do Kursu Efektywnego Działania 2.0 - szczegóły znajdziesz w sekcji z materiałami.",
                resources: [
                    {
                        title: "Dla uczniów: Prezentacja Kursu Efektywnego Działania",
                        link: "https://produkacja.pl/polecenie/kurs-efektywnego-dzialania/uczen?ref=JM6RC2"
                    },
                    {
                        title: "Dla rodziców: Prezentacja Kursu Efektywnego Działania",
                        link: "https://produkacja.pl/polecenie/kurs-efektywnego-dzialania?ref=JM6RC2"
                    }
                ],
            },
        ]
    }
] as LearningCourseWeek[]

export interface CourseRankingEntry {
    rank: number;
    userId: string;
    userName: string;
    avatar?: string;
    courseXP: number;
    currentStreak?: number;
    achievementCount?: number;
    isCurrentUser?: boolean;
}

export interface CourseLeaderboardResponse {
    rankings: CourseRankingEntry[];
    totalUsers: number;
    userRank?: number;
    userXP?: number;
}
